import * as I from '@mdi/js';

// https://textedit.tools/kebabcase
export const icon = {
  'ab-testing': I.mdiAbTesting,
  abacus: I.mdiAbacus,
  'abjad-arabic': I.mdiAbjadArabic,
  'abjad-hebrew': I.mdiAbjadHebrew,
  'abugida-devanagari': I.mdiAbugidaDevanagari,
  'abugida-thai': I.mdiAbugidaThai,
  'access-point': I.mdiAccessPoint,
  'access-point-check': I.mdiAccessPointCheck,
  'access-point-minus': I.mdiAccessPointMinus,
  'access-point-network': I.mdiAccessPointNetwork,
  'access-point-network-off': I.mdiAccessPointNetworkOff,
  'access-point-off': I.mdiAccessPointOff,
  'access-point-plus': I.mdiAccessPointPlus,
  'access-point-remove': I.mdiAccessPointRemove,
  account: I.mdiAccount,
  'account-alert': I.mdiAccountAlert,
  'account-alert-outline': I.mdiAccountAlertOutline,
  'account-arrow-down': I.mdiAccountArrowDown,
  'account-arrow-down-outline': I.mdiAccountArrowDownOutline,
  'account-arrow-left': I.mdiAccountArrowLeft,
  'account-arrow-left-outline': I.mdiAccountArrowLeftOutline,
  'account-arrow-right': I.mdiAccountArrowRight,
  'account-arrow-right-outline': I.mdiAccountArrowRightOutline,
  'account-arrow-up': I.mdiAccountArrowUp,
  'account-arrow-up-outline': I.mdiAccountArrowUpOutline,
  'account-badge': I.mdiAccountBadge,
  'account-badge-outline': I.mdiAccountBadgeOutline,
  'account-box': I.mdiAccountBox,
  'account-box-multiple': I.mdiAccountBoxMultiple,
  'account-box-multiple-outline': I.mdiAccountBoxMultipleOutline,
  'account-box-outline': I.mdiAccountBoxOutline,
  'account-cancel': I.mdiAccountCancel,
  'account-cancel-outline': I.mdiAccountCancelOutline,
  'account-card': I.mdiAccountCard,
  'account-card-outline': I.mdiAccountCardOutline,
  'account-cash': I.mdiAccountCash,
  'account-cash-outline': I.mdiAccountCashOutline,
  'account-check': I.mdiAccountCheck,
  'account-check-outline': I.mdiAccountCheckOutline,
  'account-child': I.mdiAccountChild,
  'account-child-circle': I.mdiAccountChildCircle,
  'account-child-outline': I.mdiAccountChildOutline,
  'account-circle': I.mdiAccountCircle,
  'account-circle-outline': I.mdiAccountCircleOutline,
  'account-clock': I.mdiAccountClock,
  'account-clock-outline': I.mdiAccountClockOutline,
  'account-cog': I.mdiAccountCog,
  'account-cog-outline': I.mdiAccountCogOutline,
  'account-convert': I.mdiAccountConvert,
  'account-convert-outline': I.mdiAccountConvertOutline,
  'account-cowboy-hat': I.mdiAccountCowboyHat,
  'account-cowboy-hat-outline': I.mdiAccountCowboyHatOutline,
  'account-credit-card': I.mdiAccountCreditCard,
  'account-credit-card-outline': I.mdiAccountCreditCardOutline,
  'account-details': I.mdiAccountDetails,
  'account-details-outline': I.mdiAccountDetailsOutline,
  'account-edit': I.mdiAccountEdit,
  'account-edit-outline': I.mdiAccountEditOutline,
  'account-eye': I.mdiAccountEye,
  'account-eye-outline': I.mdiAccountEyeOutline,
  'account-filter': I.mdiAccountFilter,
  'account-filter-outline': I.mdiAccountFilterOutline,
  'account-group': I.mdiAccountGroup,
  'account-group-outline': I.mdiAccountGroupOutline,
  'account-hard-hat': I.mdiAccountHardHat,
  'account-hard-hat-outline': I.mdiAccountHardHatOutline,
  'account-heart': I.mdiAccountHeart,
  'account-heart-outline': I.mdiAccountHeartOutline,
  'account-injury': I.mdiAccountInjury,
  'account-injury-outline': I.mdiAccountInjuryOutline,
  'account-key': I.mdiAccountKey,
  'account-key-outline': I.mdiAccountKeyOutline,
  'account-lock': I.mdiAccountLock,
  'account-lock-open': I.mdiAccountLockOpen,
  'account-lock-open-outline': I.mdiAccountLockOpenOutline,
  'account-lock-outline': I.mdiAccountLockOutline,
  'account-minus': I.mdiAccountMinus,
  'account-minus-outline': I.mdiAccountMinusOutline,
  'account-multiple': I.mdiAccountMultiple,
  'account-multiple-check': I.mdiAccountMultipleCheck,
  'account-multiple-check-outline': I.mdiAccountMultipleCheckOutline,
  'account-multiple-minus': I.mdiAccountMultipleMinus,
  'account-multiple-minus-outline': I.mdiAccountMultipleMinusOutline,
  'account-multiple-outline': I.mdiAccountMultipleOutline,
  'account-multiple-plus': I.mdiAccountMultiplePlus,
  'account-multiple-plus-outline': I.mdiAccountMultiplePlusOutline,
  'account-multiple-remove': I.mdiAccountMultipleRemove,
  'account-multiple-remove-outline': I.mdiAccountMultipleRemoveOutline,
  'account-music': I.mdiAccountMusic,
  'account-music-outline': I.mdiAccountMusicOutline,
  'account-network': I.mdiAccountNetwork,
  'account-network-off': I.mdiAccountNetworkOff,
  'account-network-off-outline': I.mdiAccountNetworkOffOutline,
  'account-network-outline': I.mdiAccountNetworkOutline,
  'account-off': I.mdiAccountOff,
  'account-off-outline': I.mdiAccountOffOutline,
  'account-outline': I.mdiAccountOutline,
  'account-plus': I.mdiAccountPlus,
  'account-plus-outline': I.mdiAccountPlusOutline,
  'account-question': I.mdiAccountQuestion,
  'account-question-outline': I.mdiAccountQuestionOutline,
  'account-reactivate': I.mdiAccountReactivate,
  'account-reactivate-outline': I.mdiAccountReactivateOutline,
  'account-remove': I.mdiAccountRemove,
  'account-remove-outline': I.mdiAccountRemoveOutline,
  'account-school': I.mdiAccountSchool,
  'account-school-outline': I.mdiAccountSchoolOutline,
  'account-search': I.mdiAccountSearch,
  'account-search-outline': I.mdiAccountSearchOutline,
  'account-settings': I.mdiAccountSettings,
  'account-settings-outline': I.mdiAccountSettingsOutline,
  'account-star': I.mdiAccountStar,
  'account-star-outline': I.mdiAccountStarOutline,
  'account-supervisor': I.mdiAccountSupervisor,
  'account-supervisor-circle': I.mdiAccountSupervisorCircle,
  'account-supervisor-circle-outline': I.mdiAccountSupervisorCircleOutline,
  'account-supervisor-outline': I.mdiAccountSupervisorOutline,
  'account-switch': I.mdiAccountSwitch,
  'account-switch-outline': I.mdiAccountSwitchOutline,
  'account-sync': I.mdiAccountSync,
  'account-sync-outline': I.mdiAccountSyncOutline,
  'account-tie': I.mdiAccountTie,
  'account-tie-hat': I.mdiAccountTieHat,
  'account-tie-hat-outline': I.mdiAccountTieHatOutline,
  'account-tie-outline': I.mdiAccountTieOutline,
  'account-tie-voice': I.mdiAccountTieVoice,
  'account-tie-voice-off': I.mdiAccountTieVoiceOff,
  'account-tie-voice-off-outline': I.mdiAccountTieVoiceOffOutline,
  'account-tie-voice-outline': I.mdiAccountTieVoiceOutline,
  'account-tie-woman': I.mdiAccountTieWoman,
  'account-voice': I.mdiAccountVoice,
  'account-voice-off': I.mdiAccountVoiceOff,
  'account-wrench': I.mdiAccountWrench,
  'account-wrench-outline': I.mdiAccountWrenchOutline,
  adjust: I.mdiAdjust,
  advertisements: I.mdiAdvertisements,
  'advertisements-off': I.mdiAdvertisementsOff,
  'air-conditioner': I.mdiAirConditioner,
  'air-filter': I.mdiAirFilter,
  'air-horn': I.mdiAirHorn,
  'air-humidifier': I.mdiAirHumidifier,
  'air-humidifier-off': I.mdiAirHumidifierOff,
  'air-purifier': I.mdiAirPurifier,
  'air-purifier-off': I.mdiAirPurifierOff,
  airbag: I.mdiAirbag,
  airballoon: I.mdiAirballoon,
  'airballoon-outline': I.mdiAirballoonOutline,
  airplane: I.mdiAirplane,
  'airplane-alert': I.mdiAirplaneAlert,
  'airplane-check': I.mdiAirplaneCheck,
  'airplane-clock': I.mdiAirplaneClock,
  'airplane-cog': I.mdiAirplaneCog,
  'airplane-edit': I.mdiAirplaneEdit,
  'airplane-landing': I.mdiAirplaneLanding,
  'airplane-marker': I.mdiAirplaneMarker,
  'airplane-minus': I.mdiAirplaneMinus,
  'airplane-off': I.mdiAirplaneOff,
  'airplane-plus': I.mdiAirplanePlus,
  'airplane-remove': I.mdiAirplaneRemove,
  'airplane-search': I.mdiAirplaneSearch,
  'airplane-settings': I.mdiAirplaneSettings,
  'airplane-takeoff': I.mdiAirplaneTakeoff,
  airport: I.mdiAirport,
  alarm: I.mdiAlarm,
  'alarm-bell': I.mdiAlarmBell,
  'alarm-check': I.mdiAlarmCheck,
  'alarm-light': I.mdiAlarmLight,
  'alarm-light-off': I.mdiAlarmLightOff,
  'alarm-light-off-outline': I.mdiAlarmLightOffOutline,
  'alarm-light-outline': I.mdiAlarmLightOutline,
  'alarm-multiple': I.mdiAlarmMultiple,
  'alarm-note': I.mdiAlarmNote,
  'alarm-note-off': I.mdiAlarmNoteOff,
  'alarm-off': I.mdiAlarmOff,
  'alarm-panel': I.mdiAlarmPanel,
  'alarm-panel-outline': I.mdiAlarmPanelOutline,
  'alarm-plus': I.mdiAlarmPlus,
  'alarm-snooze': I.mdiAlarmSnooze,
  album: I.mdiAlbum,
  alert: I.mdiAlert,
  'alert-box': I.mdiAlertBox,
  'alert-box-outline': I.mdiAlertBoxOutline,
  'alert-circle': I.mdiAlertCircle,
  'alert-circle-check': I.mdiAlertCircleCheck,
  'alert-circle-check-outline': I.mdiAlertCircleCheckOutline,
  'alert-circle-outline': I.mdiAlertCircleOutline,
  'alert-decagram': I.mdiAlertDecagram,
  'alert-decagram-outline': I.mdiAlertDecagramOutline,
  'alert-minus': I.mdiAlertMinus,
  'alert-minus-outline': I.mdiAlertMinusOutline,
  'alert-octagon': I.mdiAlertOctagon,
  'alert-octagon-outline': I.mdiAlertOctagonOutline,
  'alert-octagram': I.mdiAlertOctagram,
  'alert-octagram-outline': I.mdiAlertOctagramOutline,
  'alert-outline': I.mdiAlertOutline,
  'alert-plus': I.mdiAlertPlus,
  'alert-plus-outline': I.mdiAlertPlusOutline,
  'alert-remove': I.mdiAlertRemove,
  'alert-remove-outline': I.mdiAlertRemoveOutline,
  'alert-rhombus': I.mdiAlertRhombus,
  'alert-rhombus-outline': I.mdiAlertRhombusOutline,
  alien: I.mdiAlien,
  'alien-outline': I.mdiAlienOutline,
  'align-horizontal-center': I.mdiAlignHorizontalCenter,
  'align-horizontal-distribute': I.mdiAlignHorizontalDistribute,
  'align-horizontal-left': I.mdiAlignHorizontalLeft,
  'align-horizontal-right': I.mdiAlignHorizontalRight,
  'align-vertical-bottom': I.mdiAlignVerticalBottom,
  'align-vertical-center': I.mdiAlignVerticalCenter,
  'align-vertical-distribute': I.mdiAlignVerticalDistribute,
  'align-vertical-top': I.mdiAlignVerticalTop,
  'all-inclusive': I.mdiAllInclusive,
  'all-inclusive-box': I.mdiAllInclusiveBox,
  'all-inclusive-box-outline': I.mdiAllInclusiveBoxOutline,
  allergy: I.mdiAllergy,
  alpha: I.mdiAlpha,
  'alpha-a': I.mdiAlphaA,
  'alpha-a-box': I.mdiAlphaABox,
  'alpha-a-box-outline': I.mdiAlphaABoxOutline,
  'alpha-a-circle': I.mdiAlphaACircle,
  'alpha-a-circle-outline': I.mdiAlphaACircleOutline,
  'alpha-b': I.mdiAlphaB,
  'alpha-b-box': I.mdiAlphaBBox,
  'alpha-b-box-outline': I.mdiAlphaBBoxOutline,
  'alpha-b-circle': I.mdiAlphaBCircle,
  'alpha-b-circle-outline': I.mdiAlphaBCircleOutline,
  'alpha-c': I.mdiAlphaC,
  'alpha-c-box': I.mdiAlphaCBox,
  'alpha-c-box-outline': I.mdiAlphaCBoxOutline,
  'alpha-c-circle': I.mdiAlphaCCircle,
  'alpha-c-circle-outline': I.mdiAlphaCCircleOutline,
  'alpha-d': I.mdiAlphaD,
  'alpha-d-box': I.mdiAlphaDBox,
  'alpha-d-box-outline': I.mdiAlphaDBoxOutline,
  'alpha-d-circle': I.mdiAlphaDCircle,
  'alpha-d-circle-outline': I.mdiAlphaDCircleOutline,
  'alpha-e': I.mdiAlphaE,
  'alpha-e-box': I.mdiAlphaEBox,
  'alpha-e-box-outline': I.mdiAlphaEBoxOutline,
  'alpha-e-circle': I.mdiAlphaECircle,
  'alpha-e-circle-outline': I.mdiAlphaECircleOutline,
  'alpha-f': I.mdiAlphaF,
  'alpha-f-box': I.mdiAlphaFBox,
  'alpha-f-box-outline': I.mdiAlphaFBoxOutline,
  'alpha-f-circle': I.mdiAlphaFCircle,
  'alpha-f-circle-outline': I.mdiAlphaFCircleOutline,
  'alpha-g': I.mdiAlphaG,
  'alpha-g-box': I.mdiAlphaGBox,
  'alpha-g-box-outline': I.mdiAlphaGBoxOutline,
  'alpha-g-circle': I.mdiAlphaGCircle,
  'alpha-g-circle-outline': I.mdiAlphaGCircleOutline,
  'alpha-h': I.mdiAlphaH,
  'alpha-h-box': I.mdiAlphaHBox,
  'alpha-h-box-outline': I.mdiAlphaHBoxOutline,
  'alpha-h-circle': I.mdiAlphaHCircle,
  'alpha-h-circle-outline': I.mdiAlphaHCircleOutline,
  'alpha-i': I.mdiAlphaI,
  'alpha-i-box': I.mdiAlphaIBox,
  'alpha-i-box-outline': I.mdiAlphaIBoxOutline,
  'alpha-i-circle': I.mdiAlphaICircle,
  'alpha-i-circle-outline': I.mdiAlphaICircleOutline,
  'alpha-j': I.mdiAlphaJ,
  'alpha-j-box': I.mdiAlphaJBox,
  'alpha-j-box-outline': I.mdiAlphaJBoxOutline,
  'alpha-j-circle': I.mdiAlphaJCircle,
  'alpha-j-circle-outline': I.mdiAlphaJCircleOutline,
  'alpha-k': I.mdiAlphaK,
  'alpha-k-box': I.mdiAlphaKBox,
  'alpha-k-box-outline': I.mdiAlphaKBoxOutline,
  'alpha-k-circle': I.mdiAlphaKCircle,
  'alpha-k-circle-outline': I.mdiAlphaKCircleOutline,
  'alpha-l': I.mdiAlphaL,
  'alpha-l-box': I.mdiAlphaLBox,
  'alpha-l-box-outline': I.mdiAlphaLBoxOutline,
  'alpha-l-circle': I.mdiAlphaLCircle,
  'alpha-l-circle-outline': I.mdiAlphaLCircleOutline,
  'alpha-m': I.mdiAlphaM,
  'alpha-m-box': I.mdiAlphaMBox,
  'alpha-m-box-outline': I.mdiAlphaMBoxOutline,
  'alpha-m-circle': I.mdiAlphaMCircle,
  'alpha-m-circle-outline': I.mdiAlphaMCircleOutline,
  'alpha-n': I.mdiAlphaN,
  'alpha-n-box': I.mdiAlphaNBox,
  'alpha-n-box-outline': I.mdiAlphaNBoxOutline,
  'alpha-n-circle': I.mdiAlphaNCircle,
  'alpha-n-circle-outline': I.mdiAlphaNCircleOutline,
  'alpha-o': I.mdiAlphaO,
  'alpha-o-box': I.mdiAlphaOBox,
  'alpha-o-box-outline': I.mdiAlphaOBoxOutline,
  'alpha-o-circle': I.mdiAlphaOCircle,
  'alpha-o-circle-outline': I.mdiAlphaOCircleOutline,
  'alpha-p': I.mdiAlphaP,
  'alpha-p-box': I.mdiAlphaPBox,
  'alpha-p-box-outline': I.mdiAlphaPBoxOutline,
  'alpha-p-circle': I.mdiAlphaPCircle,
  'alpha-p-circle-outline': I.mdiAlphaPCircleOutline,
  'alpha-q': I.mdiAlphaQ,
  'alpha-q-box': I.mdiAlphaQBox,
  'alpha-q-box-outline': I.mdiAlphaQBoxOutline,
  'alpha-q-circle': I.mdiAlphaQCircle,
  'alpha-q-circle-outline': I.mdiAlphaQCircleOutline,
  'alpha-r': I.mdiAlphaR,
  'alpha-r-box': I.mdiAlphaRBox,
  'alpha-r-box-outline': I.mdiAlphaRBoxOutline,
  'alpha-r-circle': I.mdiAlphaRCircle,
  'alpha-r-circle-outline': I.mdiAlphaRCircleOutline,
  'alpha-s': I.mdiAlphaS,
  'alpha-s-box': I.mdiAlphaSBox,
  'alpha-s-box-outline': I.mdiAlphaSBoxOutline,
  'alpha-s-circle': I.mdiAlphaSCircle,
  'alpha-s-circle-outline': I.mdiAlphaSCircleOutline,
  'alpha-t': I.mdiAlphaT,
  'alpha-t-box': I.mdiAlphaTBox,
  'alpha-t-box-outline': I.mdiAlphaTBoxOutline,
  'alpha-t-circle': I.mdiAlphaTCircle,
  'alpha-t-circle-outline': I.mdiAlphaTCircleOutline,
  'alpha-u': I.mdiAlphaU,
  'alpha-u-box': I.mdiAlphaUBox,
  'alpha-u-box-outline': I.mdiAlphaUBoxOutline,
  'alpha-u-circle': I.mdiAlphaUCircle,
  'alpha-u-circle-outline': I.mdiAlphaUCircleOutline,
  'alpha-v': I.mdiAlphaV,
  'alpha-v-box': I.mdiAlphaVBox,
  'alpha-v-box-outline': I.mdiAlphaVBoxOutline,
  'alpha-v-circle': I.mdiAlphaVCircle,
  'alpha-v-circle-outline': I.mdiAlphaVCircleOutline,
  'alpha-w': I.mdiAlphaW,
  'alpha-w-box': I.mdiAlphaWBox,
  'alpha-w-box-outline': I.mdiAlphaWBoxOutline,
  'alpha-w-circle': I.mdiAlphaWCircle,
  'alpha-w-circle-outline': I.mdiAlphaWCircleOutline,
  'alpha-x': I.mdiAlphaX,
  'alpha-x-box': I.mdiAlphaXBox,
  'alpha-x-box-outline': I.mdiAlphaXBoxOutline,
  'alpha-x-circle': I.mdiAlphaXCircle,
  'alpha-x-circle-outline': I.mdiAlphaXCircleOutline,
  'alpha-y': I.mdiAlphaY,
  'alpha-y-box': I.mdiAlphaYBox,
  'alpha-y-box-outline': I.mdiAlphaYBoxOutline,
  'alpha-y-circle': I.mdiAlphaYCircle,
  'alpha-y-circle-outline': I.mdiAlphaYCircleOutline,
  'alpha-z': I.mdiAlphaZ,
  'alpha-z-box': I.mdiAlphaZBox,
  'alpha-z-box-outline': I.mdiAlphaZBoxOutline,
  'alpha-z-circle': I.mdiAlphaZCircle,
  'alpha-z-circle-outline': I.mdiAlphaZCircleOutline,
  'alphabet-aurebesh': I.mdiAlphabetAurebesh,
  'alphabet-cyrillic': I.mdiAlphabetCyrillic,
  'alphabet-greek': I.mdiAlphabetGreek,
  'alphabet-latin': I.mdiAlphabetLatin,
  'alphabet-piqad': I.mdiAlphabetPiqad,
  'alphabet-tengwar': I.mdiAlphabetTengwar,
  alphabetical: I.mdiAlphabetical,
  'alphabetical-off': I.mdiAlphabeticalOff,
  'alphabetical-variant': I.mdiAlphabeticalVariant,
  'alphabetical-variant-off': I.mdiAlphabeticalVariantOff,
  altimeter: I.mdiAltimeter,
  ambulance: I.mdiAmbulance,
  ammunition: I.mdiAmmunition,
  ampersand: I.mdiAmpersand,
  amplifier: I.mdiAmplifier,
  'amplifier-off': I.mdiAmplifierOff,
  anchor: I.mdiAnchor,
  android: I.mdiAndroid,
  'android-studio': I.mdiAndroidStudio,
  'angle-acute': I.mdiAngleAcute,
  'angle-obtuse': I.mdiAngleObtuse,
  'angle-right': I.mdiAngleRight,
  angular: I.mdiAngular,
  angularjs: I.mdiAngularjs,
  animation: I.mdiAnimation,
  'animation-outline': I.mdiAnimationOutline,
  'animation-play': I.mdiAnimationPlay,
  'animation-play-outline': I.mdiAnimationPlayOutline,
  ansible: I.mdiAnsible,
  antenna: I.mdiAntenna,
  anvil: I.mdiAnvil,
  'apache-kafka': I.mdiApacheKafka,
  api: I.mdiApi,
  'api-off': I.mdiApiOff,
  apple: I.mdiApple,
  'apple-finder': I.mdiAppleFinder,
  'apple-icloud': I.mdiAppleIcloud,
  'apple-ios': I.mdiAppleIos,
  'apple-keyboard-caps': I.mdiAppleKeyboardCaps,
  'apple-keyboard-command': I.mdiAppleKeyboardCommand,
  'apple-keyboard-control': I.mdiAppleKeyboardControl,
  'apple-keyboard-option': I.mdiAppleKeyboardOption,
  'apple-keyboard-shift': I.mdiAppleKeyboardShift,
  'apple-safari': I.mdiAppleSafari,
  application: I.mdiApplication,
  'application-array': I.mdiApplicationArray,
  'application-array-outline': I.mdiApplicationArrayOutline,
  'application-braces': I.mdiApplicationBraces,
  'application-braces-outline': I.mdiApplicationBracesOutline,
  'application-brackets': I.mdiApplicationBrackets,
  'application-brackets-outline': I.mdiApplicationBracketsOutline,
  'application-cog': I.mdiApplicationCog,
  'application-cog-outline': I.mdiApplicationCogOutline,
  'application-edit': I.mdiApplicationEdit,
  'application-edit-outline': I.mdiApplicationEditOutline,
  'application-export': I.mdiApplicationExport,
  'application-import': I.mdiApplicationImport,
  'application-outline': I.mdiApplicationOutline,
  'application-parentheses': I.mdiApplicationParentheses,
  'application-parentheses-outline': I.mdiApplicationParenthesesOutline,
  'application-settings': I.mdiApplicationSettings,
  'application-settings-outline': I.mdiApplicationSettingsOutline,
  'application-variable': I.mdiApplicationVariable,
  'application-variable-outline': I.mdiApplicationVariableOutline,
  'approximately-equal': I.mdiApproximatelyEqual,
  'approximately-equal-box': I.mdiApproximatelyEqualBox,
  apps: I.mdiApps,
  'apps-box': I.mdiAppsBox,
  arch: I.mdiArch,
  archive: I.mdiArchive,
  'archive-alert': I.mdiArchiveAlert,
  'archive-alert-outline': I.mdiArchiveAlertOutline,
  'archive-arrow-down': I.mdiArchiveArrowDown,
  'archive-arrow-down-outline': I.mdiArchiveArrowDownOutline,
  'archive-arrow-up': I.mdiArchiveArrowUp,
  'archive-arrow-up-outline': I.mdiArchiveArrowUpOutline,
  'archive-cancel': I.mdiArchiveCancel,
  'archive-cancel-outline': I.mdiArchiveCancelOutline,
  'archive-check': I.mdiArchiveCheck,
  'archive-check-outline': I.mdiArchiveCheckOutline,
  'archive-clock': I.mdiArchiveClock,
  'archive-clock-outline': I.mdiArchiveClockOutline,
  'archive-cog': I.mdiArchiveCog,
  'archive-cog-outline': I.mdiArchiveCogOutline,
  'archive-edit': I.mdiArchiveEdit,
  'archive-edit-outline': I.mdiArchiveEditOutline,
  'archive-eye': I.mdiArchiveEye,
  'archive-eye-outline': I.mdiArchiveEyeOutline,
  'archive-lock': I.mdiArchiveLock,
  'archive-lock-open': I.mdiArchiveLockOpen,
  'archive-lock-open-outline': I.mdiArchiveLockOpenOutline,
  'archive-lock-outline': I.mdiArchiveLockOutline,
  'archive-marker': I.mdiArchiveMarker,
  'archive-marker-outline': I.mdiArchiveMarkerOutline,
  'archive-minus': I.mdiArchiveMinus,
  'archive-minus-outline': I.mdiArchiveMinusOutline,
  'archive-music': I.mdiArchiveMusic,
  'archive-music-outline': I.mdiArchiveMusicOutline,
  'archive-off': I.mdiArchiveOff,
  'archive-off-outline': I.mdiArchiveOffOutline,
  'archive-outline': I.mdiArchiveOutline,
  'archive-plus': I.mdiArchivePlus,
  'archive-plus-outline': I.mdiArchivePlusOutline,
  'archive-refresh': I.mdiArchiveRefresh,
  'archive-refresh-outline': I.mdiArchiveRefreshOutline,
  'archive-remove': I.mdiArchiveRemove,
  'archive-remove-outline': I.mdiArchiveRemoveOutline,
  'archive-search': I.mdiArchiveSearch,
  'archive-search-outline': I.mdiArchiveSearchOutline,
  'archive-settings': I.mdiArchiveSettings,
  'archive-settings-outline': I.mdiArchiveSettingsOutline,
  'archive-star': I.mdiArchiveStar,
  'archive-star-outline': I.mdiArchiveStarOutline,
  'archive-sync': I.mdiArchiveSync,
  'archive-sync-outline': I.mdiArchiveSyncOutline,
  'arm-flex': I.mdiArmFlex,
  'arm-flex-outline': I.mdiArmFlexOutline,
  'arrange-bring-forward': I.mdiArrangeBringForward,
  'arrange-bring-to-front': I.mdiArrangeBringToFront,
  'arrange-send-backward': I.mdiArrangeSendBackward,
  'arrange-send-to-back': I.mdiArrangeSendToBack,
  'arrow-all': I.mdiArrowAll,
  'arrow-bottom-left': I.mdiArrowBottomLeft,
  'arrow-bottom-left-bold-box': I.mdiArrowBottomLeftBoldBox,
  'arrow-bottom-left-bold-box-outline': I.mdiArrowBottomLeftBoldBoxOutline,
  'arrow-bottom-left-bold-outline': I.mdiArrowBottomLeftBoldOutline,
  'arrow-bottom-left-thick': I.mdiArrowBottomLeftThick,
  'arrow-bottom-left-thin': I.mdiArrowBottomLeftThin,
  'arrow-bottom-left-thin-circle-outline':
    I.mdiArrowBottomLeftThinCircleOutline,
  'arrow-bottom-right': I.mdiArrowBottomRight,
  'arrow-bottom-right-bold-box': I.mdiArrowBottomRightBoldBox,
  'arrow-bottom-right-bold-box-outline': I.mdiArrowBottomRightBoldBoxOutline,
  'arrow-bottom-right-bold-outline': I.mdiArrowBottomRightBoldOutline,
  'arrow-bottom-right-thick': I.mdiArrowBottomRightThick,
  'arrow-bottom-right-thin': I.mdiArrowBottomRightThin,
  'arrow-bottom-right-thin-circle-outline':
    I.mdiArrowBottomRightThinCircleOutline,
  'arrow-collapse': I.mdiArrowCollapse,
  'arrow-collapse-all': I.mdiArrowCollapseAll,
  'arrow-collapse-down': I.mdiArrowCollapseDown,
  'arrow-collapse-horizontal': I.mdiArrowCollapseHorizontal,
  'arrow-collapse-left': I.mdiArrowCollapseLeft,
  'arrow-collapse-right': I.mdiArrowCollapseRight,
  'arrow-collapse-up': I.mdiArrowCollapseUp,
  'arrow-collapse-vertical': I.mdiArrowCollapseVertical,
  'arrow-decision': I.mdiArrowDecision,
  'arrow-decision-auto': I.mdiArrowDecisionAuto,
  'arrow-decision-auto-outline': I.mdiArrowDecisionAutoOutline,
  'arrow-decision-outline': I.mdiArrowDecisionOutline,
  'arrow-down': I.mdiArrowDown,
  'arrow-down-bold': I.mdiArrowDownBold,
  'arrow-down-bold-box': I.mdiArrowDownBoldBox,
  'arrow-down-bold-box-outline': I.mdiArrowDownBoldBoxOutline,
  'arrow-down-bold-circle': I.mdiArrowDownBoldCircle,
  'arrow-down-bold-circle-outline': I.mdiArrowDownBoldCircleOutline,
  'arrow-down-bold-hexagon-outline': I.mdiArrowDownBoldHexagonOutline,
  'arrow-down-bold-outline': I.mdiArrowDownBoldOutline,
  'arrow-down-box': I.mdiArrowDownBox,
  'arrow-down-circle': I.mdiArrowDownCircle,
  'arrow-down-circle-outline': I.mdiArrowDownCircleOutline,
  'arrow-down-drop-circle': I.mdiArrowDownDropCircle,
  'arrow-down-drop-circle-outline': I.mdiArrowDownDropCircleOutline,
  'arrow-down-left': I.mdiArrowDownLeft,
  'arrow-down-left-bold': I.mdiArrowDownLeftBold,
  'arrow-down-right': I.mdiArrowDownRight,
  'arrow-down-right-bold': I.mdiArrowDownRightBold,
  'arrow-down-thick': I.mdiArrowDownThick,
  'arrow-down-thin': I.mdiArrowDownThin,
  'arrow-down-thin-circle-outline': I.mdiArrowDownThinCircleOutline,
  'arrow-expand': I.mdiArrowExpand,
  'arrow-expand-all': I.mdiArrowExpandAll,
  'arrow-expand-down': I.mdiArrowExpandDown,
  'arrow-expand-horizontal': I.mdiArrowExpandHorizontal,
  'arrow-expand-left': I.mdiArrowExpandLeft,
  'arrow-expand-right': I.mdiArrowExpandRight,
  'arrow-expand-up': I.mdiArrowExpandUp,
  'arrow-expand-vertical': I.mdiArrowExpandVertical,
  'arrow-horizontal-lock': I.mdiArrowHorizontalLock,
  'arrow-left': I.mdiArrowLeft,
  'arrow-left-bold': I.mdiArrowLeftBold,
  'arrow-left-bold-box': I.mdiArrowLeftBoldBox,
  'arrow-left-bold-box-outline': I.mdiArrowLeftBoldBoxOutline,
  'arrow-left-bold-circle': I.mdiArrowLeftBoldCircle,
  'arrow-left-bold-circle-outline': I.mdiArrowLeftBoldCircleOutline,
  'arrow-left-bold-hexagon-outline': I.mdiArrowLeftBoldHexagonOutline,
  'arrow-left-bold-outline': I.mdiArrowLeftBoldOutline,
  'arrow-left-bottom': I.mdiArrowLeftBottom,
  'arrow-left-bottom-bold': I.mdiArrowLeftBottomBold,
  'arrow-left-box': I.mdiArrowLeftBox,
  'arrow-left-circle': I.mdiArrowLeftCircle,
  'arrow-left-circle-outline': I.mdiArrowLeftCircleOutline,
  'arrow-left-drop-circle': I.mdiArrowLeftDropCircle,
  'arrow-left-drop-circle-outline': I.mdiArrowLeftDropCircleOutline,
  'arrow-left-right': I.mdiArrowLeftRight,
  'arrow-left-right-bold': I.mdiArrowLeftRightBold,
  'arrow-left-right-bold-outline': I.mdiArrowLeftRightBoldOutline,
  'arrow-left-thick': I.mdiArrowLeftThick,
  'arrow-left-thin': I.mdiArrowLeftThin,
  'arrow-left-thin-circle-outline': I.mdiArrowLeftThinCircleOutline,
  'arrow-left-top': I.mdiArrowLeftTop,
  'arrow-left-top-bold': I.mdiArrowLeftTopBold,
  'arrow-projectile': I.mdiArrowProjectile,
  'arrow-projectile-multiple': I.mdiArrowProjectileMultiple,
  'arrow-right': I.mdiArrowRight,
  'arrow-right-bold': I.mdiArrowRightBold,
  'arrow-right-bold-box': I.mdiArrowRightBoldBox,
  'arrow-right-bold-box-outline': I.mdiArrowRightBoldBoxOutline,
  'arrow-right-bold-circle': I.mdiArrowRightBoldCircle,
  'arrow-right-bold-circle-outline': I.mdiArrowRightBoldCircleOutline,
  'arrow-right-bold-hexagon-outline': I.mdiArrowRightBoldHexagonOutline,
  'arrow-right-bold-outline': I.mdiArrowRightBoldOutline,
  'arrow-right-bottom': I.mdiArrowRightBottom,
  'arrow-right-bottom-bold': I.mdiArrowRightBottomBold,
  'arrow-right-box': I.mdiArrowRightBox,
  'arrow-right-circle': I.mdiArrowRightCircle,
  'arrow-right-circle-outline': I.mdiArrowRightCircleOutline,
  'arrow-right-drop-circle': I.mdiArrowRightDropCircle,
  'arrow-right-drop-circle-outline': I.mdiArrowRightDropCircleOutline,
  'arrow-right-thick': I.mdiArrowRightThick,
  'arrow-right-thin': I.mdiArrowRightThin,
  'arrow-right-thin-circle-outline': I.mdiArrowRightThinCircleOutline,
  'arrow-right-top': I.mdiArrowRightTop,
  'arrow-right-top-bold': I.mdiArrowRightTopBold,
  'arrow-split-horizontal': I.mdiArrowSplitHorizontal,
  'arrow-split-vertical': I.mdiArrowSplitVertical,
  'arrow-top-left': I.mdiArrowTopLeft,
  'arrow-top-left-bold-box': I.mdiArrowTopLeftBoldBox,
  'arrow-top-left-bold-box-outline': I.mdiArrowTopLeftBoldBoxOutline,
  'arrow-top-left-bold-outline': I.mdiArrowTopLeftBoldOutline,
  'arrow-top-left-bottom-right': I.mdiArrowTopLeftBottomRight,
  'arrow-top-left-bottom-right-bold': I.mdiArrowTopLeftBottomRightBold,
  'arrow-top-left-thick': I.mdiArrowTopLeftThick,
  'arrow-top-left-thin': I.mdiArrowTopLeftThin,
  'arrow-top-left-thin-circle-outline': I.mdiArrowTopLeftThinCircleOutline,
  'arrow-top-right': I.mdiArrowTopRight,
  'arrow-top-right-bold-box': I.mdiArrowTopRightBoldBox,
  'arrow-top-right-bold-box-outline': I.mdiArrowTopRightBoldBoxOutline,
  'arrow-top-right-bold-outline': I.mdiArrowTopRightBoldOutline,
  'arrow-top-right-bottom-left': I.mdiArrowTopRightBottomLeft,
  'arrow-top-right-bottom-left-bold': I.mdiArrowTopRightBottomLeftBold,
  'arrow-top-right-thick': I.mdiArrowTopRightThick,
  'arrow-top-right-thin': I.mdiArrowTopRightThin,
  'arrow-top-right-thin-circle-outline': I.mdiArrowTopRightThinCircleOutline,
  'arrow-u-down-left': I.mdiArrowUDownLeft,
  'arrow-u-down-left-bold': I.mdiArrowUDownLeftBold,
  'arrow-u-down-right': I.mdiArrowUDownRight,
  'arrow-u-down-right-bold': I.mdiArrowUDownRightBold,
  'arrow-u-left-bottom': I.mdiArrowULeftBottom,
  'arrow-u-left-bottom-bold': I.mdiArrowULeftBottomBold,
  'arrow-u-left-top': I.mdiArrowULeftTop,
  'arrow-u-left-top-bold': I.mdiArrowULeftTopBold,
  'arrow-u-right-bottom': I.mdiArrowURightBottom,
  'arrow-u-right-bottom-bold': I.mdiArrowURightBottomBold,
  'arrow-u-right-top': I.mdiArrowURightTop,
  'arrow-u-right-top-bold': I.mdiArrowURightTopBold,
  'arrow-u-up-left': I.mdiArrowUUpLeft,
  'arrow-u-up-left-bold': I.mdiArrowUUpLeftBold,
  'arrow-u-up-right': I.mdiArrowUUpRight,
  'arrow-u-up-right-bold': I.mdiArrowUUpRightBold,
  'arrow-up': I.mdiArrowUp,
  'arrow-up-bold': I.mdiArrowUpBold,
  'arrow-up-bold-box': I.mdiArrowUpBoldBox,
  'arrow-up-bold-box-outline': I.mdiArrowUpBoldBoxOutline,
  'arrow-up-bold-circle': I.mdiArrowUpBoldCircle,
  'arrow-up-bold-circle-outline': I.mdiArrowUpBoldCircleOutline,
  'arrow-up-bold-hexagon-outline': I.mdiArrowUpBoldHexagonOutline,
  'arrow-up-bold-outline': I.mdiArrowUpBoldOutline,
  'arrow-up-box': I.mdiArrowUpBox,
  'arrow-up-circle': I.mdiArrowUpCircle,
  'arrow-up-circle-outline': I.mdiArrowUpCircleOutline,
  'arrow-up-down': I.mdiArrowUpDown,
  'arrow-up-down-bold': I.mdiArrowUpDownBold,
  'arrow-up-down-bold-outline': I.mdiArrowUpDownBoldOutline,
  'arrow-up-drop-circle': I.mdiArrowUpDropCircle,
  'arrow-up-drop-circle-outline': I.mdiArrowUpDropCircleOutline,
  'arrow-up-left': I.mdiArrowUpLeft,
  'arrow-up-left-bold': I.mdiArrowUpLeftBold,
  'arrow-up-right': I.mdiArrowUpRight,
  'arrow-up-right-bold': I.mdiArrowUpRightBold,
  'arrow-up-thick': I.mdiArrowUpThick,
  'arrow-up-thin': I.mdiArrowUpThin,
  'arrow-up-thin-circle-outline': I.mdiArrowUpThinCircleOutline,
  'arrow-vertical-lock': I.mdiArrowVerticalLock,
  artboard: I.mdiArtboard,
  artstation: I.mdiArtstation,
  'aspect-ratio': I.mdiAspectRatio,
  assistant: I.mdiAssistant,
  asterisk: I.mdiAsterisk,
  'asterisk-circle-outline': I.mdiAsteriskCircleOutline,
  at: I.mdiAt,
  atlassian: I.mdiAtlassian,
  atm: I.mdiAtm,
  atom: I.mdiAtom,
  'atom-variant': I.mdiAtomVariant,
  attachment: I.mdiAttachment,
  'attachment-check': I.mdiAttachmentCheck,
  'attachment-lock': I.mdiAttachmentLock,
  'attachment-minus': I.mdiAttachmentMinus,
  'attachment-off': I.mdiAttachmentOff,
  'attachment-plus': I.mdiAttachmentPlus,
  'attachment-remove': I.mdiAttachmentRemove,
  atv: I.mdiAtv,
  'audio-input-rca': I.mdiAudioInputRca,
  'audio-input-stereo-minijack': I.mdiAudioInputStereoMinijack,
  'audio-input-xlr': I.mdiAudioInputXlr,
  'audio-video': I.mdiAudioVideo,
  'audio-video-off': I.mdiAudioVideoOff,
  'augmented-reality': I.mdiAugmentedReality,
  'auto-download': I.mdiAutoDownload,
  'auto-fix': I.mdiAutoFix,
  'auto-upload': I.mdiAutoUpload,
  autorenew: I.mdiAutorenew,
  'autorenew-off': I.mdiAutorenewOff,
  'av-timer': I.mdiAvTimer,
  awning: I.mdiAwning,
  'awning-outline': I.mdiAwningOutline,
  aws: I.mdiAws,
  axe: I.mdiAxe,
  'axe-battle': I.mdiAxeBattle,
  axis: I.mdiAxis,
  'axis-arrow': I.mdiAxisArrow,
  'axis-arrow-info': I.mdiAxisArrowInfo,
  'axis-arrow-lock': I.mdiAxisArrowLock,
  'axis-lock': I.mdiAxisLock,
  'axis-x-arrow': I.mdiAxisXArrow,
  'axis-x-arrow-lock': I.mdiAxisXArrowLock,
  'axis-x-rotate-clockwise': I.mdiAxisXRotateClockwise,
  'axis-x-rotate-counterclockwise': I.mdiAxisXRotateCounterclockwise,
  'axis-xy-arrow-lock': I.mdiAxisXYArrowLock,
  'axis-y-arrow': I.mdiAxisYArrow,
  'axis-y-arrow-lock': I.mdiAxisYArrowLock,
  'axis-y-rotate-clockwise': I.mdiAxisYRotateClockwise,
  'axis-y-rotate-counterclockwise': I.mdiAxisYRotateCounterclockwise,
  'axis-z-arrow': I.mdiAxisZArrow,
  'axis-z-arrow-lock': I.mdiAxisZArrowLock,
  'axis-z-rotate-clockwise': I.mdiAxisZRotateClockwise,
  'axis-z-rotate-counterclockwise': I.mdiAxisZRotateCounterclockwise,
  babel: I.mdiBabel,
  baby: I.mdiBaby,
  'baby-bottle': I.mdiBabyBottle,
  'baby-bottle-outline': I.mdiBabyBottleOutline,
  'baby-buggy': I.mdiBabyBuggy,
  'baby-buggy-off': I.mdiBabyBuggyOff,
  'baby-carriage': I.mdiBabyCarriage,
  'baby-carriage-off': I.mdiBabyCarriageOff,
  'baby-face': I.mdiBabyFace,
  'baby-face-outline': I.mdiBabyFaceOutline,
  backburger: I.mdiBackburger,
  backspace: I.mdiBackspace,
  'backspace-outline': I.mdiBackspaceOutline,
  'backspace-reverse': I.mdiBackspaceReverse,
  'backspace-reverse-outline': I.mdiBackspaceReverseOutline,
  'backup-restore': I.mdiBackupRestore,
  bacteria: I.mdiBacteria,
  'bacteria-outline': I.mdiBacteriaOutline,
  'badge-account': I.mdiBadgeAccount,
  'badge-account-alert': I.mdiBadgeAccountAlert,
  'badge-account-alert-outline': I.mdiBadgeAccountAlertOutline,
  'badge-account-horizontal': I.mdiBadgeAccountHorizontal,
  'badge-account-horizontal-outline': I.mdiBadgeAccountHorizontalOutline,
  'badge-account-outline': I.mdiBadgeAccountOutline,
  badminton: I.mdiBadminton,
  'bag-carry-on': I.mdiBagCarryOn,
  'bag-carry-on-check': I.mdiBagCarryOnCheck,
  'bag-carry-on-off': I.mdiBagCarryOnOff,
  'bag-checked': I.mdiBagChecked,
  'bag-personal': I.mdiBagPersonal,
  'bag-personal-off': I.mdiBagPersonalOff,
  'bag-personal-off-outline': I.mdiBagPersonalOffOutline,
  'bag-personal-outline': I.mdiBagPersonalOutline,
  'bag-personal-tag': I.mdiBagPersonalTag,
  'bag-personal-tag-outline': I.mdiBagPersonalTagOutline,
  'bag-suitcase': I.mdiBagSuitcase,
  'bag-suitcase-off': I.mdiBagSuitcaseOff,
  'bag-suitcase-off-outline': I.mdiBagSuitcaseOffOutline,
  'bag-suitcase-outline': I.mdiBagSuitcaseOutline,
  baguette: I.mdiBaguette,
  balcony: I.mdiBalcony,
  balloon: I.mdiBalloon,
  ballot: I.mdiBallot,
  'ballot-outline': I.mdiBallotOutline,
  'ballot-recount': I.mdiBallotRecount,
  'ballot-recount-outline': I.mdiBallotRecountOutline,
  bandage: I.mdiBandage,
  bank: I.mdiBank,
  'bank-check': I.mdiBankCheck,
  'bank-minus': I.mdiBankMinus,
  'bank-off': I.mdiBankOff,
  'bank-off-outline': I.mdiBankOffOutline,
  'bank-outline': I.mdiBankOutline,
  'bank-plus': I.mdiBankPlus,
  'bank-remove': I.mdiBankRemove,
  'bank-transfer': I.mdiBankTransfer,
  'bank-transfer-in': I.mdiBankTransferIn,
  'bank-transfer-out': I.mdiBankTransferOut,
  barcode: I.mdiBarcode,
  'barcode-off': I.mdiBarcodeOff,
  'barcode-scan': I.mdiBarcodeScan,
  barley: I.mdiBarley,
  'barley-off': I.mdiBarleyOff,
  barn: I.mdiBarn,
  barrel: I.mdiBarrel,
  'barrel-outline': I.mdiBarrelOutline,
  baseball: I.mdiBaseball,
  'baseball-bat': I.mdiBaseballBat,
  'baseball-diamond': I.mdiBaseballDiamond,
  'baseball-diamond-outline': I.mdiBaseballDiamondOutline,
  bash: I.mdiBash,
  basket: I.mdiBasket,
  'basket-check': I.mdiBasketCheck,
  'basket-check-outline': I.mdiBasketCheckOutline,
  'basket-fill': I.mdiBasketFill,
  'basket-minus': I.mdiBasketMinus,
  'basket-minus-outline': I.mdiBasketMinusOutline,
  'basket-off': I.mdiBasketOff,
  'basket-off-outline': I.mdiBasketOffOutline,
  'basket-outline': I.mdiBasketOutline,
  'basket-plus': I.mdiBasketPlus,
  'basket-plus-outline': I.mdiBasketPlusOutline,
  'basket-remove': I.mdiBasketRemove,
  'basket-remove-outline': I.mdiBasketRemoveOutline,
  'basket-unfill': I.mdiBasketUnfill,
  basketball: I.mdiBasketball,
  'basketball-hoop': I.mdiBasketballHoop,
  'basketball-hoop-outline': I.mdiBasketballHoopOutline,
  bat: I.mdiBat,
  bathtub: I.mdiBathtub,
  'bathtub-outline': I.mdiBathtubOutline,
  battery: I.mdiBattery,
  'battery-10': I.mdiBattery10,
  'battery-10-bluetooth': I.mdiBattery10Bluetooth,
  'battery-20': I.mdiBattery20,
  'battery-20-bluetooth': I.mdiBattery20Bluetooth,
  'battery-30': I.mdiBattery30,
  'battery-30-bluetooth': I.mdiBattery30Bluetooth,
  'battery-40': I.mdiBattery40,
  'battery-40-bluetooth': I.mdiBattery40Bluetooth,
  'battery-50': I.mdiBattery50,
  'battery-50-bluetooth': I.mdiBattery50Bluetooth,
  'battery-60': I.mdiBattery60,
  'battery-60-bluetooth': I.mdiBattery60Bluetooth,
  'battery-70': I.mdiBattery70,
  'battery-70-bluetooth': I.mdiBattery70Bluetooth,
  'battery-80': I.mdiBattery80,
  'battery-80-bluetooth': I.mdiBattery80Bluetooth,
  'battery-90': I.mdiBattery90,
  'battery-90-bluetooth': I.mdiBattery90Bluetooth,
  'battery-alert': I.mdiBatteryAlert,
  'battery-alert-bluetooth': I.mdiBatteryAlertBluetooth,
  'battery-alert-variant': I.mdiBatteryAlertVariant,
  'battery-alert-variant-outline': I.mdiBatteryAlertVariantOutline,
  'battery-arrow-down': I.mdiBatteryArrowDown,
  'battery-arrow-down-outline': I.mdiBatteryArrowDownOutline,
  'battery-arrow-up': I.mdiBatteryArrowUp,
  'battery-arrow-up-outline': I.mdiBatteryArrowUpOutline,
  'battery-bluetooth': I.mdiBatteryBluetooth,
  'battery-bluetooth-variant': I.mdiBatteryBluetoothVariant,
  'battery-charging': I.mdiBatteryCharging,
  'battery-charging-10': I.mdiBatteryCharging10,
  'battery-charging-20': I.mdiBatteryCharging20,
  'battery-charging-30': I.mdiBatteryCharging30,
  'battery-charging-40': I.mdiBatteryCharging40,
  'battery-charging-50': I.mdiBatteryCharging50,
  'battery-charging-60': I.mdiBatteryCharging60,
  'battery-charging-70': I.mdiBatteryCharging70,
  'battery-charging-80': I.mdiBatteryCharging80,
  'battery-charging-90': I.mdiBatteryCharging90,
  'battery-charging-100': I.mdiBatteryCharging100,
  'battery-charging-high': I.mdiBatteryChargingHigh,
  'battery-charging-low': I.mdiBatteryChargingLow,
  'battery-charging-medium': I.mdiBatteryChargingMedium,
  'battery-charging-outline': I.mdiBatteryChargingOutline,
  'battery-charging-wireless': I.mdiBatteryChargingWireless,
  'battery-charging-wireless-10': I.mdiBatteryChargingWireless10,
  'battery-charging-wireless-20': I.mdiBatteryChargingWireless20,
  'battery-charging-wireless-30': I.mdiBatteryChargingWireless30,
  'battery-charging-wireless-40': I.mdiBatteryChargingWireless40,
  'battery-charging-wireless-50': I.mdiBatteryChargingWireless50,
  'battery-charging-wireless-60': I.mdiBatteryChargingWireless60,
  'battery-charging-wireless-70': I.mdiBatteryChargingWireless70,
  'battery-charging-wireless-80': I.mdiBatteryChargingWireless80,
  'battery-charging-wireless-90': I.mdiBatteryChargingWireless90,
  'battery-charging-wireless-alert': I.mdiBatteryChargingWirelessAlert,
  'battery-charging-wireless-outline': I.mdiBatteryChargingWirelessOutline,
  'battery-check': I.mdiBatteryCheck,
  'battery-check-outline': I.mdiBatteryCheckOutline,
  'battery-clock': I.mdiBatteryClock,
  'battery-clock-outline': I.mdiBatteryClockOutline,
  'battery-heart': I.mdiBatteryHeart,
  'battery-heart-outline': I.mdiBatteryHeartOutline,
  'battery-heart-variant': I.mdiBatteryHeartVariant,
  'battery-high': I.mdiBatteryHigh,
  'battery-lock': I.mdiBatteryLock,
  'battery-lock-open': I.mdiBatteryLockOpen,
  'battery-low': I.mdiBatteryLow,
  'battery-medium': I.mdiBatteryMedium,
  'battery-minus': I.mdiBatteryMinus,
  'battery-minus-outline': I.mdiBatteryMinusOutline,
  'battery-minus-variant': I.mdiBatteryMinusVariant,
  'battery-negative': I.mdiBatteryNegative,
  'battery-off': I.mdiBatteryOff,
  'battery-off-outline': I.mdiBatteryOffOutline,
  'battery-outline': I.mdiBatteryOutline,
  'battery-plus': I.mdiBatteryPlus,
  'battery-plus-outline': I.mdiBatteryPlusOutline,
  'battery-plus-variant': I.mdiBatteryPlusVariant,
  'battery-positive': I.mdiBatteryPositive,
  'battery-remove': I.mdiBatteryRemove,
  'battery-remove-outline': I.mdiBatteryRemoveOutline,
  'battery-sync': I.mdiBatterySync,
  'battery-sync-outline': I.mdiBatterySyncOutline,
  'battery-unknown': I.mdiBatteryUnknown,
  'battery-unknown-bluetooth': I.mdiBatteryUnknownBluetooth,
  beach: I.mdiBeach,
  beaker: I.mdiBeaker,
  'beaker-alert': I.mdiBeakerAlert,
  'beaker-alert-outline': I.mdiBeakerAlertOutline,
  'beaker-check': I.mdiBeakerCheck,
  'beaker-check-outline': I.mdiBeakerCheckOutline,
  'beaker-minus': I.mdiBeakerMinus,
  'beaker-minus-outline': I.mdiBeakerMinusOutline,
  'beaker-outline': I.mdiBeakerOutline,
  'beaker-plus': I.mdiBeakerPlus,
  'beaker-plus-outline': I.mdiBeakerPlusOutline,
  'beaker-question': I.mdiBeakerQuestion,
  'beaker-question-outline': I.mdiBeakerQuestionOutline,
  'beaker-remove': I.mdiBeakerRemove,
  'beaker-remove-outline': I.mdiBeakerRemoveOutline,
  bed: I.mdiBed,
  'bed-clock': I.mdiBedClock,
  'bed-double': I.mdiBedDouble,
  'bed-double-outline': I.mdiBedDoubleOutline,
  'bed-empty': I.mdiBedEmpty,
  'bed-king': I.mdiBedKing,
  'bed-king-outline': I.mdiBedKingOutline,
  'bed-outline': I.mdiBedOutline,
  'bed-queen': I.mdiBedQueen,
  'bed-queen-outline': I.mdiBedQueenOutline,
  'bed-single': I.mdiBedSingle,
  'bed-single-outline': I.mdiBedSingleOutline,
  bee: I.mdiBee,
  'bee-flower': I.mdiBeeFlower,
  'beehive-off-outline': I.mdiBeehiveOffOutline,
  'beehive-outline': I.mdiBeehiveOutline,
  beekeeper: I.mdiBeekeeper,
  beer: I.mdiBeer,
  'beer-outline': I.mdiBeerOutline,
  bell: I.mdiBell,
  'bell-alert': I.mdiBellAlert,
  'bell-alert-outline': I.mdiBellAlertOutline,
  'bell-badge': I.mdiBellBadge,
  'bell-badge-outline': I.mdiBellBadgeOutline,
  'bell-cancel': I.mdiBellCancel,
  'bell-cancel-outline': I.mdiBellCancelOutline,
  'bell-check': I.mdiBellCheck,
  'bell-check-outline': I.mdiBellCheckOutline,
  'bell-circle': I.mdiBellCircle,
  'bell-circle-outline': I.mdiBellCircleOutline,
  'bell-cog': I.mdiBellCog,
  'bell-cog-outline': I.mdiBellCogOutline,
  'bell-minus': I.mdiBellMinus,
  'bell-minus-outline': I.mdiBellMinusOutline,
  'bell-off': I.mdiBellOff,
  'bell-off-outline': I.mdiBellOffOutline,
  'bell-outline': I.mdiBellOutline,
  'bell-plus': I.mdiBellPlus,
  'bell-plus-outline': I.mdiBellPlusOutline,
  'bell-remove': I.mdiBellRemove,
  'bell-remove-outline': I.mdiBellRemoveOutline,
  'bell-ring': I.mdiBellRing,
  'bell-ring-outline': I.mdiBellRingOutline,
  'bell-sleep': I.mdiBellSleep,
  'bell-sleep-outline': I.mdiBellSleepOutline,
  beta: I.mdiBeta,
  betamax: I.mdiBetamax,
  biathlon: I.mdiBiathlon,
  bicycle: I.mdiBicycle,
  'bicycle-basket': I.mdiBicycleBasket,
  'bicycle-cargo': I.mdiBicycleCargo,
  'bicycle-electric': I.mdiBicycleElectric,
  'bicycle-penny-farthing': I.mdiBicyclePennyFarthing,
  bike: I.mdiBike,
  'bike-fast': I.mdiBikeFast,
  billboard: I.mdiBillboard,
  billiards: I.mdiBilliards,
  'billiards-rack': I.mdiBilliardsRack,
  binoculars: I.mdiBinoculars,
  bio: I.mdiBio,
  biohazard: I.mdiBiohazard,
  bird: I.mdiBird,
  bitbucket: I.mdiBitbucket,
  bitcoin: I.mdiBitcoin,
  'black-mesa': I.mdiBlackMesa,
  blender: I.mdiBlender,
  'blender-outline': I.mdiBlenderOutline,
  'blender-software': I.mdiBlenderSoftware,
  blinds: I.mdiBlinds,
  'blinds-horizontal': I.mdiBlindsHorizontal,
  'blinds-horizontal-closed': I.mdiBlindsHorizontalClosed,
  'blinds-open': I.mdiBlindsOpen,
  'blinds-vertical': I.mdiBlindsVertical,
  'blinds-vertical-closed': I.mdiBlindsVerticalClosed,
  'block-helper': I.mdiBlockHelper,
  'blood-bag': I.mdiBloodBag,
  bluetooth: I.mdiBluetooth,
  'bluetooth-audio': I.mdiBluetoothAudio,
  'bluetooth-connect': I.mdiBluetoothConnect,
  'bluetooth-off': I.mdiBluetoothOff,
  'bluetooth-settings': I.mdiBluetoothSettings,
  'bluetooth-transfer': I.mdiBluetoothTransfer,
  blur: I.mdiBlur,
  'blur-linear': I.mdiBlurLinear,
  'blur-off': I.mdiBlurOff,
  'blur-radial': I.mdiBlurRadial,
  bolt: I.mdiBolt,
  bomb: I.mdiBomb,
  'bomb-off': I.mdiBombOff,
  bone: I.mdiBone,
  'bone-off': I.mdiBoneOff,
  book: I.mdiBook,
  'book-account': I.mdiBookAccount,
  'book-account-outline': I.mdiBookAccountOutline,
  'book-alert': I.mdiBookAlert,
  'book-alert-outline': I.mdiBookAlertOutline,
  'book-alphabet': I.mdiBookAlphabet,
  'book-arrow-down': I.mdiBookArrowDown,
  'book-arrow-down-outline': I.mdiBookArrowDownOutline,
  'book-arrow-left': I.mdiBookArrowLeft,
  'book-arrow-left-outline': I.mdiBookArrowLeftOutline,
  'book-arrow-right': I.mdiBookArrowRight,
  'book-arrow-right-outline': I.mdiBookArrowRightOutline,
  'book-arrow-up': I.mdiBookArrowUp,
  'book-arrow-up-outline': I.mdiBookArrowUpOutline,
  'book-cancel': I.mdiBookCancel,
  'book-cancel-outline': I.mdiBookCancelOutline,
  'book-check': I.mdiBookCheck,
  'book-check-outline': I.mdiBookCheckOutline,
  'book-clock': I.mdiBookClock,
  'book-clock-outline': I.mdiBookClockOutline,
  'book-cog': I.mdiBookCog,
  'book-cog-outline': I.mdiBookCogOutline,
  'book-cross': I.mdiBookCross,
  'book-edit': I.mdiBookEdit,
  'book-edit-outline': I.mdiBookEditOutline,
  'book-education': I.mdiBookEducation,
  'book-education-outline': I.mdiBookEducationOutline,
  'book-heart': I.mdiBookHeart,
  'book-heart-outline': I.mdiBookHeartOutline,
  'book-information-variant': I.mdiBookInformationVariant,
  'book-lock': I.mdiBookLock,
  'book-lock-open': I.mdiBookLockOpen,
  'book-lock-open-outline': I.mdiBookLockOpenOutline,
  'book-lock-outline': I.mdiBookLockOutline,
  'book-marker': I.mdiBookMarker,
  'book-marker-outline': I.mdiBookMarkerOutline,
  'book-minus': I.mdiBookMinus,
  'book-minus-multiple': I.mdiBookMinusMultiple,
  'book-minus-multiple-outline': I.mdiBookMinusMultipleOutline,
  'book-minus-outline': I.mdiBookMinusOutline,
  'book-multiple': I.mdiBookMultiple,
  'book-multiple-outline': I.mdiBookMultipleOutline,
  'book-music': I.mdiBookMusic,
  'book-music-outline': I.mdiBookMusicOutline,
  'book-off': I.mdiBookOff,
  'book-off-outline': I.mdiBookOffOutline,
  'book-open': I.mdiBookOpen,
  'book-open-blank-variant': I.mdiBookOpenBlankVariant,
  'book-open-outline': I.mdiBookOpenOutline,
  'book-open-page-variant': I.mdiBookOpenPageVariant,
  'book-open-page-variant-outline': I.mdiBookOpenPageVariantOutline,
  'book-open-variant': I.mdiBookOpenVariant,
  'book-outline': I.mdiBookOutline,
  'book-play': I.mdiBookPlay,
  'book-play-outline': I.mdiBookPlayOutline,
  'book-plus': I.mdiBookPlus,
  'book-plus-multiple': I.mdiBookPlusMultiple,
  'book-plus-multiple-outline': I.mdiBookPlusMultipleOutline,
  'book-plus-outline': I.mdiBookPlusOutline,
  'book-refresh': I.mdiBookRefresh,
  'book-refresh-outline': I.mdiBookRefreshOutline,
  'book-remove': I.mdiBookRemove,
  'book-remove-multiple': I.mdiBookRemoveMultiple,
  'book-remove-multiple-outline': I.mdiBookRemoveMultipleOutline,
  'book-remove-outline': I.mdiBookRemoveOutline,
  'book-search': I.mdiBookSearch,
  'book-search-outline': I.mdiBookSearchOutline,
  'book-settings': I.mdiBookSettings,
  'book-settings-outline': I.mdiBookSettingsOutline,
  'book-sync': I.mdiBookSync,
  'book-sync-outline': I.mdiBookSyncOutline,
  'book-variant': I.mdiBookVariant,
  bookmark: I.mdiBookmark,
  'bookmark-box': I.mdiBookmarkBox,
  'bookmark-box-multiple': I.mdiBookmarkBoxMultiple,
  'bookmark-box-multiple-outline': I.mdiBookmarkBoxMultipleOutline,
  'bookmark-box-outline': I.mdiBookmarkBoxOutline,
  'bookmark-check': I.mdiBookmarkCheck,
  'bookmark-check-outline': I.mdiBookmarkCheckOutline,
  'bookmark-minus': I.mdiBookmarkMinus,
  'bookmark-minus-outline': I.mdiBookmarkMinusOutline,
  'bookmark-multiple': I.mdiBookmarkMultiple,
  'bookmark-multiple-outline': I.mdiBookmarkMultipleOutline,
  'bookmark-music': I.mdiBookmarkMusic,
  'bookmark-music-outline': I.mdiBookmarkMusicOutline,
  'bookmark-off': I.mdiBookmarkOff,
  'bookmark-off-outline': I.mdiBookmarkOffOutline,
  'bookmark-outline': I.mdiBookmarkOutline,
  'bookmark-plus': I.mdiBookmarkPlus,
  'bookmark-plus-outline': I.mdiBookmarkPlusOutline,
  'bookmark-remove': I.mdiBookmarkRemove,
  'bookmark-remove-outline': I.mdiBookmarkRemoveOutline,
  bookshelf: I.mdiBookshelf,
  'boom-gate': I.mdiBoomGate,
  'boom-gate-alert': I.mdiBoomGateAlert,
  'boom-gate-alert-outline': I.mdiBoomGateAlertOutline,
  'boom-gate-arrow-down': I.mdiBoomGateArrowDown,
  'boom-gate-arrow-down-outline': I.mdiBoomGateArrowDownOutline,
  'boom-gate-arrow-up': I.mdiBoomGateArrowUp,
  'boom-gate-arrow-up-outline': I.mdiBoomGateArrowUpOutline,
  'boom-gate-outline': I.mdiBoomGateOutline,
  'boom-gate-up': I.mdiBoomGateUp,
  'boom-gate-up-outline': I.mdiBoomGateUpOutline,
  boombox: I.mdiBoombox,
  boomerang: I.mdiBoomerang,
  bootstrap: I.mdiBootstrap,
  'border-all': I.mdiBorderAll,
  'border-all-variant': I.mdiBorderAllVariant,
  'border-bottom': I.mdiBorderBottom,
  'border-bottom-variant': I.mdiBorderBottomVariant,
  'border-color': I.mdiBorderColor,
  'border-horizontal': I.mdiBorderHorizontal,
  'border-inside': I.mdiBorderInside,
  'border-left': I.mdiBorderLeft,
  'border-left-variant': I.mdiBorderLeftVariant,
  'border-none': I.mdiBorderNone,
  'border-none-variant': I.mdiBorderNoneVariant,
  'border-outside': I.mdiBorderOutside,
  'border-radius': I.mdiBorderRadius,
  'border-right': I.mdiBorderRight,
  'border-right-variant': I.mdiBorderRightVariant,
  'border-style': I.mdiBorderStyle,
  'border-top': I.mdiBorderTop,
  'border-top-variant': I.mdiBorderTopVariant,
  'border-vertical': I.mdiBorderVertical,
  'bottle-soda': I.mdiBottleSoda,
  'bottle-soda-classic': I.mdiBottleSodaClassic,
  'bottle-soda-classic-outline': I.mdiBottleSodaClassicOutline,
  'bottle-soda-outline': I.mdiBottleSodaOutline,
  'bottle-tonic': I.mdiBottleTonic,
  'bottle-tonic-outline': I.mdiBottleTonicOutline,
  'bottle-tonic-plus': I.mdiBottleTonicPlus,
  'bottle-tonic-plus-outline': I.mdiBottleTonicPlusOutline,
  'bottle-tonic-skull': I.mdiBottleTonicSkull,
  'bottle-tonic-skull-outline': I.mdiBottleTonicSkullOutline,
  'bottle-wine': I.mdiBottleWine,
  'bottle-wine-outline': I.mdiBottleWineOutline,
  'bow-arrow': I.mdiBowArrow,
  'bow-tie': I.mdiBowTie,
  bowl: I.mdiBowl,
  'bowl-mix': I.mdiBowlMix,
  'bowl-mix-outline': I.mdiBowlMixOutline,
  'bowl-outline': I.mdiBowlOutline,
  bowling: I.mdiBowling,
  box: I.mdiBox,
  'box-cutter': I.mdiBoxCutter,
  'box-cutter-off': I.mdiBoxCutterOff,
  'box-shadow': I.mdiBoxShadow,
  'boxing-glove': I.mdiBoxingGlove,
  braille: I.mdiBraille,
  brain: I.mdiBrain,
  'bread-slice': I.mdiBreadSlice,
  'bread-slice-outline': I.mdiBreadSliceOutline,
  bridge: I.mdiBridge,
  briefcase: I.mdiBriefcase,
  'briefcase-account': I.mdiBriefcaseAccount,
  'briefcase-account-outline': I.mdiBriefcaseAccountOutline,
  'briefcase-arrow-left-right': I.mdiBriefcaseArrowLeftRight,
  'briefcase-arrow-left-right-outline': I.mdiBriefcaseArrowLeftRightOutline,
  'briefcase-arrow-up-down': I.mdiBriefcaseArrowUpDown,
  'briefcase-arrow-up-down-outline': I.mdiBriefcaseArrowUpDownOutline,
  'briefcase-check': I.mdiBriefcaseCheck,
  'briefcase-check-outline': I.mdiBriefcaseCheckOutline,
  'briefcase-clock': I.mdiBriefcaseClock,
  'briefcase-clock-outline': I.mdiBriefcaseClockOutline,
  'briefcase-download': I.mdiBriefcaseDownload,
  'briefcase-download-outline': I.mdiBriefcaseDownloadOutline,
  'briefcase-edit': I.mdiBriefcaseEdit,
  'briefcase-edit-outline': I.mdiBriefcaseEditOutline,
  'briefcase-eye': I.mdiBriefcaseEye,
  'briefcase-eye-outline': I.mdiBriefcaseEyeOutline,
  'briefcase-minus': I.mdiBriefcaseMinus,
  'briefcase-minus-outline': I.mdiBriefcaseMinusOutline,
  'briefcase-off': I.mdiBriefcaseOff,
  'briefcase-off-outline': I.mdiBriefcaseOffOutline,
  'briefcase-outline': I.mdiBriefcaseOutline,
  'briefcase-plus': I.mdiBriefcasePlus,
  'briefcase-plus-outline': I.mdiBriefcasePlusOutline,
  'briefcase-remove': I.mdiBriefcaseRemove,
  'briefcase-remove-outline': I.mdiBriefcaseRemoveOutline,
  'briefcase-search': I.mdiBriefcaseSearch,
  'briefcase-search-outline': I.mdiBriefcaseSearchOutline,
  'briefcase-upload': I.mdiBriefcaseUpload,
  'briefcase-upload-outline': I.mdiBriefcaseUploadOutline,
  'briefcase-variant': I.mdiBriefcaseVariant,
  'briefcase-variant-off': I.mdiBriefcaseVariantOff,
  'briefcase-variant-off-outline': I.mdiBriefcaseVariantOffOutline,
  'briefcase-variant-outline': I.mdiBriefcaseVariantOutline,
  'brightness-1': I.mdiBrightness1,
  'brightness-2': I.mdiBrightness2,
  'brightness-3': I.mdiBrightness3,
  'brightness-4': I.mdiBrightness4,
  'brightness-5': I.mdiBrightness5,
  'brightness-6': I.mdiBrightness6,
  'brightness-7': I.mdiBrightness7,
  'brightness-auto': I.mdiBrightnessAuto,
  'brightness-percent': I.mdiBrightnessPercent,
  broadcast: I.mdiBroadcast,
  'broadcast-off': I.mdiBroadcastOff,
  broom: I.mdiBroom,
  brush: I.mdiBrush,
  'brush-off': I.mdiBrushOff,
  'brush-outline': I.mdiBrushOutline,
  'brush-variant': I.mdiBrushVariant,
  bucket: I.mdiBucket,
  'bucket-outline': I.mdiBucketOutline,
  buffet: I.mdiBuffet,
  bug: I.mdiBug,
  'bug-check': I.mdiBugCheck,
  'bug-check-outline': I.mdiBugCheckOutline,
  'bug-outline': I.mdiBugOutline,
  'bug-pause': I.mdiBugPause,
  'bug-pause-outline': I.mdiBugPauseOutline,
  'bug-play': I.mdiBugPlay,
  'bug-play-outline': I.mdiBugPlayOutline,
  'bug-stop': I.mdiBugStop,
  'bug-stop-outline': I.mdiBugStopOutline,
  bugle: I.mdiBugle,
  'bulkhead-light': I.mdiBulkheadLight,
  bulldozer: I.mdiBulldozer,
  bullet: I.mdiBullet,
  'bulletin-board': I.mdiBulletinBoard,
  bullhorn: I.mdiBullhorn,
  'bullhorn-outline': I.mdiBullhornOutline,
  'bullhorn-variant': I.mdiBullhornVariant,
  'bullhorn-variant-outline': I.mdiBullhornVariantOutline,
  bullseye: I.mdiBullseye,
  'bullseye-arrow': I.mdiBullseyeArrow,
  bulma: I.mdiBulma,
  'bunk-bed': I.mdiBunkBed,
  'bunk-bed-outline': I.mdiBunkBedOutline,
  bus: I.mdiBus,
  'bus-alert': I.mdiBusAlert,
  'bus-articulated-end': I.mdiBusArticulatedEnd,
  'bus-articulated-front': I.mdiBusArticulatedFront,
  'bus-clock': I.mdiBusClock,
  'bus-double-decker': I.mdiBusDoubleDecker,
  'bus-electric': I.mdiBusElectric,
  'bus-marker': I.mdiBusMarker,
  'bus-multiple': I.mdiBusMultiple,
  'bus-school': I.mdiBusSchool,
  'bus-side': I.mdiBusSide,
  'bus-stop': I.mdiBusStop,
  'bus-stop-covered': I.mdiBusStopCovered,
  'bus-stop-uncovered': I.mdiBusStopUncovered,
  butterfly: I.mdiButterfly,
  'butterfly-outline': I.mdiButterflyOutline,
  'button-cursor': I.mdiButtonCursor,
  'button-pointer': I.mdiButtonPointer,
  'cabin-a-frame': I.mdiCabinAFrame,
  'cable-data': I.mdiCableData,
  cached: I.mdiCached,
  cactus: I.mdiCactus,
  cake: I.mdiCake,
  'cake-layered': I.mdiCakeLayered,
  'cake-variant': I.mdiCakeVariant,
  'cake-variant-outline': I.mdiCakeVariantOutline,
  calculator: I.mdiCalculator,
  'calculator-variant': I.mdiCalculatorVariant,
  'calculator-variant-outline': I.mdiCalculatorVariantOutline,
  calendar: I.mdiCalendar,
  'calendar-account': I.mdiCalendarAccount,
  'calendar-account-outline': I.mdiCalendarAccountOutline,
  'calendar-alert': I.mdiCalendarAlert,
  'calendar-alert-outline': I.mdiCalendarAlertOutline,
  'calendar-arrow-left': I.mdiCalendarArrowLeft,
  'calendar-arrow-right': I.mdiCalendarArrowRight,
  'calendar-badge': I.mdiCalendarBadge,
  'calendar-badge-outline': I.mdiCalendarBadgeOutline,
  'calendar-blank': I.mdiCalendarBlank,
  'calendar-blank-multiple': I.mdiCalendarBlankMultiple,
  'calendar-blank-outline': I.mdiCalendarBlankOutline,
  'calendar-check': I.mdiCalendarCheck,
  'calendar-check-outline': I.mdiCalendarCheckOutline,
  'calendar-clock': I.mdiCalendarClock,
  'calendar-clock-outline': I.mdiCalendarClockOutline,
  'calendar-collapse-horizontal': I.mdiCalendarCollapseHorizontal,
  'calendar-collapse-horizontal-outline':
    I.mdiCalendarCollapseHorizontalOutline,
  'calendar-cursor': I.mdiCalendarCursor,
  'calendar-cursor-outline': I.mdiCalendarCursorOutline,
  'calendar-edit': I.mdiCalendarEdit,
  'calendar-edit-outline': I.mdiCalendarEditOutline,
  'calendar-end': I.mdiCalendarEnd,
  'calendar-end-outline': I.mdiCalendarEndOutline,
  'calendar-expand-horizontal': I.mdiCalendarExpandHorizontal,
  'calendar-expand-horizontal-outline': I.mdiCalendarExpandHorizontalOutline,
  'calendar-export': I.mdiCalendarExport,
  'calendar-export-outline': I.mdiCalendarExportOutline,
  'calendar-filter': I.mdiCalendarFilter,
  'calendar-filter-outline': I.mdiCalendarFilterOutline,
  'calendar-heart': I.mdiCalendarHeart,
  'calendar-heart-outline': I.mdiCalendarHeartOutline,
  'calendar-import': I.mdiCalendarImport,
  'calendar-import-outline': I.mdiCalendarImportOutline,
  'calendar-lock': I.mdiCalendarLock,
  'calendar-lock-open': I.mdiCalendarLockOpen,
  'calendar-lock-open-outline': I.mdiCalendarLockOpenOutline,
  'calendar-lock-outline': I.mdiCalendarLockOutline,
  'calendar-minus': I.mdiCalendarMinus,
  'calendar-minus-outline': I.mdiCalendarMinusOutline,
  'calendar-month': I.mdiCalendarMonth,
  'calendar-month-outline': I.mdiCalendarMonthOutline,
  'calendar-multiple': I.mdiCalendarMultiple,
  'calendar-multiple-check': I.mdiCalendarMultipleCheck,
  'calendar-multiselect': I.mdiCalendarMultiselect,
  'calendar-multiselect-outline': I.mdiCalendarMultiselectOutline,
  'calendar-outline': I.mdiCalendarOutline,
  'calendar-plus': I.mdiCalendarPlus,
  'calendar-plus-outline': I.mdiCalendarPlusOutline,
  'calendar-question': I.mdiCalendarQuestion,
  'calendar-question-outline': I.mdiCalendarQuestionOutline,
  'calendar-range': I.mdiCalendarRange,
  'calendar-range-outline': I.mdiCalendarRangeOutline,
  'calendar-refresh': I.mdiCalendarRefresh,
  'calendar-refresh-outline': I.mdiCalendarRefreshOutline,
  'calendar-remove': I.mdiCalendarRemove,
  'calendar-remove-outline': I.mdiCalendarRemoveOutline,
  'calendar-search': I.mdiCalendarSearch,
  'calendar-search-outline': I.mdiCalendarSearchOutline,
  'calendar-star': I.mdiCalendarStar,
  'calendar-star-outline': I.mdiCalendarStarOutline,
  'calendar-start': I.mdiCalendarStart,
  'calendar-start-outline': I.mdiCalendarStartOutline,
  'calendar-sync': I.mdiCalendarSync,
  'calendar-sync-outline': I.mdiCalendarSyncOutline,
  'calendar-text': I.mdiCalendarText,
  'calendar-text-outline': I.mdiCalendarTextOutline,
  'calendar-today': I.mdiCalendarToday,
  'calendar-today-outline': I.mdiCalendarTodayOutline,
  'calendar-week': I.mdiCalendarWeek,
  'calendar-week-begin': I.mdiCalendarWeekBegin,
  'calendar-week-begin-outline': I.mdiCalendarWeekBeginOutline,
  'calendar-week-outline': I.mdiCalendarWeekOutline,
  'calendar-weekend': I.mdiCalendarWeekend,
  'calendar-weekend-outline': I.mdiCalendarWeekendOutline,
  'call-made': I.mdiCallMade,
  'call-merge': I.mdiCallMerge,
  'call-missed': I.mdiCallMissed,
  'call-received': I.mdiCallReceived,
  'call-split': I.mdiCallSplit,
  camcorder: I.mdiCamcorder,
  'camcorder-off': I.mdiCamcorderOff,
  camera: I.mdiCamera,
  'camera-account': I.mdiCameraAccount,
  'camera-burst': I.mdiCameraBurst,
  'camera-control': I.mdiCameraControl,
  'camera-document': I.mdiCameraDocument,
  'camera-document-off': I.mdiCameraDocumentOff,
  'camera-enhance': I.mdiCameraEnhance,
  'camera-enhance-outline': I.mdiCameraEnhanceOutline,
  'camera-flip': I.mdiCameraFlip,
  'camera-flip-outline': I.mdiCameraFlipOutline,
  'camera-front': I.mdiCameraFront,
  'camera-front-variant': I.mdiCameraFrontVariant,
  'camera-gopro': I.mdiCameraGopro,
  'camera-image': I.mdiCameraImage,
  'camera-iris': I.mdiCameraIris,
  'camera-lock': I.mdiCameraLock,
  'camera-lock-outline': I.mdiCameraLockOutline,
  'camera-marker': I.mdiCameraMarker,
  'camera-marker-outline': I.mdiCameraMarkerOutline,
  'camera-metering-center': I.mdiCameraMeteringCenter,
  'camera-metering-matrix': I.mdiCameraMeteringMatrix,
  'camera-metering-partial': I.mdiCameraMeteringPartial,
  'camera-metering-spot': I.mdiCameraMeteringSpot,
  'camera-off': I.mdiCameraOff,
  'camera-off-outline': I.mdiCameraOffOutline,
  'camera-outline': I.mdiCameraOutline,
  'camera-party-mode': I.mdiCameraPartyMode,
  'camera-plus': I.mdiCameraPlus,
  'camera-plus-outline': I.mdiCameraPlusOutline,
  'camera-rear': I.mdiCameraRear,
  'camera-rear-variant': I.mdiCameraRearVariant,
  'camera-retake': I.mdiCameraRetake,
  'camera-retake-outline': I.mdiCameraRetakeOutline,
  'camera-switch': I.mdiCameraSwitch,
  'camera-switch-outline': I.mdiCameraSwitchOutline,
  'camera-timer': I.mdiCameraTimer,
  'camera-wireless': I.mdiCameraWireless,
  'camera-wireless-outline': I.mdiCameraWirelessOutline,
  campfire: I.mdiCampfire,
  cancel: I.mdiCancel,
  candelabra: I.mdiCandelabra,
  'candelabra-fire': I.mdiCandelabraFire,
  candle: I.mdiCandle,
  candy: I.mdiCandy,
  'candy-off': I.mdiCandyOff,
  'candy-off-outline': I.mdiCandyOffOutline,
  'candy-outline': I.mdiCandyOutline,
  candycane: I.mdiCandycane,
  cannabis: I.mdiCannabis,
  'cannabis-off': I.mdiCannabisOff,
  'caps-lock': I.mdiCapsLock,
  car: I.mdiCar,
  'car-2-plus': I.mdiCar2Plus,
  'car-3-plus': I.mdiCar3Plus,
  'car-arrow-left': I.mdiCarArrowLeft,
  'car-arrow-right': I.mdiCarArrowRight,
  'car-back': I.mdiCarBack,
  'car-battery': I.mdiCarBattery,
  'car-brake-abs': I.mdiCarBrakeAbs,
  'car-brake-alert': I.mdiCarBrakeAlert,
  'car-brake-fluid-level': I.mdiCarBrakeFluidLevel,
  'car-brake-hold': I.mdiCarBrakeHold,
  'car-brake-low-pressure': I.mdiCarBrakeLowPressure,
  'car-brake-parking': I.mdiCarBrakeParking,
  'car-brake-retarder': I.mdiCarBrakeRetarder,
  'car-brake-temperature': I.mdiCarBrakeTemperature,
  'car-brake-worn-linings': I.mdiCarBrakeWornLinings,
  'car-child-seat': I.mdiCarChildSeat,
  'car-clock': I.mdiCarClock,
  'car-clutch': I.mdiCarClutch,
  'car-cog': I.mdiCarCog,
  'car-connected': I.mdiCarConnected,
  'car-convertible': I.mdiCarConvertible,
  'car-coolant-level': I.mdiCarCoolantLevel,
  'car-cruise-control': I.mdiCarCruiseControl,
  'car-defrost-front': I.mdiCarDefrostFront,
  'car-defrost-rear': I.mdiCarDefrostRear,
  'car-door': I.mdiCarDoor,
  'car-door-lock': I.mdiCarDoorLock,
  'car-electric': I.mdiCarElectric,
  'car-electric-outline': I.mdiCarElectricOutline,
  'car-emergency': I.mdiCarEmergency,
  'car-esp': I.mdiCarEsp,
  'car-estate': I.mdiCarEstate,
  'car-hatchback': I.mdiCarHatchback,
  'car-info': I.mdiCarInfo,
  'car-key': I.mdiCarKey,
  'car-lifted-pickup': I.mdiCarLiftedPickup,
  'car-light-alert': I.mdiCarLightAlert,
  'car-light-dimmed': I.mdiCarLightDimmed,
  'car-light-fog': I.mdiCarLightFog,
  'car-light-high': I.mdiCarLightHigh,
  'car-limousine': I.mdiCarLimousine,
  'car-multiple': I.mdiCarMultiple,
  'car-off': I.mdiCarOff,
  'car-outline': I.mdiCarOutline,
  'car-parking-lights': I.mdiCarParkingLights,
  'car-pickup': I.mdiCarPickup,
  'car-search': I.mdiCarSearch,
  'car-search-outline': I.mdiCarSearchOutline,
  'car-seat': I.mdiCarSeat,
  'car-seat-cooler': I.mdiCarSeatCooler,
  'car-seat-heater': I.mdiCarSeatHeater,
  'car-select': I.mdiCarSelect,
  'car-settings': I.mdiCarSettings,
  'car-shift-pattern': I.mdiCarShiftPattern,
  'car-side': I.mdiCarSide,
  'car-speed-limiter': I.mdiCarSpeedLimiter,
  'car-sports': I.mdiCarSports,
  'car-tire-alert': I.mdiCarTireAlert,
  'car-traction-control': I.mdiCarTractionControl,
  'car-turbocharger': I.mdiCarTurbocharger,
  'car-wash': I.mdiCarWash,
  'car-windshield': I.mdiCarWindshield,
  'car-windshield-outline': I.mdiCarWindshieldOutline,
  'car-wireless': I.mdiCarWireless,
  'car-wrench': I.mdiCarWrench,
  carabiner: I.mdiCarabiner,
  caravan: I.mdiCaravan,
  card: I.mdiCard,
  'card-account-details': I.mdiCardAccountDetails,
  'card-account-details-outline': I.mdiCardAccountDetailsOutline,
  'card-account-details-star': I.mdiCardAccountDetailsStar,
  'card-account-details-star-outline': I.mdiCardAccountDetailsStarOutline,
  'card-account-mail': I.mdiCardAccountMail,
  'card-account-mail-outline': I.mdiCardAccountMailOutline,
  'card-account-phone': I.mdiCardAccountPhone,
  'card-account-phone-outline': I.mdiCardAccountPhoneOutline,
  'card-bulleted': I.mdiCardBulleted,
  'card-bulleted-off': I.mdiCardBulletedOff,
  'card-bulleted-off-outline': I.mdiCardBulletedOffOutline,
  'card-bulleted-outline': I.mdiCardBulletedOutline,
  'card-bulleted-settings': I.mdiCardBulletedSettings,
  'card-bulleted-settings-outline': I.mdiCardBulletedSettingsOutline,
  'card-minus': I.mdiCardMinus,
  'card-minus-outline': I.mdiCardMinusOutline,
  'card-multiple': I.mdiCardMultiple,
  'card-multiple-outline': I.mdiCardMultipleOutline,
  'card-off': I.mdiCardOff,
  'card-off-outline': I.mdiCardOffOutline,
  'card-outline': I.mdiCardOutline,
  'card-plus': I.mdiCardPlus,
  'card-plus-outline': I.mdiCardPlusOutline,
  'card-remove': I.mdiCardRemove,
  'card-remove-outline': I.mdiCardRemoveOutline,
  'card-search': I.mdiCardSearch,
  'card-search-outline': I.mdiCardSearchOutline,
  'card-text': I.mdiCardText,
  'card-text-outline': I.mdiCardTextOutline,
  cards: I.mdiCards,
  'cards-club': I.mdiCardsClub,
  'cards-club-outline': I.mdiCardsClubOutline,
  'cards-diamond': I.mdiCardsDiamond,
  'cards-diamond-outline': I.mdiCardsDiamondOutline,
  'cards-heart': I.mdiCardsHeart,
  'cards-heart-outline': I.mdiCardsHeartOutline,
  'cards-outline': I.mdiCardsOutline,
  'cards-playing': I.mdiCardsPlaying,
  'cards-playing-club': I.mdiCardsPlayingClub,
  'cards-playing-club-multiple': I.mdiCardsPlayingClubMultiple,
  'cards-playing-club-multiple-outline': I.mdiCardsPlayingClubMultipleOutline,
  'cards-playing-club-outline': I.mdiCardsPlayingClubOutline,
  'cards-playing-diamond': I.mdiCardsPlayingDiamond,
  'cards-playing-diamond-multiple': I.mdiCardsPlayingDiamondMultiple,
  'cards-playing-diamond-multiple-outline':
    I.mdiCardsPlayingDiamondMultipleOutline,
  'cards-playing-diamond-outline': I.mdiCardsPlayingDiamondOutline,
  'cards-playing-heart': I.mdiCardsPlayingHeart,
  'cards-playing-heart-multiple': I.mdiCardsPlayingHeartMultiple,
  'cards-playing-heart-multiple-outline': I.mdiCardsPlayingHeartMultipleOutline,
  'cards-playing-heart-outline': I.mdiCardsPlayingHeartOutline,
  'cards-playing-outline': I.mdiCardsPlayingOutline,
  'cards-playing-spade': I.mdiCardsPlayingSpade,
  'cards-playing-spade-multiple': I.mdiCardsPlayingSpadeMultiple,
  'cards-playing-spade-multiple-outline': I.mdiCardsPlayingSpadeMultipleOutline,
  'cards-playing-spade-outline': I.mdiCardsPlayingSpadeOutline,
  'cards-spade': I.mdiCardsSpade,
  'cards-spade-outline': I.mdiCardsSpadeOutline,
  'cards-variant': I.mdiCardsVariant,
  carrot: I.mdiCarrot,
  cart: I.mdiCart,
  'cart-arrow-down': I.mdiCartArrowDown,
  'cart-arrow-right': I.mdiCartArrowRight,
  'cart-arrow-up': I.mdiCartArrowUp,
  'cart-check': I.mdiCartCheck,
  'cart-heart': I.mdiCartHeart,
  'cart-minus': I.mdiCartMinus,
  'cart-off': I.mdiCartOff,
  'cart-outline': I.mdiCartOutline,
  'cart-percent': I.mdiCartPercent,
  'cart-plus': I.mdiCartPlus,
  'cart-remove': I.mdiCartRemove,
  'cart-variant': I.mdiCartVariant,
  'case-sensitive-alt': I.mdiCaseSensitiveAlt,
  cash: I.mdiCash,
  'cash-100': I.mdiCash100,
  'cash-check': I.mdiCashCheck,
  'cash-clock': I.mdiCashClock,
  'cash-fast': I.mdiCashFast,
  'cash-lock': I.mdiCashLock,
  'cash-lock-open': I.mdiCashLockOpen,
  'cash-marker': I.mdiCashMarker,
  'cash-minus': I.mdiCashMinus,
  'cash-multiple': I.mdiCashMultiple,
  'cash-plus': I.mdiCashPlus,
  'cash-refund': I.mdiCashRefund,
  'cash-register': I.mdiCashRegister,
  'cash-remove': I.mdiCashRemove,
  'cash-sync': I.mdiCashSync,
  cassette: I.mdiCassette,
  cast: I.mdiCast,
  'cast-audio': I.mdiCastAudio,
  'cast-audio-variant': I.mdiCastAudioVariant,
  'cast-connected': I.mdiCastConnected,
  'cast-education': I.mdiCastEducation,
  'cast-off': I.mdiCastOff,
  'cast-variant': I.mdiCastVariant,
  castle: I.mdiCastle,
  cat: I.mdiCat,
  cctv: I.mdiCctv,
  'cctv-off': I.mdiCctvOff,
  'ceiling-fan': I.mdiCeilingFan,
  'ceiling-fan-light': I.mdiCeilingFanLight,
  'ceiling-light': I.mdiCeilingLight,
  'ceiling-light-multiple': I.mdiCeilingLightMultiple,
  'ceiling-light-multiple-outline': I.mdiCeilingLightMultipleOutline,
  'ceiling-light-outline': I.mdiCeilingLightOutline,
  cellphone: I.mdiCellphone,
  'cellphone-arrow-down': I.mdiCellphoneArrowDown,
  'cellphone-arrow-down-variant': I.mdiCellphoneArrowDownVariant,
  'cellphone-basic': I.mdiCellphoneBasic,
  'cellphone-charging': I.mdiCellphoneCharging,
  'cellphone-check': I.mdiCellphoneCheck,
  'cellphone-cog': I.mdiCellphoneCog,
  'cellphone-dock': I.mdiCellphoneDock,
  'cellphone-information': I.mdiCellphoneInformation,
  'cellphone-key': I.mdiCellphoneKey,
  'cellphone-link': I.mdiCellphoneLink,
  'cellphone-link-off': I.mdiCellphoneLinkOff,
  'cellphone-lock': I.mdiCellphoneLock,
  'cellphone-marker': I.mdiCellphoneMarker,
  'cellphone-message': I.mdiCellphoneMessage,
  'cellphone-message-off': I.mdiCellphoneMessageOff,
  'cellphone-nfc': I.mdiCellphoneNfc,
  'cellphone-nfc-off': I.mdiCellphoneNfcOff,
  'cellphone-off': I.mdiCellphoneOff,
  'cellphone-play': I.mdiCellphonePlay,
  'cellphone-remove': I.mdiCellphoneRemove,
  'cellphone-screenshot': I.mdiCellphoneScreenshot,
  'cellphone-settings': I.mdiCellphoneSettings,
  'cellphone-sound': I.mdiCellphoneSound,
  'cellphone-text': I.mdiCellphoneText,
  'cellphone-wireless': I.mdiCellphoneWireless,
  centos: I.mdiCentos,
  certificate: I.mdiCertificate,
  'certificate-outline': I.mdiCertificateOutline,
  'chair-rolling': I.mdiChairRolling,
  'chair-school': I.mdiChairSchool,
  chandelier: I.mdiChandelier,
  charity: I.mdiCharity,
  'chart-arc': I.mdiChartArc,
  'chart-areaspline': I.mdiChartAreaspline,
  'chart-areaspline-variant': I.mdiChartAreasplineVariant,
  'chart-bar': I.mdiChartBar,
  'chart-bar-stacked': I.mdiChartBarStacked,
  'chart-bell-curve': I.mdiChartBellCurve,
  'chart-bell-curve-cumulative': I.mdiChartBellCurveCumulative,
  'chart-box': I.mdiChartBox,
  'chart-box-outline': I.mdiChartBoxOutline,
  'chart-box-plus-outline': I.mdiChartBoxPlusOutline,
  'chart-bubble': I.mdiChartBubble,
  'chart-donut': I.mdiChartDonut,
  'chart-donut-variant': I.mdiChartDonutVariant,
  'chart-gantt': I.mdiChartGantt,
  'chart-histogram': I.mdiChartHistogram,
  'chart-line': I.mdiChartLine,
  'chart-line-stacked': I.mdiChartLineStacked,
  'chart-line-variant': I.mdiChartLineVariant,
  'chart-multiline': I.mdiChartMultiline,
  'chart-multiple': I.mdiChartMultiple,
  'chart-pie': I.mdiChartPie,
  'chart-ppf': I.mdiChartPpf,
  'chart-sankey': I.mdiChartSankey,
  'chart-sankey-variant': I.mdiChartSankeyVariant,
  'chart-scatter-plot': I.mdiChartScatterPlot,
  'chart-scatter-plot-hexbin': I.mdiChartScatterPlotHexbin,
  'chart-timeline': I.mdiChartTimeline,
  'chart-timeline-variant': I.mdiChartTimelineVariant,
  'chart-timeline-variant-shimmer': I.mdiChartTimelineVariantShimmer,
  'chart-tree': I.mdiChartTree,
  'chart-waterfall': I.mdiChartWaterfall,
  chat: I.mdiChat,
  'chat-alert': I.mdiChatAlert,
  'chat-alert-outline': I.mdiChatAlertOutline,
  'chat-minus': I.mdiChatMinus,
  'chat-minus-outline': I.mdiChatMinusOutline,
  'chat-outline': I.mdiChatOutline,
  'chat-plus': I.mdiChatPlus,
  'chat-plus-outline': I.mdiChatPlusOutline,
  'chat-processing': I.mdiChatProcessing,
  'chat-processing-outline': I.mdiChatProcessingOutline,
  'chat-question': I.mdiChatQuestion,
  'chat-question-outline': I.mdiChatQuestionOutline,
  'chat-remove': I.mdiChatRemove,
  'chat-remove-outline': I.mdiChatRemoveOutline,
  'chat-sleep': I.mdiChatSleep,
  'chat-sleep-outline': I.mdiChatSleepOutline,
  check: I.mdiCheck,
  'check-all': I.mdiCheckAll,
  'check-bold': I.mdiCheckBold,
  'check-circle': I.mdiCheckCircle,
  'check-circle-outline': I.mdiCheckCircleOutline,
  'check-decagram': I.mdiCheckDecagram,
  'check-decagram-outline': I.mdiCheckDecagramOutline,
  'check-network': I.mdiCheckNetwork,
  'check-network-outline': I.mdiCheckNetworkOutline,
  'check-outline': I.mdiCheckOutline,
  'check-underline': I.mdiCheckUnderline,
  'check-underline-circle': I.mdiCheckUnderlineCircle,
  'check-underline-circle-outline': I.mdiCheckUnderlineCircleOutline,
  checkbook: I.mdiCheckbook,
  'checkbox-blank': I.mdiCheckboxBlank,
  'checkbox-blank-badge': I.mdiCheckboxBlankBadge,
  'checkbox-blank-badge-outline': I.mdiCheckboxBlankBadgeOutline,
  'checkbox-blank-circle': I.mdiCheckboxBlankCircle,
  'checkbox-blank-circle-outline': I.mdiCheckboxBlankCircleOutline,
  'checkbox-blank-off': I.mdiCheckboxBlankOff,
  'checkbox-blank-off-outline': I.mdiCheckboxBlankOffOutline,
  'checkbox-blank-outline': I.mdiCheckboxBlankOutline,
  'checkbox-intermediate': I.mdiCheckboxIntermediate,
  'checkbox-intermediate-variant': I.mdiCheckboxIntermediateVariant,
  'checkbox-marked': I.mdiCheckboxMarked,
  'checkbox-marked-circle': I.mdiCheckboxMarkedCircle,
  'checkbox-marked-circle-outline': I.mdiCheckboxMarkedCircleOutline,
  'checkbox-marked-circle-plus-outline': I.mdiCheckboxMarkedCirclePlusOutline,
  'checkbox-marked-outline': I.mdiCheckboxMarkedOutline,
  'checkbox-multiple-blank': I.mdiCheckboxMultipleBlank,
  'checkbox-multiple-blank-circle': I.mdiCheckboxMultipleBlankCircle,
  'checkbox-multiple-blank-circle-outline':
    I.mdiCheckboxMultipleBlankCircleOutline,
  'checkbox-multiple-blank-outline': I.mdiCheckboxMultipleBlankOutline,
  'checkbox-multiple-marked': I.mdiCheckboxMultipleMarked,
  'checkbox-multiple-marked-circle': I.mdiCheckboxMultipleMarkedCircle,
  'checkbox-multiple-marked-circle-outline':
    I.mdiCheckboxMultipleMarkedCircleOutline,
  'checkbox-multiple-marked-outline': I.mdiCheckboxMultipleMarkedOutline,
  'checkbox-multiple-outline': I.mdiCheckboxMultipleOutline,
  'checkbox-outline': I.mdiCheckboxOutline,
  checkerboard: I.mdiCheckerboard,
  'checkerboard-minus': I.mdiCheckerboardMinus,
  'checkerboard-plus': I.mdiCheckerboardPlus,
  'checkerboard-remove': I.mdiCheckerboardRemove,
  cheese: I.mdiCheese,
  'cheese-off': I.mdiCheeseOff,
  'chef-hat': I.mdiChefHat,
  'chemical-weapon': I.mdiChemicalWeapon,
  'chess-bishop': I.mdiChessBishop,
  'chess-king': I.mdiChessKing,
  'chess-knight': I.mdiChessKnight,
  'chess-pawn': I.mdiChessPawn,
  'chess-queen': I.mdiChessQueen,
  'chess-rook': I.mdiChessRook,
  'chevron-double-down': I.mdiChevronDoubleDown,
  'chevron-double-left': I.mdiChevronDoubleLeft,
  'chevron-double-right': I.mdiChevronDoubleRight,
  'chevron-double-up': I.mdiChevronDoubleUp,
  'chevron-down': I.mdiChevronDown,
  'chevron-down-box': I.mdiChevronDownBox,
  'chevron-down-box-outline': I.mdiChevronDownBoxOutline,
  'chevron-down-circle': I.mdiChevronDownCircle,
  'chevron-down-circle-outline': I.mdiChevronDownCircleOutline,
  'chevron-left': I.mdiChevronLeft,
  'chevron-left-box': I.mdiChevronLeftBox,
  'chevron-left-box-outline': I.mdiChevronLeftBoxOutline,
  'chevron-left-circle': I.mdiChevronLeftCircle,
  'chevron-left-circle-outline': I.mdiChevronLeftCircleOutline,
  'chevron-right': I.mdiChevronRight,
  'chevron-right-box': I.mdiChevronRightBox,
  'chevron-right-box-outline': I.mdiChevronRightBoxOutline,
  'chevron-right-circle': I.mdiChevronRightCircle,
  'chevron-right-circle-outline': I.mdiChevronRightCircleOutline,
  'chevron-triple-down': I.mdiChevronTripleDown,
  'chevron-triple-left': I.mdiChevronTripleLeft,
  'chevron-triple-right': I.mdiChevronTripleRight,
  'chevron-triple-up': I.mdiChevronTripleUp,
  'chevron-up': I.mdiChevronUp,
  'chevron-up-box': I.mdiChevronUpBox,
  'chevron-up-box-outline': I.mdiChevronUpBoxOutline,
  'chevron-up-circle': I.mdiChevronUpCircle,
  'chevron-up-circle-outline': I.mdiChevronUpCircleOutline,
  'chili-alert': I.mdiChiliAlert,
  'chili-alert-outline': I.mdiChiliAlertOutline,
  'chili-hot': I.mdiChiliHot,
  'chili-hot-outline': I.mdiChiliHotOutline,
  'chili-medium': I.mdiChiliMedium,
  'chili-medium-outline': I.mdiChiliMediumOutline,
  'chili-mild': I.mdiChiliMild,
  'chili-mild-outline': I.mdiChiliMildOutline,
  'chili-off': I.mdiChiliOff,
  'chili-off-outline': I.mdiChiliOffOutline,
  chip: I.mdiChip,
  church: I.mdiChurch,
  'church-outline': I.mdiChurchOutline,
  cigar: I.mdiCigar,
  'cigar-off': I.mdiCigarOff,
  circle: I.mdiCircle,
  'circle-box': I.mdiCircleBox,
  'circle-box-outline': I.mdiCircleBoxOutline,
  'circle-double': I.mdiCircleDouble,
  'circle-edit-outline': I.mdiCircleEditOutline,
  'circle-expand': I.mdiCircleExpand,
  'circle-half': I.mdiCircleHalf,
  'circle-half-full': I.mdiCircleHalfFull,
  'circle-medium': I.mdiCircleMedium,
  'circle-multiple': I.mdiCircleMultiple,
  'circle-multiple-outline': I.mdiCircleMultipleOutline,
  'circle-off-outline': I.mdiCircleOffOutline,
  'circle-opacity': I.mdiCircleOpacity,
  'circle-outline': I.mdiCircleOutline,
  'circle-slice-1': I.mdiCircleSlice1,
  'circle-slice-2': I.mdiCircleSlice2,
  'circle-slice-3': I.mdiCircleSlice3,
  'circle-slice-4': I.mdiCircleSlice4,
  'circle-slice-5': I.mdiCircleSlice5,
  'circle-slice-6': I.mdiCircleSlice6,
  'circle-slice-7': I.mdiCircleSlice7,
  'circle-slice-8': I.mdiCircleSlice8,
  'circle-small': I.mdiCircleSmall,
  'circular-saw': I.mdiCircularSaw,
  city: I.mdiCity,
  'city-variant': I.mdiCityVariant,
  'city-variant-outline': I.mdiCityVariantOutline,
  clipboard: I.mdiClipboard,
  'clipboard-account': I.mdiClipboardAccount,
  'clipboard-account-outline': I.mdiClipboardAccountOutline,
  'clipboard-alert': I.mdiClipboardAlert,
  'clipboard-alert-outline': I.mdiClipboardAlertOutline,
  'clipboard-arrow-down': I.mdiClipboardArrowDown,
  'clipboard-arrow-down-outline': I.mdiClipboardArrowDownOutline,
  'clipboard-arrow-left': I.mdiClipboardArrowLeft,
  'clipboard-arrow-left-outline': I.mdiClipboardArrowLeftOutline,
  'clipboard-arrow-right': I.mdiClipboardArrowRight,
  'clipboard-arrow-right-outline': I.mdiClipboardArrowRightOutline,
  'clipboard-arrow-up': I.mdiClipboardArrowUp,
  'clipboard-arrow-up-outline': I.mdiClipboardArrowUpOutline,
  'clipboard-check': I.mdiClipboardCheck,
  'clipboard-check-multiple': I.mdiClipboardCheckMultiple,
  'clipboard-check-multiple-outline': I.mdiClipboardCheckMultipleOutline,
  'clipboard-check-outline': I.mdiClipboardCheckOutline,
  'clipboard-clock': I.mdiClipboardClock,
  'clipboard-clock-outline': I.mdiClipboardClockOutline,
  'clipboard-edit': I.mdiClipboardEdit,
  'clipboard-edit-outline': I.mdiClipboardEditOutline,
  'clipboard-file': I.mdiClipboardFile,
  'clipboard-file-outline': I.mdiClipboardFileOutline,
  'clipboard-flow': I.mdiClipboardFlow,
  'clipboard-flow-outline': I.mdiClipboardFlowOutline,
  'clipboard-list': I.mdiClipboardList,
  'clipboard-list-outline': I.mdiClipboardListOutline,
  'clipboard-minus': I.mdiClipboardMinus,
  'clipboard-minus-outline': I.mdiClipboardMinusOutline,
  'clipboard-multiple': I.mdiClipboardMultiple,
  'clipboard-multiple-outline': I.mdiClipboardMultipleOutline,
  'clipboard-off': I.mdiClipboardOff,
  'clipboard-off-outline': I.mdiClipboardOffOutline,
  'clipboard-outline': I.mdiClipboardOutline,
  'clipboard-play': I.mdiClipboardPlay,
  'clipboard-play-multiple': I.mdiClipboardPlayMultiple,
  'clipboard-play-multiple-outline': I.mdiClipboardPlayMultipleOutline,
  'clipboard-play-outline': I.mdiClipboardPlayOutline,
  'clipboard-plus': I.mdiClipboardPlus,
  'clipboard-plus-outline': I.mdiClipboardPlusOutline,
  'clipboard-pulse': I.mdiClipboardPulse,
  'clipboard-pulse-outline': I.mdiClipboardPulseOutline,
  'clipboard-remove': I.mdiClipboardRemove,
  'clipboard-remove-outline': I.mdiClipboardRemoveOutline,
  'clipboard-search': I.mdiClipboardSearch,
  'clipboard-search-outline': I.mdiClipboardSearchOutline,
  'clipboard-text': I.mdiClipboardText,
  'clipboard-text-clock': I.mdiClipboardTextClock,
  'clipboard-text-clock-outline': I.mdiClipboardTextClockOutline,
  'clipboard-text-multiple': I.mdiClipboardTextMultiple,
  'clipboard-text-multiple-outline': I.mdiClipboardTextMultipleOutline,
  'clipboard-text-off': I.mdiClipboardTextOff,
  'clipboard-text-off-outline': I.mdiClipboardTextOffOutline,
  'clipboard-text-outline': I.mdiClipboardTextOutline,
  'clipboard-text-play': I.mdiClipboardTextPlay,
  'clipboard-text-play-outline': I.mdiClipboardTextPlayOutline,
  'clipboard-text-search': I.mdiClipboardTextSearch,
  'clipboard-text-search-outline': I.mdiClipboardTextSearchOutline,
  clippy: I.mdiClippy,
  clock: I.mdiClock,
  'clock-alert': I.mdiClockAlert,
  'clock-alert-outline': I.mdiClockAlertOutline,
  'clock-check': I.mdiClockCheck,
  'clock-check-outline': I.mdiClockCheckOutline,
  'clock-digital': I.mdiClockDigital,
  'clock-edit': I.mdiClockEdit,
  'clock-edit-outline': I.mdiClockEditOutline,
  'clock-end': I.mdiClockEnd,
  'clock-fast': I.mdiClockFast,
  'clock-in': I.mdiClockIn,
  'clock-minus': I.mdiClockMinus,
  'clock-minus-outline': I.mdiClockMinusOutline,
  'clock-out': I.mdiClockOut,
  'clock-outline': I.mdiClockOutline,
  'clock-plus': I.mdiClockPlus,
  'clock-plus-outline': I.mdiClockPlusOutline,
  'clock-remove': I.mdiClockRemove,
  'clock-remove-outline': I.mdiClockRemoveOutline,
  'clock-start': I.mdiClockStart,
  'clock-time-eight': I.mdiClockTimeEight,
  'clock-time-eight-outline': I.mdiClockTimeEightOutline,
  'clock-time-eleven': I.mdiClockTimeEleven,
  'clock-time-eleven-outline': I.mdiClockTimeElevenOutline,
  'clock-time-five': I.mdiClockTimeFive,
  'clock-time-five-outline': I.mdiClockTimeFiveOutline,
  'clock-time-four': I.mdiClockTimeFour,
  'clock-time-four-outline': I.mdiClockTimeFourOutline,
  'clock-time-nine': I.mdiClockTimeNine,
  'clock-time-nine-outline': I.mdiClockTimeNineOutline,
  'clock-time-one': I.mdiClockTimeOne,
  'clock-time-one-outline': I.mdiClockTimeOneOutline,
  'clock-time-seven': I.mdiClockTimeSeven,
  'clock-time-seven-outline': I.mdiClockTimeSevenOutline,
  'clock-time-six': I.mdiClockTimeSix,
  'clock-time-six-outline': I.mdiClockTimeSixOutline,
  'clock-time-ten': I.mdiClockTimeTen,
  'clock-time-ten-outline': I.mdiClockTimeTenOutline,
  'clock-time-three': I.mdiClockTimeThree,
  'clock-time-three-outline': I.mdiClockTimeThreeOutline,
  'clock-time-twelve': I.mdiClockTimeTwelve,
  'clock-time-twelve-outline': I.mdiClockTimeTwelveOutline,
  'clock-time-two': I.mdiClockTimeTwo,
  'clock-time-two-outline': I.mdiClockTimeTwoOutline,
  close: I.mdiClose,
  'close-box': I.mdiCloseBox,
  'close-box-multiple': I.mdiCloseBoxMultiple,
  'close-box-multiple-outline': I.mdiCloseBoxMultipleOutline,
  'close-box-outline': I.mdiCloseBoxOutline,
  'close-circle': I.mdiCloseCircle,
  'close-circle-multiple': I.mdiCloseCircleMultiple,
  'close-circle-multiple-outline': I.mdiCloseCircleMultipleOutline,
  'close-circle-outline': I.mdiCloseCircleOutline,
  'close-network': I.mdiCloseNetwork,
  'close-network-outline': I.mdiCloseNetworkOutline,
  'close-octagon': I.mdiCloseOctagon,
  'close-octagon-outline': I.mdiCloseOctagonOutline,
  'close-outline': I.mdiCloseOutline,
  'close-thick': I.mdiCloseThick,
  'closed-caption': I.mdiClosedCaption,
  'closed-caption-outline': I.mdiClosedCaptionOutline,
  cloud: I.mdiCloud,
  'cloud-alert': I.mdiCloudAlert,
  'cloud-braces': I.mdiCloudBraces,
  'cloud-check': I.mdiCloudCheck,
  'cloud-check-outline': I.mdiCloudCheckOutline,
  'cloud-circle': I.mdiCloudCircle,
  'cloud-download': I.mdiCloudDownload,
  'cloud-download-outline': I.mdiCloudDownloadOutline,
  'cloud-lock': I.mdiCloudLock,
  'cloud-lock-outline': I.mdiCloudLockOutline,
  'cloud-off-outline': I.mdiCloudOffOutline,
  'cloud-outline': I.mdiCloudOutline,
  'cloud-percent': I.mdiCloudPercent,
  'cloud-percent-outline': I.mdiCloudPercentOutline,
  'cloud-print': I.mdiCloudPrint,
  'cloud-print-outline': I.mdiCloudPrintOutline,
  'cloud-question': I.mdiCloudQuestion,
  'cloud-refresh': I.mdiCloudRefresh,
  'cloud-search': I.mdiCloudSearch,
  'cloud-search-outline': I.mdiCloudSearchOutline,
  'cloud-sync': I.mdiCloudSync,
  'cloud-sync-outline': I.mdiCloudSyncOutline,
  'cloud-tags': I.mdiCloudTags,
  'cloud-upload': I.mdiCloudUpload,
  'cloud-upload-outline': I.mdiCloudUploadOutline,
  clouds: I.mdiClouds,
  clover: I.mdiClover,
  'coach-lamp': I.mdiCoachLamp,
  'coach-lamp-variant': I.mdiCoachLampVariant,
  'coat-rack': I.mdiCoatRack,
  'code-array': I.mdiCodeArray,
  'code-braces': I.mdiCodeBraces,
  'code-braces-box': I.mdiCodeBracesBox,
  'code-brackets': I.mdiCodeBrackets,
  'code-equal': I.mdiCodeEqual,
  'code-greater-than': I.mdiCodeGreaterThan,
  'code-greater-than-or-equal': I.mdiCodeGreaterThanOrEqual,
  'code-json': I.mdiCodeJson,
  'code-less-than': I.mdiCodeLessThan,
  'code-less-than-or-equal': I.mdiCodeLessThanOrEqual,
  'code-not-equal': I.mdiCodeNotEqual,
  'code-not-equal-variant': I.mdiCodeNotEqualVariant,
  'code-parentheses': I.mdiCodeParentheses,
  'code-parentheses-box': I.mdiCodeParenthesesBox,
  'code-string': I.mdiCodeString,
  'code-tags': I.mdiCodeTags,
  'code-tags-check': I.mdiCodeTagsCheck,
  codepen: I.mdiCodepen,
  coffee: I.mdiCoffee,
  'coffee-maker': I.mdiCoffeeMaker,
  'coffee-maker-check': I.mdiCoffeeMakerCheck,
  'coffee-maker-check-outline': I.mdiCoffeeMakerCheckOutline,
  'coffee-maker-outline': I.mdiCoffeeMakerOutline,
  'coffee-off': I.mdiCoffeeOff,
  'coffee-off-outline': I.mdiCoffeeOffOutline,
  'coffee-outline': I.mdiCoffeeOutline,
  'coffee-to-go': I.mdiCoffeeToGo,
  'coffee-to-go-outline': I.mdiCoffeeToGoOutline,
  coffin: I.mdiCoffin,
  cog: I.mdiCog,
  'cog-box': I.mdiCogBox,
  'cog-clockwise': I.mdiCogClockwise,
  'cog-counterclockwise': I.mdiCogCounterclockwise,
  'cog-off': I.mdiCogOff,
  'cog-off-outline': I.mdiCogOffOutline,
  'cog-outline': I.mdiCogOutline,
  'cog-pause': I.mdiCogPause,
  'cog-pause-outline': I.mdiCogPauseOutline,
  'cog-play': I.mdiCogPlay,
  'cog-play-outline': I.mdiCogPlayOutline,
  'cog-refresh': I.mdiCogRefresh,
  'cog-refresh-outline': I.mdiCogRefreshOutline,
  'cog-stop': I.mdiCogStop,
  'cog-stop-outline': I.mdiCogStopOutline,
  'cog-sync': I.mdiCogSync,
  'cog-sync-outline': I.mdiCogSyncOutline,
  'cog-transfer': I.mdiCogTransfer,
  'cog-transfer-outline': I.mdiCogTransferOutline,
  cogs: I.mdiCogs,
  collage: I.mdiCollage,
  'collapse-all': I.mdiCollapseAll,
  'collapse-all-outline': I.mdiCollapseAllOutline,
  'color-helper': I.mdiColorHelper,
  comma: I.mdiComma,
  'comma-box': I.mdiCommaBox,
  'comma-box-outline': I.mdiCommaBoxOutline,
  'comma-circle': I.mdiCommaCircle,
  'comma-circle-outline': I.mdiCommaCircleOutline,
  comment: I.mdiComment,
  'comment-account': I.mdiCommentAccount,
  'comment-account-outline': I.mdiCommentAccountOutline,
  'comment-alert': I.mdiCommentAlert,
  'comment-alert-outline': I.mdiCommentAlertOutline,
  'comment-arrow-left': I.mdiCommentArrowLeft,
  'comment-arrow-left-outline': I.mdiCommentArrowLeftOutline,
  'comment-arrow-right': I.mdiCommentArrowRight,
  'comment-arrow-right-outline': I.mdiCommentArrowRightOutline,
  'comment-bookmark': I.mdiCommentBookmark,
  'comment-bookmark-outline': I.mdiCommentBookmarkOutline,
  'comment-check': I.mdiCommentCheck,
  'comment-check-outline': I.mdiCommentCheckOutline,
  'comment-edit': I.mdiCommentEdit,
  'comment-edit-outline': I.mdiCommentEditOutline,
  'comment-eye': I.mdiCommentEye,
  'comment-eye-outline': I.mdiCommentEyeOutline,
  'comment-flash': I.mdiCommentFlash,
  'comment-flash-outline': I.mdiCommentFlashOutline,
  'comment-minus': I.mdiCommentMinus,
  'comment-minus-outline': I.mdiCommentMinusOutline,
  'comment-multiple': I.mdiCommentMultiple,
  'comment-multiple-outline': I.mdiCommentMultipleOutline,
  'comment-off': I.mdiCommentOff,
  'comment-off-outline': I.mdiCommentOffOutline,
  'comment-outline': I.mdiCommentOutline,
  'comment-plus': I.mdiCommentPlus,
  'comment-plus-outline': I.mdiCommentPlusOutline,
  'comment-processing': I.mdiCommentProcessing,
  'comment-processing-outline': I.mdiCommentProcessingOutline,
  'comment-question': I.mdiCommentQuestion,
  'comment-question-outline': I.mdiCommentQuestionOutline,
  'comment-quote': I.mdiCommentQuote,
  'comment-quote-outline': I.mdiCommentQuoteOutline,
  'comment-remove': I.mdiCommentRemove,
  'comment-remove-outline': I.mdiCommentRemoveOutline,
  'comment-search': I.mdiCommentSearch,
  'comment-search-outline': I.mdiCommentSearchOutline,
  'comment-text': I.mdiCommentText,
  'comment-text-multiple': I.mdiCommentTextMultiple,
  'comment-text-multiple-outline': I.mdiCommentTextMultipleOutline,
  'comment-text-outline': I.mdiCommentTextOutline,
  compare: I.mdiCompare,
  'compare-horizontal': I.mdiCompareHorizontal,
  'compare-remove': I.mdiCompareRemove,
  'compare-vertical': I.mdiCompareVertical,
  compass: I.mdiCompass,
  'compass-off': I.mdiCompassOff,
  'compass-off-outline': I.mdiCompassOffOutline,
  'compass-outline': I.mdiCompassOutline,
  'compass-rose': I.mdiCompassRose,
  compost: I.mdiCompost,
  cone: I.mdiCone,
  'cone-off': I.mdiConeOff,
  connection: I.mdiConnection,
  console: I.mdiConsole,
  'console-line': I.mdiConsoleLine,
  'console-network': I.mdiConsoleNetwork,
  'console-network-outline': I.mdiConsoleNetworkOutline,
  consolidate: I.mdiConsolidate,
  'contactless-payment': I.mdiContactlessPayment,
  'contactless-payment-circle': I.mdiContactlessPaymentCircle,
  'contactless-payment-circle-outline': I.mdiContactlessPaymentCircleOutline,
  contacts: I.mdiContacts,
  'contacts-outline': I.mdiContactsOutline,
  contain: I.mdiContain,
  'contain-end': I.mdiContainEnd,
  'contain-start': I.mdiContainStart,
  'content-copy': I.mdiContentCopy,
  'content-cut': I.mdiContentCut,
  'content-duplicate': I.mdiContentDuplicate,
  'content-paste': I.mdiContentPaste,
  'content-save': I.mdiContentSave,
  'content-save-alert': I.mdiContentSaveAlert,
  'content-save-alert-outline': I.mdiContentSaveAlertOutline,
  'content-save-all': I.mdiContentSaveAll,
  'content-save-all-outline': I.mdiContentSaveAllOutline,
  'content-save-check': I.mdiContentSaveCheck,
  'content-save-check-outline': I.mdiContentSaveCheckOutline,
  'content-save-cog': I.mdiContentSaveCog,
  'content-save-cog-outline': I.mdiContentSaveCogOutline,
  'content-save-edit': I.mdiContentSaveEdit,
  'content-save-edit-outline': I.mdiContentSaveEditOutline,
  'content-save-minus': I.mdiContentSaveMinus,
  'content-save-minus-outline': I.mdiContentSaveMinusOutline,
  'content-save-move': I.mdiContentSaveMove,
  'content-save-move-outline': I.mdiContentSaveMoveOutline,
  'content-save-off': I.mdiContentSaveOff,
  'content-save-off-outline': I.mdiContentSaveOffOutline,
  'content-save-outline': I.mdiContentSaveOutline,
  'content-save-plus': I.mdiContentSavePlus,
  'content-save-plus-outline': I.mdiContentSavePlusOutline,
  'content-save-settings': I.mdiContentSaveSettings,
  'content-save-settings-outline': I.mdiContentSaveSettingsOutline,
  contrast: I.mdiContrast,
  'contrast-box': I.mdiContrastBox,
  'contrast-circle': I.mdiContrastCircle,
  controller: I.mdiController,
  'controller-classic': I.mdiControllerClassic,
  'controller-classic-outline': I.mdiControllerClassicOutline,
  'controller-off': I.mdiControllerOff,
  cookie: I.mdiCookie,
  'cookie-alert': I.mdiCookieAlert,
  'cookie-alert-outline': I.mdiCookieAlertOutline,
  'cookie-check': I.mdiCookieCheck,
  'cookie-check-outline': I.mdiCookieCheckOutline,
  'cookie-clock': I.mdiCookieClock,
  'cookie-clock-outline': I.mdiCookieClockOutline,
  'cookie-cog': I.mdiCookieCog,
  'cookie-cog-outline': I.mdiCookieCogOutline,
  'cookie-edit': I.mdiCookieEdit,
  'cookie-edit-outline': I.mdiCookieEditOutline,
  'cookie-lock': I.mdiCookieLock,
  'cookie-lock-outline': I.mdiCookieLockOutline,
  'cookie-minus': I.mdiCookieMinus,
  'cookie-minus-outline': I.mdiCookieMinusOutline,
  'cookie-off': I.mdiCookieOff,
  'cookie-off-outline': I.mdiCookieOffOutline,
  'cookie-outline': I.mdiCookieOutline,
  'cookie-plus': I.mdiCookiePlus,
  'cookie-plus-outline': I.mdiCookiePlusOutline,
  'cookie-refresh': I.mdiCookieRefresh,
  'cookie-refresh-outline': I.mdiCookieRefreshOutline,
  'cookie-remove': I.mdiCookieRemove,
  'cookie-remove-outline': I.mdiCookieRemoveOutline,
  'cookie-settings': I.mdiCookieSettings,
  'cookie-settings-outline': I.mdiCookieSettingsOutline,
  'coolant-temperature': I.mdiCoolantTemperature,
  copyleft: I.mdiCopyleft,
  copyright: I.mdiCopyright,
  cordova: I.mdiCordova,
  corn: I.mdiCorn,
  'corn-off': I.mdiCornOff,
  'cosine-wave': I.mdiCosineWave,
  counter: I.mdiCounter,
  countertop: I.mdiCountertop,
  'countertop-outline': I.mdiCountertopOutline,
  cow: I.mdiCow,
  'cow-off': I.mdiCowOff,
  'cpu-32-bit': I.mdiCpu32Bit,
  'cpu-64-bit': I.mdiCpu64Bit,
  cradle: I.mdiCradle,
  'cradle-outline': I.mdiCradleOutline,
  crane: I.mdiCrane,
  creation: I.mdiCreation,
  'creative-commons': I.mdiCreativeCommons,
  'credit-card': I.mdiCreditCard,
  'credit-card-check': I.mdiCreditCardCheck,
  'credit-card-check-outline': I.mdiCreditCardCheckOutline,
  'credit-card-chip': I.mdiCreditCardChip,
  'credit-card-chip-outline': I.mdiCreditCardChipOutline,
  'credit-card-clock': I.mdiCreditCardClock,
  'credit-card-clock-outline': I.mdiCreditCardClockOutline,
  'credit-card-edit': I.mdiCreditCardEdit,
  'credit-card-edit-outline': I.mdiCreditCardEditOutline,
  'credit-card-fast': I.mdiCreditCardFast,
  'credit-card-fast-outline': I.mdiCreditCardFastOutline,
  'credit-card-lock': I.mdiCreditCardLock,
  'credit-card-lock-outline': I.mdiCreditCardLockOutline,
  'credit-card-marker': I.mdiCreditCardMarker,
  'credit-card-marker-outline': I.mdiCreditCardMarkerOutline,
  'credit-card-minus': I.mdiCreditCardMinus,
  'credit-card-minus-outline': I.mdiCreditCardMinusOutline,
  'credit-card-multiple': I.mdiCreditCardMultiple,
  'credit-card-multiple-outline': I.mdiCreditCardMultipleOutline,
  'credit-card-off': I.mdiCreditCardOff,
  'credit-card-off-outline': I.mdiCreditCardOffOutline,
  'credit-card-outline': I.mdiCreditCardOutline,
  'credit-card-plus': I.mdiCreditCardPlus,
  'credit-card-plus-outline': I.mdiCreditCardPlusOutline,
  'credit-card-refresh': I.mdiCreditCardRefresh,
  'credit-card-refresh-outline': I.mdiCreditCardRefreshOutline,
  'credit-card-refund': I.mdiCreditCardRefund,
  'credit-card-refund-outline': I.mdiCreditCardRefundOutline,
  'credit-card-remove': I.mdiCreditCardRemove,
  'credit-card-remove-outline': I.mdiCreditCardRemoveOutline,
  'credit-card-scan': I.mdiCreditCardScan,
  'credit-card-scan-outline': I.mdiCreditCardScanOutline,
  'credit-card-search': I.mdiCreditCardSearch,
  'credit-card-search-outline': I.mdiCreditCardSearchOutline,
  'credit-card-settings': I.mdiCreditCardSettings,
  'credit-card-settings-outline': I.mdiCreditCardSettingsOutline,
  'credit-card-sync': I.mdiCreditCardSync,
  'credit-card-sync-outline': I.mdiCreditCardSyncOutline,
  'credit-card-wireless': I.mdiCreditCardWireless,
  'credit-card-wireless-off': I.mdiCreditCardWirelessOff,
  'credit-card-wireless-off-outline': I.mdiCreditCardWirelessOffOutline,
  'credit-card-wireless-outline': I.mdiCreditCardWirelessOutline,
  cricket: I.mdiCricket,
  crop: I.mdiCrop,
  'crop-free': I.mdiCropFree,
  'crop-landscape': I.mdiCropLandscape,
  'crop-portrait': I.mdiCropPortrait,
  'crop-rotate': I.mdiCropRotate,
  'crop-square': I.mdiCropSquare,
  cross: I.mdiCross,
  'cross-bolnisi': I.mdiCrossBolnisi,
  'cross-celtic': I.mdiCrossCeltic,
  'cross-outline': I.mdiCrossOutline,
  crosshairs: I.mdiCrosshairs,
  'crosshairs-gps': I.mdiCrosshairsGps,
  'crosshairs-off': I.mdiCrosshairsOff,
  'crosshairs-question': I.mdiCrosshairsQuestion,
  crowd: I.mdiCrowd,
  crown: I.mdiCrown,
  'crown-circle': I.mdiCrownCircle,
  'crown-circle-outline': I.mdiCrownCircleOutline,
  'crown-outline': I.mdiCrownOutline,
  cryengine: I.mdiCryengine,
  'crystal-ball': I.mdiCrystalBall,
  cube: I.mdiCube,
  'cube-off': I.mdiCubeOff,
  'cube-off-outline': I.mdiCubeOffOutline,
  'cube-outline': I.mdiCubeOutline,
  'cube-scan': I.mdiCubeScan,
  'cube-send': I.mdiCubeSend,
  'cube-unfolded': I.mdiCubeUnfolded,
  cup: I.mdiCup,
  'cup-off': I.mdiCupOff,
  'cup-off-outline': I.mdiCupOffOutline,
  'cup-outline': I.mdiCupOutline,
  'cup-water': I.mdiCupWater,
  cupboard: I.mdiCupboard,
  'cupboard-outline': I.mdiCupboardOutline,
  cupcake: I.mdiCupcake,
  curling: I.mdiCurling,
  'currency-bdt': I.mdiCurrencyBdt,
  'currency-brl': I.mdiCurrencyBrl,
  'currency-btc': I.mdiCurrencyBtc,
  'currency-cny': I.mdiCurrencyCny,
  'currency-eth': I.mdiCurrencyEth,
  'currency-eur': I.mdiCurrencyEur,
  'currency-eur-off': I.mdiCurrencyEurOff,
  'currency-fra': I.mdiCurrencyFra,
  'currency-gbp': I.mdiCurrencyGbp,
  'currency-ils': I.mdiCurrencyIls,
  'currency-inr': I.mdiCurrencyInr,
  'currency-jpy': I.mdiCurrencyJpy,
  'currency-krw': I.mdiCurrencyKrw,
  'currency-kzt': I.mdiCurrencyKzt,
  'currency-mnt': I.mdiCurrencyMnt,
  'currency-ngn': I.mdiCurrencyNgn,
  'currency-php': I.mdiCurrencyPhp,
  'currency-rial': I.mdiCurrencyRial,
  'currency-rub': I.mdiCurrencyRub,
  'currency-rupee': I.mdiCurrencyRupee,
  'currency-sign': I.mdiCurrencySign,
  'currency-try': I.mdiCurrencyTry,
  'currency-twd': I.mdiCurrencyTwd,
  'currency-uah': I.mdiCurrencyUah,
  'currency-usd': I.mdiCurrencyUsd,
  'currency-usd-off': I.mdiCurrencyUsdOff,
  'current-ac': I.mdiCurrentAc,
  'current-dc': I.mdiCurrentDc,
  'cursor-default': I.mdiCursorDefault,
  'cursor-default-click': I.mdiCursorDefaultClick,
  'cursor-default-click-outline': I.mdiCursorDefaultClickOutline,
  'cursor-default-gesture': I.mdiCursorDefaultGesture,
  'cursor-default-gesture-outline': I.mdiCursorDefaultGestureOutline,
  'cursor-default-outline': I.mdiCursorDefaultOutline,
  'cursor-move': I.mdiCursorMove,
  'cursor-pointer': I.mdiCursorPointer,
  'cursor-text': I.mdiCursorText,
  curtains: I.mdiCurtains,
  'curtains-closed': I.mdiCurtainsClosed,
  cylinder: I.mdiCylinder,
  'cylinder-off': I.mdiCylinderOff,
  'dance-ballroom': I.mdiDanceBallroom,
  'dance-pole': I.mdiDancePole,
  'data-matrix': I.mdiDataMatrix,
  'data-matrix-edit': I.mdiDataMatrixEdit,
  'data-matrix-minus': I.mdiDataMatrixMinus,
  'data-matrix-plus': I.mdiDataMatrixPlus,
  'data-matrix-remove': I.mdiDataMatrixRemove,
  'data-matrix-scan': I.mdiDataMatrixScan,
  database: I.mdiDatabase,
  'database-alert': I.mdiDatabaseAlert,
  'database-alert-outline': I.mdiDatabaseAlertOutline,
  'database-arrow-down': I.mdiDatabaseArrowDown,
  'database-arrow-down-outline': I.mdiDatabaseArrowDownOutline,
  'database-arrow-left': I.mdiDatabaseArrowLeft,
  'database-arrow-left-outline': I.mdiDatabaseArrowLeftOutline,
  'database-arrow-right': I.mdiDatabaseArrowRight,
  'database-arrow-right-outline': I.mdiDatabaseArrowRightOutline,
  'database-arrow-up': I.mdiDatabaseArrowUp,
  'database-arrow-up-outline': I.mdiDatabaseArrowUpOutline,
  'database-check': I.mdiDatabaseCheck,
  'database-check-outline': I.mdiDatabaseCheckOutline,
  'database-clock': I.mdiDatabaseClock,
  'database-clock-outline': I.mdiDatabaseClockOutline,
  'database-cog': I.mdiDatabaseCog,
  'database-cog-outline': I.mdiDatabaseCogOutline,
  'database-edit': I.mdiDatabaseEdit,
  'database-edit-outline': I.mdiDatabaseEditOutline,
  'database-export': I.mdiDatabaseExport,
  'database-export-outline': I.mdiDatabaseExportOutline,
  'database-eye': I.mdiDatabaseEye,
  'database-eye-off': I.mdiDatabaseEyeOff,
  'database-eye-off-outline': I.mdiDatabaseEyeOffOutline,
  'database-eye-outline': I.mdiDatabaseEyeOutline,
  'database-import': I.mdiDatabaseImport,
  'database-import-outline': I.mdiDatabaseImportOutline,
  'database-lock': I.mdiDatabaseLock,
  'database-lock-outline': I.mdiDatabaseLockOutline,
  'database-marker': I.mdiDatabaseMarker,
  'database-marker-outline': I.mdiDatabaseMarkerOutline,
  'database-minus': I.mdiDatabaseMinus,
  'database-minus-outline': I.mdiDatabaseMinusOutline,
  'database-off': I.mdiDatabaseOff,
  'database-off-outline': I.mdiDatabaseOffOutline,
  'database-outline': I.mdiDatabaseOutline,
  'database-plus': I.mdiDatabasePlus,
  'database-plus-outline': I.mdiDatabasePlusOutline,
  'database-refresh': I.mdiDatabaseRefresh,
  'database-refresh-outline': I.mdiDatabaseRefreshOutline,
  'database-remove': I.mdiDatabaseRemove,
  'database-remove-outline': I.mdiDatabaseRemoveOutline,
  'database-search': I.mdiDatabaseSearch,
  'database-search-outline': I.mdiDatabaseSearchOutline,
  'database-settings': I.mdiDatabaseSettings,
  'database-settings-outline': I.mdiDatabaseSettingsOutline,
  'database-sync': I.mdiDatabaseSync,
  'database-sync-outline': I.mdiDatabaseSyncOutline,
  'death-star': I.mdiDeathStar,
  'death-star-variant': I.mdiDeathStarVariant,
  'deathly-hallows': I.mdiDeathlyHallows,
  debian: I.mdiDebian,
  'debug-step-into': I.mdiDebugStepInto,
  'debug-step-out': I.mdiDebugStepOut,
  'debug-step-over': I.mdiDebugStepOver,
  decagram: I.mdiDecagram,
  'decagram-outline': I.mdiDecagramOutline,
  decimal: I.mdiDecimal,
  'decimal-comma': I.mdiDecimalComma,
  'decimal-comma-decrease': I.mdiDecimalCommaDecrease,
  'decimal-comma-increase': I.mdiDecimalCommaIncrease,
  'decimal-decrease': I.mdiDecimalDecrease,
  'decimal-increase': I.mdiDecimalIncrease,
  delete: I.mdiDelete,
  'delete-alert': I.mdiDeleteAlert,
  'delete-alert-outline': I.mdiDeleteAlertOutline,
  'delete-circle': I.mdiDeleteCircle,
  'delete-circle-outline': I.mdiDeleteCircleOutline,
  'delete-clock': I.mdiDeleteClock,
  'delete-clock-outline': I.mdiDeleteClockOutline,
  'delete-empty': I.mdiDeleteEmpty,
  'delete-empty-outline': I.mdiDeleteEmptyOutline,
  'delete-forever': I.mdiDeleteForever,
  'delete-forever-outline': I.mdiDeleteForeverOutline,
  'delete-off': I.mdiDeleteOff,
  'delete-off-outline': I.mdiDeleteOffOutline,
  'delete-outline': I.mdiDeleteOutline,
  'delete-restore': I.mdiDeleteRestore,
  'delete-sweep': I.mdiDeleteSweep,
  'delete-sweep-outline': I.mdiDeleteSweepOutline,
  'delete-variant': I.mdiDeleteVariant,
  delta: I.mdiDelta,
  desk: I.mdiDesk,
  'desk-lamp': I.mdiDeskLamp,
  'desk-lamp-off': I.mdiDeskLampOff,
  'desk-lamp-on': I.mdiDeskLampOn,
  deskphone: I.mdiDeskphone,
  'desktop-classic': I.mdiDesktopClassic,
  'desktop-tower': I.mdiDesktopTower,
  'desktop-tower-monitor': I.mdiDesktopTowerMonitor,
  details: I.mdiDetails,
  'dev-to': I.mdiDevTo,
  'developer-board': I.mdiDeveloperBoard,
  deviantart: I.mdiDeviantart,
  devices: I.mdiDevices,
  dharmachakra: I.mdiDharmachakra,
  diabetes: I.mdiDiabetes,
  dialpad: I.mdiDialpad,
  diameter: I.mdiDiameter,
  'diameter-outline': I.mdiDiameterOutline,
  'diameter-variant': I.mdiDiameterVariant,
  diamond: I.mdiDiamond,
  'diamond-outline': I.mdiDiamondOutline,
  'diamond-stone': I.mdiDiamondStone,
  'dice-1': I.mdiDice1,
  'dice-1-outline': I.mdiDice1Outline,
  'dice-2': I.mdiDice2,
  'dice-2-outline': I.mdiDice2Outline,
  'dice-3': I.mdiDice3,
  'dice-3-outline': I.mdiDice3Outline,
  'dice-4': I.mdiDice4,
  'dice-4-outline': I.mdiDice4Outline,
  'dice-5': I.mdiDice5,
  'dice-5-outline': I.mdiDice5Outline,
  'dice-6': I.mdiDice6,
  'dice-6-outline': I.mdiDice6Outline,
  'dice-d-4': I.mdiDiceD4,
  'dice-d-4-outline': I.mdiDiceD4Outline,
  'dice-d-6': I.mdiDiceD6,
  'dice-d-6-outline': I.mdiDiceD6Outline,
  'dice-d-8': I.mdiDiceD8,
  'dice-d-8-outline': I.mdiDiceD8Outline,
  'dice-d-10': I.mdiDiceD10,
  'dice-d-10-outline': I.mdiDiceD10Outline,
  'dice-d-12': I.mdiDiceD12,
  'dice-d-12-outline': I.mdiDiceD12Outline,
  'dice-d-20': I.mdiDiceD20,
  'dice-d-20-outline': I.mdiDiceD20Outline,
  'dice-multiple': I.mdiDiceMultiple,
  'dice-multiple-outline': I.mdiDiceMultipleOutline,
  'digital-ocean': I.mdiDigitalOcean,
  'dip-switch': I.mdiDipSwitch,
  directions: I.mdiDirections,
  'directions-fork': I.mdiDirectionsFork,
  disc: I.mdiDisc,
  'disc-alert': I.mdiDiscAlert,
  'disc-player': I.mdiDiscPlayer,
  dishwasher: I.mdiDishwasher,
  'dishwasher-alert': I.mdiDishwasherAlert,
  'dishwasher-off': I.mdiDishwasherOff,
  disqus: I.mdiDisqus,
  'distribute-horizontal-center': I.mdiDistributeHorizontalCenter,
  'distribute-horizontal-left': I.mdiDistributeHorizontalLeft,
  'distribute-horizontal-right': I.mdiDistributeHorizontalRight,
  'distribute-vertical-bottom': I.mdiDistributeVerticalBottom,
  'distribute-vertical-center': I.mdiDistributeVerticalCenter,
  'distribute-vertical-top': I.mdiDistributeVerticalTop,
  diversify: I.mdiDiversify,
  diving: I.mdiDiving,
  'diving-flippers': I.mdiDivingFlippers,
  'diving-helmet': I.mdiDivingHelmet,
  'diving-scuba': I.mdiDivingScuba,
  'diving-scuba-flag': I.mdiDivingScubaFlag,
  'diving-scuba-mask': I.mdiDivingScubaMask,
  'diving-scuba-tank': I.mdiDivingScubaTank,
  'diving-scuba-tank-multiple': I.mdiDivingScubaTankMultiple,
  'diving-snorkel': I.mdiDivingSnorkel,
  division: I.mdiDivision,
  'division-box': I.mdiDivisionBox,
  dlna: I.mdiDlna,
  dna: I.mdiDna,
  dns: I.mdiDns,
  'dns-outline': I.mdiDnsOutline,
  'dock-bottom': I.mdiDockBottom,
  'dock-left': I.mdiDockLeft,
  'dock-right': I.mdiDockRight,
  'dock-top': I.mdiDockTop,
  'dock-window': I.mdiDockWindow,
  docker: I.mdiDocker,
  doctor: I.mdiDoctor,
  dog: I.mdiDog,
  'dog-service': I.mdiDogService,
  'dog-side': I.mdiDogSide,
  'dog-side-off': I.mdiDogSideOff,
  dolby: I.mdiDolby,
  dolly: I.mdiDolly,
  dolphin: I.mdiDolphin,
  domain: I.mdiDomain,
  'domain-off': I.mdiDomainOff,
  'domain-plus': I.mdiDomainPlus,
  'domain-remove': I.mdiDomainRemove,
  'dome-light': I.mdiDomeLight,
  'domino-mask': I.mdiDominoMask,
  donkey: I.mdiDonkey,
  door: I.mdiDoor,
  'door-closed': I.mdiDoorClosed,
  'door-closed-lock': I.mdiDoorClosedLock,
  'door-open': I.mdiDoorOpen,
  'door-sliding': I.mdiDoorSliding,
  'door-sliding-lock': I.mdiDoorSlidingLock,
  'door-sliding-open': I.mdiDoorSlidingOpen,
  doorbell: I.mdiDoorbell,
  'doorbell-video': I.mdiDoorbellVideo,
  'dot-net': I.mdiDotNet,
  'dots-circle': I.mdiDotsCircle,
  'dots-grid': I.mdiDotsGrid,
  'dots-hexagon': I.mdiDotsHexagon,
  'dots-horizontal': I.mdiDotsHorizontal,
  'dots-horizontal-circle': I.mdiDotsHorizontalCircle,
  'dots-horizontal-circle-outline': I.mdiDotsHorizontalCircleOutline,
  'dots-square': I.mdiDotsSquare,
  'dots-triangle': I.mdiDotsTriangle,
  'dots-vertical': I.mdiDotsVertical,
  'dots-vertical-circle': I.mdiDotsVerticalCircle,
  'dots-vertical-circle-outline': I.mdiDotsVerticalCircleOutline,
  download: I.mdiDownload,
  'download-box': I.mdiDownloadBox,
  'download-box-outline': I.mdiDownloadBoxOutline,
  'download-circle': I.mdiDownloadCircle,
  'download-circle-outline': I.mdiDownloadCircleOutline,
  'download-lock': I.mdiDownloadLock,
  'download-lock-outline': I.mdiDownloadLockOutline,
  'download-multiple': I.mdiDownloadMultiple,
  'download-network': I.mdiDownloadNetwork,
  'download-network-outline': I.mdiDownloadNetworkOutline,
  'download-off': I.mdiDownloadOff,
  'download-off-outline': I.mdiDownloadOffOutline,
  'download-outline': I.mdiDownloadOutline,
  drag: I.mdiDrag,
  'drag-horizontal': I.mdiDragHorizontal,
  'drag-horizontal-variant': I.mdiDragHorizontalVariant,
  'drag-variant': I.mdiDragVariant,
  'drag-vertical': I.mdiDragVertical,
  'drag-vertical-variant': I.mdiDragVerticalVariant,
  'drama-masks': I.mdiDramaMasks,
  draw: I.mdiDraw,
  'draw-pen': I.mdiDrawPen,
  drawing: I.mdiDrawing,
  'drawing-box': I.mdiDrawingBox,
  dresser: I.mdiDresser,
  'dresser-outline': I.mdiDresserOutline,
  drone: I.mdiDrone,
  dropbox: I.mdiDropbox,
  drupal: I.mdiDrupal,
  duck: I.mdiDuck,
  dumbbell: I.mdiDumbbell,
  'dump-truck': I.mdiDumpTruck,
  'ear-hearing': I.mdiEarHearing,
  'ear-hearing-loop': I.mdiEarHearingLoop,
  'ear-hearing-off': I.mdiEarHearingOff,
  earbuds: I.mdiEarbuds,
  'earbuds-off': I.mdiEarbudsOff,
  'earbuds-off-outline': I.mdiEarbudsOffOutline,
  'earbuds-outline': I.mdiEarbudsOutline,
  earth: I.mdiEarth,
  'earth-arrow-right': I.mdiEarthArrowRight,
  'earth-box': I.mdiEarthBox,
  'earth-box-minus': I.mdiEarthBoxMinus,
  'earth-box-off': I.mdiEarthBoxOff,
  'earth-box-plus': I.mdiEarthBoxPlus,
  'earth-box-remove': I.mdiEarthBoxRemove,
  'earth-minus': I.mdiEarthMinus,
  'earth-off': I.mdiEarthOff,
  'earth-plus': I.mdiEarthPlus,
  'earth-remove': I.mdiEarthRemove,
  egg: I.mdiEgg,
  'egg-easter': I.mdiEggEaster,
  'egg-fried': I.mdiEggFried,
  'egg-off': I.mdiEggOff,
  'egg-off-outline': I.mdiEggOffOutline,
  'egg-outline': I.mdiEggOutline,
  'eiffel-tower': I.mdiEiffelTower,
  'eight-track': I.mdiEightTrack,
  eject: I.mdiEject,
  'eject-circle': I.mdiEjectCircle,
  'eject-circle-outline': I.mdiEjectCircleOutline,
  'eject-outline': I.mdiEjectOutline,
  'electric-switch': I.mdiElectricSwitch,
  'electric-switch-closed': I.mdiElectricSwitchClosed,
  'electron-framework': I.mdiElectronFramework,
  elephant: I.mdiElephant,
  'elevation-decline': I.mdiElevationDecline,
  'elevation-rise': I.mdiElevationRise,
  elevator: I.mdiElevator,
  'elevator-down': I.mdiElevatorDown,
  'elevator-passenger': I.mdiElevatorPassenger,
  'elevator-passenger-off': I.mdiElevatorPassengerOff,
  'elevator-passenger-off-outline': I.mdiElevatorPassengerOffOutline,
  'elevator-passenger-outline': I.mdiElevatorPassengerOutline,
  'elevator-up': I.mdiElevatorUp,
  ellipse: I.mdiEllipse,
  'ellipse-outline': I.mdiEllipseOutline,
  email: I.mdiEmail,
  'email-alert': I.mdiEmailAlert,
  'email-alert-outline': I.mdiEmailAlertOutline,
  'email-arrow-left': I.mdiEmailArrowLeft,
  'email-arrow-left-outline': I.mdiEmailArrowLeftOutline,
  'email-arrow-right': I.mdiEmailArrowRight,
  'email-arrow-right-outline': I.mdiEmailArrowRightOutline,
  'email-box': I.mdiEmailBox,
  'email-check': I.mdiEmailCheck,
  'email-check-outline': I.mdiEmailCheckOutline,
  'email-edit': I.mdiEmailEdit,
  'email-edit-outline': I.mdiEmailEditOutline,
  'email-fast': I.mdiEmailFast,
  'email-fast-outline': I.mdiEmailFastOutline,
  'email-lock': I.mdiEmailLock,
  'email-lock-outline': I.mdiEmailLockOutline,
  'email-mark-as-unread': I.mdiEmailMarkAsUnread,
  'email-minus': I.mdiEmailMinus,
  'email-minus-outline': I.mdiEmailMinusOutline,
  'email-multiple': I.mdiEmailMultiple,
  'email-multiple-outline': I.mdiEmailMultipleOutline,
  'email-newsletter': I.mdiEmailNewsletter,
  'email-off': I.mdiEmailOff,
  'email-off-outline': I.mdiEmailOffOutline,
  'email-open': I.mdiEmailOpen,
  'email-open-multiple': I.mdiEmailOpenMultiple,
  'email-open-multiple-outline': I.mdiEmailOpenMultipleOutline,
  'email-open-outline': I.mdiEmailOpenOutline,
  'email-outline': I.mdiEmailOutline,
  'email-plus': I.mdiEmailPlus,
  'email-plus-outline': I.mdiEmailPlusOutline,
  'email-remove': I.mdiEmailRemove,
  'email-remove-outline': I.mdiEmailRemoveOutline,
  'email-seal': I.mdiEmailSeal,
  'email-seal-outline': I.mdiEmailSealOutline,
  'email-search': I.mdiEmailSearch,
  'email-search-outline': I.mdiEmailSearchOutline,
  'email-sync': I.mdiEmailSync,
  'email-sync-outline': I.mdiEmailSyncOutline,
  'email-variant': I.mdiEmailVariant,
  ember: I.mdiEmber,
  emby: I.mdiEmby,
  emoticon: I.mdiEmoticon,
  'emoticon-angry': I.mdiEmoticonAngry,
  'emoticon-angry-outline': I.mdiEmoticonAngryOutline,
  'emoticon-confused': I.mdiEmoticonConfused,
  'emoticon-confused-outline': I.mdiEmoticonConfusedOutline,
  'emoticon-cool': I.mdiEmoticonCool,
  'emoticon-cool-outline': I.mdiEmoticonCoolOutline,
  'emoticon-cry': I.mdiEmoticonCry,
  'emoticon-cry-outline': I.mdiEmoticonCryOutline,
  'emoticon-dead': I.mdiEmoticonDead,
  'emoticon-dead-outline': I.mdiEmoticonDeadOutline,
  'emoticon-devil': I.mdiEmoticonDevil,
  'emoticon-devil-outline': I.mdiEmoticonDevilOutline,
  'emoticon-excited': I.mdiEmoticonExcited,
  'emoticon-excited-outline': I.mdiEmoticonExcitedOutline,
  'emoticon-frown': I.mdiEmoticonFrown,
  'emoticon-frown-outline': I.mdiEmoticonFrownOutline,
  'emoticon-happy': I.mdiEmoticonHappy,
  'emoticon-happy-outline': I.mdiEmoticonHappyOutline,
  'emoticon-kiss': I.mdiEmoticonKiss,
  'emoticon-kiss-outline': I.mdiEmoticonKissOutline,
  'emoticon-lol': I.mdiEmoticonLol,
  'emoticon-lol-outline': I.mdiEmoticonLolOutline,
  'emoticon-neutral': I.mdiEmoticonNeutral,
  'emoticon-neutral-outline': I.mdiEmoticonNeutralOutline,
  'emoticon-outline': I.mdiEmoticonOutline,
  'emoticon-poop': I.mdiEmoticonPoop,
  'emoticon-poop-outline': I.mdiEmoticonPoopOutline,
  'emoticon-sad': I.mdiEmoticonSad,
  'emoticon-sad-outline': I.mdiEmoticonSadOutline,
  'emoticon-sick': I.mdiEmoticonSick,
  'emoticon-sick-outline': I.mdiEmoticonSickOutline,
  'emoticon-tongue': I.mdiEmoticonTongue,
  'emoticon-tongue-outline': I.mdiEmoticonTongueOutline,
  'emoticon-wink': I.mdiEmoticonWink,
  'emoticon-wink-outline': I.mdiEmoticonWinkOutline,
  engine: I.mdiEngine,
  'engine-off': I.mdiEngineOff,
  'engine-off-outline': I.mdiEngineOffOutline,
  'engine-outline': I.mdiEngineOutline,
  epsilon: I.mdiEpsilon,
  equal: I.mdiEqual,
  'equal-box': I.mdiEqualBox,
  equalizer: I.mdiEqualizer,
  'equalizer-outline': I.mdiEqualizerOutline,
  eraser: I.mdiEraser,
  'eraser-variant': I.mdiEraserVariant,
  escalator: I.mdiEscalator,
  'escalator-box': I.mdiEscalatorBox,
  'escalator-down': I.mdiEscalatorDown,
  'escalator-up': I.mdiEscalatorUp,
  eslint: I.mdiEslint,
  et: I.mdiEt,
  ethereum: I.mdiEthereum,
  ethernet: I.mdiEthernet,
  'ethernet-cable': I.mdiEthernetCable,
  'ethernet-cable-off': I.mdiEthernetCableOff,
  'ev-plug-ccs-1': I.mdiEvPlugCcs1,
  'ev-plug-ccs-2': I.mdiEvPlugCcs2,
  'ev-plug-chademo': I.mdiEvPlugChademo,
  'ev-plug-tesla': I.mdiEvPlugTesla,
  'ev-plug-type-1': I.mdiEvPlugType1,
  'ev-plug-type-2': I.mdiEvPlugType2,
  'ev-station': I.mdiEvStation,
  evernote: I.mdiEvernote,
  excavator: I.mdiExcavator,
  exclamation: I.mdiExclamation,
  'exclamation-thick': I.mdiExclamationThick,
  'exit-run': I.mdiExitRun,
  'exit-to-app': I.mdiExitToApp,
  'expand-all': I.mdiExpandAll,
  'expand-all-outline': I.mdiExpandAllOutline,
  'expansion-card': I.mdiExpansionCard,
  'expansion-card-variant': I.mdiExpansionCardVariant,
  exponent: I.mdiExponent,
  'exponent-box': I.mdiExponentBox,
  export: I.mdiExport,
  'export-variant': I.mdiExportVariant,
  eye: I.mdiEye,
  'eye-arrow-left': I.mdiEyeArrowLeft,
  'eye-arrow-left-outline': I.mdiEyeArrowLeftOutline,
  'eye-arrow-right': I.mdiEyeArrowRight,
  'eye-arrow-right-outline': I.mdiEyeArrowRightOutline,
  'eye-check': I.mdiEyeCheck,
  'eye-check-outline': I.mdiEyeCheckOutline,
  'eye-circle': I.mdiEyeCircle,
  'eye-circle-outline': I.mdiEyeCircleOutline,
  'eye-minus': I.mdiEyeMinus,
  'eye-minus-outline': I.mdiEyeMinusOutline,
  'eye-off': I.mdiEyeOff,
  'eye-off-outline': I.mdiEyeOffOutline,
  'eye-outline': I.mdiEyeOutline,
  'eye-plus': I.mdiEyePlus,
  'eye-plus-outline': I.mdiEyePlusOutline,
  'eye-refresh': I.mdiEyeRefresh,
  'eye-refresh-outline': I.mdiEyeRefreshOutline,
  'eye-remove': I.mdiEyeRemove,
  'eye-remove-outline': I.mdiEyeRemoveOutline,
  'eye-settings': I.mdiEyeSettings,
  'eye-settings-outline': I.mdiEyeSettingsOutline,
  eyedropper: I.mdiEyedropper,
  'eyedropper-minus': I.mdiEyedropperMinus,
  'eyedropper-off': I.mdiEyedropperOff,
  'eyedropper-plus': I.mdiEyedropperPlus,
  'eyedropper-remove': I.mdiEyedropperRemove,
  'eyedropper-variant': I.mdiEyedropperVariant,
  'face-agent': I.mdiFaceAgent,
  'face-man': I.mdiFaceMan,
  'face-man-outline': I.mdiFaceManOutline,
  'face-man-profile': I.mdiFaceManProfile,
  'face-man-shimmer': I.mdiFaceManShimmer,
  'face-man-shimmer-outline': I.mdiFaceManShimmerOutline,
  'face-mask': I.mdiFaceMask,
  'face-mask-outline': I.mdiFaceMaskOutline,
  'face-recognition': I.mdiFaceRecognition,
  'face-woman': I.mdiFaceWoman,
  'face-woman-outline': I.mdiFaceWomanOutline,
  'face-woman-profile': I.mdiFaceWomanProfile,
  'face-woman-shimmer': I.mdiFaceWomanShimmer,
  'face-woman-shimmer-outline': I.mdiFaceWomanShimmerOutline,
  facebook: I.mdiFacebook,
  'facebook-gaming': I.mdiFacebookGaming,
  'facebook-messenger': I.mdiFacebookMessenger,
  'facebook-workplace': I.mdiFacebookWorkplace,
  factory: I.mdiFactory,
  'family-tree': I.mdiFamilyTree,
  fan: I.mdiFan,
  'fan-alert': I.mdiFanAlert,
  'fan-auto': I.mdiFanAuto,
  'fan-chevron-down': I.mdiFanChevronDown,
  'fan-chevron-up': I.mdiFanChevronUp,
  'fan-clock': I.mdiFanClock,
  'fan-minus': I.mdiFanMinus,
  'fan-off': I.mdiFanOff,
  'fan-plus': I.mdiFanPlus,
  'fan-remove': I.mdiFanRemove,
  'fan-speed-1': I.mdiFanSpeed1,
  'fan-speed-2': I.mdiFanSpeed2,
  'fan-speed-3': I.mdiFanSpeed3,
  'fast-forward': I.mdiFastForward,
  'fast-forward-5': I.mdiFastForward5,
  'fast-forward-10': I.mdiFastForward10,
  'fast-forward-15': I.mdiFastForward15,
  'fast-forward-30': I.mdiFastForward30,
  'fast-forward-45': I.mdiFastForward45,
  'fast-forward-60': I.mdiFastForward60,
  'fast-forward-outline': I.mdiFastForwardOutline,
  faucet: I.mdiFaucet,
  'faucet-variant': I.mdiFaucetVariant,
  fax: I.mdiFax,
  feather: I.mdiFeather,
  'feature-search': I.mdiFeatureSearch,
  'feature-search-outline': I.mdiFeatureSearchOutline,
  fedora: I.mdiFedora,
  fence: I.mdiFence,
  'fence-electric': I.mdiFenceElectric,
  fencing: I.mdiFencing,
  'ferris-wheel': I.mdiFerrisWheel,
  ferry: I.mdiFerry,
  file: I.mdiFile,
  'file-account': I.mdiFileAccount,
  'file-account-outline': I.mdiFileAccountOutline,
  'file-alert': I.mdiFileAlert,
  'file-alert-outline': I.mdiFileAlertOutline,
  'file-arrow-left-right': I.mdiFileArrowLeftRight,
  'file-arrow-left-right-outline': I.mdiFileArrowLeftRightOutline,
  'file-arrow-up-down': I.mdiFileArrowUpDown,
  'file-arrow-up-down-outline': I.mdiFileArrowUpDownOutline,
  'file-cabinet': I.mdiFileCabinet,
  'file-cad': I.mdiFileCad,
  'file-cad-box': I.mdiFileCadBox,
  'file-cancel': I.mdiFileCancel,
  'file-cancel-outline': I.mdiFileCancelOutline,
  'file-certificate': I.mdiFileCertificate,
  'file-certificate-outline': I.mdiFileCertificateOutline,
  'file-chart': I.mdiFileChart,
  'file-chart-check': I.mdiFileChartCheck,
  'file-chart-check-outline': I.mdiFileChartCheckOutline,
  'file-chart-outline': I.mdiFileChartOutline,
  'file-check': I.mdiFileCheck,
  'file-check-outline': I.mdiFileCheckOutline,
  'file-clock': I.mdiFileClock,
  'file-clock-outline': I.mdiFileClockOutline,
  'file-cloud': I.mdiFileCloud,
  'file-cloud-outline': I.mdiFileCloudOutline,
  'file-code': I.mdiFileCode,
  'file-code-outline': I.mdiFileCodeOutline,
  'file-cog': I.mdiFileCog,
  'file-cog-outline': I.mdiFileCogOutline,
  'file-compare': I.mdiFileCompare,
  'file-delimited': I.mdiFileDelimited,
  'file-delimited-outline': I.mdiFileDelimitedOutline,
  'file-document': I.mdiFileDocument,
  'file-document-alert': I.mdiFileDocumentAlert,
  'file-document-alert-outline': I.mdiFileDocumentAlertOutline,
  'file-document-check': I.mdiFileDocumentCheck,
  'file-document-check-outline': I.mdiFileDocumentCheckOutline,
  'file-document-edit': I.mdiFileDocumentEdit,
  'file-document-edit-outline': I.mdiFileDocumentEditOutline,
  'file-document-minus': I.mdiFileDocumentMinus,
  'file-document-minus-outline': I.mdiFileDocumentMinusOutline,
  'file-document-multiple': I.mdiFileDocumentMultiple,
  'file-document-multiple-outline': I.mdiFileDocumentMultipleOutline,
  'file-document-outline': I.mdiFileDocumentOutline,
  'file-document-plus': I.mdiFileDocumentPlus,
  'file-document-plus-outline': I.mdiFileDocumentPlusOutline,
  'file-document-remove': I.mdiFileDocumentRemove,
  'file-document-remove-outline': I.mdiFileDocumentRemoveOutline,
  'file-download': I.mdiFileDownload,
  'file-download-outline': I.mdiFileDownloadOutline,
  'file-edit': I.mdiFileEdit,
  'file-edit-outline': I.mdiFileEditOutline,
  'file-excel': I.mdiFileExcel,
  'file-excel-box': I.mdiFileExcelBox,
  'file-excel-box-outline': I.mdiFileExcelBoxOutline,
  'file-excel-outline': I.mdiFileExcelOutline,
  'file-export': I.mdiFileExport,
  'file-export-outline': I.mdiFileExportOutline,
  'file-eye': I.mdiFileEye,
  'file-eye-outline': I.mdiFileEyeOutline,
  'file-find': I.mdiFileFind,
  'file-find-outline': I.mdiFileFindOutline,
  'file-gif-box': I.mdiFileGifBox,
  'file-hidden': I.mdiFileHidden,
  'file-image': I.mdiFileImage,
  'file-image-marker': I.mdiFileImageMarker,
  'file-image-marker-outline': I.mdiFileImageMarkerOutline,
  'file-image-minus': I.mdiFileImageMinus,
  'file-image-minus-outline': I.mdiFileImageMinusOutline,
  'file-image-outline': I.mdiFileImageOutline,
  'file-image-plus': I.mdiFileImagePlus,
  'file-image-plus-outline': I.mdiFileImagePlusOutline,
  'file-image-remove': I.mdiFileImageRemove,
  'file-image-remove-outline': I.mdiFileImageRemoveOutline,
  'file-import': I.mdiFileImport,
  'file-import-outline': I.mdiFileImportOutline,
  'file-jpg-box': I.mdiFileJpgBox,
  'file-key': I.mdiFileKey,
  'file-key-outline': I.mdiFileKeyOutline,
  'file-link': I.mdiFileLink,
  'file-link-outline': I.mdiFileLinkOutline,
  'file-lock': I.mdiFileLock,
  'file-lock-open': I.mdiFileLockOpen,
  'file-lock-open-outline': I.mdiFileLockOpenOutline,
  'file-lock-outline': I.mdiFileLockOutline,
  'file-marker': I.mdiFileMarker,
  'file-marker-outline': I.mdiFileMarkerOutline,
  'file-minus': I.mdiFileMinus,
  'file-minus-outline': I.mdiFileMinusOutline,
  'file-move': I.mdiFileMove,
  'file-move-outline': I.mdiFileMoveOutline,
  'file-multiple': I.mdiFileMultiple,
  'file-multiple-outline': I.mdiFileMultipleOutline,
  'file-music': I.mdiFileMusic,
  'file-music-outline': I.mdiFileMusicOutline,
  'file-outline': I.mdiFileOutline,
  'file-pdf-box': I.mdiFilePdfBox,
  'file-percent': I.mdiFilePercent,
  'file-percent-outline': I.mdiFilePercentOutline,
  'file-phone': I.mdiFilePhone,
  'file-phone-outline': I.mdiFilePhoneOutline,
  'file-plus': I.mdiFilePlus,
  'file-plus-outline': I.mdiFilePlusOutline,
  'file-png-box': I.mdiFilePngBox,
  'file-powerpoint': I.mdiFilePowerpoint,
  'file-powerpoint-box': I.mdiFilePowerpointBox,
  'file-powerpoint-box-outline': I.mdiFilePowerpointBoxOutline,
  'file-powerpoint-outline': I.mdiFilePowerpointOutline,
  'file-presentation-box': I.mdiFilePresentationBox,
  'file-question': I.mdiFileQuestion,
  'file-question-outline': I.mdiFileQuestionOutline,
  'file-refresh': I.mdiFileRefresh,
  'file-refresh-outline': I.mdiFileRefreshOutline,
  'file-remove': I.mdiFileRemove,
  'file-remove-outline': I.mdiFileRemoveOutline,
  'file-replace': I.mdiFileReplace,
  'file-replace-outline': I.mdiFileReplaceOutline,
  'file-restore': I.mdiFileRestore,
  'file-restore-outline': I.mdiFileRestoreOutline,
  'file-rotate-left': I.mdiFileRotateLeft,
  'file-rotate-left-outline': I.mdiFileRotateLeftOutline,
  'file-rotate-right': I.mdiFileRotateRight,
  'file-rotate-right-outline': I.mdiFileRotateRightOutline,
  'file-search': I.mdiFileSearch,
  'file-search-outline': I.mdiFileSearchOutline,
  'file-send': I.mdiFileSend,
  'file-send-outline': I.mdiFileSendOutline,
  'file-settings': I.mdiFileSettings,
  'file-settings-outline': I.mdiFileSettingsOutline,
  'file-sign': I.mdiFileSign,
  'file-star': I.mdiFileStar,
  'file-star-outline': I.mdiFileStarOutline,
  'file-swap': I.mdiFileSwap,
  'file-swap-outline': I.mdiFileSwapOutline,
  'file-sync': I.mdiFileSync,
  'file-sync-outline': I.mdiFileSyncOutline,
  'file-table': I.mdiFileTable,
  'file-table-box': I.mdiFileTableBox,
  'file-table-box-multiple': I.mdiFileTableBoxMultiple,
  'file-table-box-multiple-outline': I.mdiFileTableBoxMultipleOutline,
  'file-table-box-outline': I.mdiFileTableBoxOutline,
  'file-table-outline': I.mdiFileTableOutline,
  'file-tree': I.mdiFileTree,
  'file-tree-outline': I.mdiFileTreeOutline,
  'file-undo': I.mdiFileUndo,
  'file-undo-outline': I.mdiFileUndoOutline,
  'file-upload': I.mdiFileUpload,
  'file-upload-outline': I.mdiFileUploadOutline,
  'file-video': I.mdiFileVideo,
  'file-video-outline': I.mdiFileVideoOutline,
  'file-word': I.mdiFileWord,
  'file-word-box': I.mdiFileWordBox,
  'file-word-box-outline': I.mdiFileWordBoxOutline,
  'file-word-outline': I.mdiFileWordOutline,
  'file-xml-box': I.mdiFileXmlBox,
  film: I.mdiFilm,
  filmstrip: I.mdiFilmstrip,
  'filmstrip-box': I.mdiFilmstripBox,
  'filmstrip-box-multiple': I.mdiFilmstripBoxMultiple,
  'filmstrip-off': I.mdiFilmstripOff,
  filter: I.mdiFilter,
  'filter-check': I.mdiFilterCheck,
  'filter-check-outline': I.mdiFilterCheckOutline,
  'filter-cog': I.mdiFilterCog,
  'filter-cog-outline': I.mdiFilterCogOutline,
  'filter-menu': I.mdiFilterMenu,
  'filter-menu-outline': I.mdiFilterMenuOutline,
  'filter-minus': I.mdiFilterMinus,
  'filter-minus-outline': I.mdiFilterMinusOutline,
  'filter-multiple': I.mdiFilterMultiple,
  'filter-multiple-outline': I.mdiFilterMultipleOutline,
  'filter-off': I.mdiFilterOff,
  'filter-off-outline': I.mdiFilterOffOutline,
  'filter-outline': I.mdiFilterOutline,
  'filter-plus': I.mdiFilterPlus,
  'filter-plus-outline': I.mdiFilterPlusOutline,
  'filter-remove': I.mdiFilterRemove,
  'filter-remove-outline': I.mdiFilterRemoveOutline,
  'filter-settings': I.mdiFilterSettings,
  'filter-settings-outline': I.mdiFilterSettingsOutline,
  'filter-variant': I.mdiFilterVariant,
  'filter-variant-minus': I.mdiFilterVariantMinus,
  'filter-variant-plus': I.mdiFilterVariantPlus,
  'filter-variant-remove': I.mdiFilterVariantRemove,
  finance: I.mdiFinance,
  'find-replace': I.mdiFindReplace,
  fingerprint: I.mdiFingerprint,
  'fingerprint-off': I.mdiFingerprintOff,
  fire: I.mdiFire,
  'fire-alert': I.mdiFireAlert,
  'fire-circle': I.mdiFireCircle,
  'fire-extinguisher': I.mdiFireExtinguisher,
  'fire-hydrant': I.mdiFireHydrant,
  'fire-hydrant-alert': I.mdiFireHydrantAlert,
  'fire-hydrant-off': I.mdiFireHydrantOff,
  'fire-off': I.mdiFireOff,
  'fire-truck': I.mdiFireTruck,
  firebase: I.mdiFirebase,
  firefox: I.mdiFirefox,
  fireplace: I.mdiFireplace,
  'fireplace-off': I.mdiFireplaceOff,
  firewire: I.mdiFirewire,
  firework: I.mdiFirework,
  'firework-off': I.mdiFireworkOff,
  fish: I.mdiFish,
  'fish-off': I.mdiFishOff,
  fishbowl: I.mdiFishbowl,
  'fishbowl-outline': I.mdiFishbowlOutline,
  'fit-to-page': I.mdiFitToPage,
  'fit-to-page-outline': I.mdiFitToPageOutline,
  'fit-to-screen': I.mdiFitToScreen,
  'fit-to-screen-outline': I.mdiFitToScreenOutline,
  flag: I.mdiFlag,
  'flag-checkered': I.mdiFlagCheckered,
  'flag-minus': I.mdiFlagMinus,
  'flag-minus-outline': I.mdiFlagMinusOutline,
  'flag-off': I.mdiFlagOff,
  'flag-off-outline': I.mdiFlagOffOutline,
  'flag-outline': I.mdiFlagOutline,
  'flag-plus': I.mdiFlagPlus,
  'flag-plus-outline': I.mdiFlagPlusOutline,
  'flag-remove': I.mdiFlagRemove,
  'flag-remove-outline': I.mdiFlagRemoveOutline,
  'flag-triangle': I.mdiFlagTriangle,
  'flag-variant': I.mdiFlagVariant,
  'flag-variant-minus': I.mdiFlagVariantMinus,
  'flag-variant-minus-outline': I.mdiFlagVariantMinusOutline,
  'flag-variant-off': I.mdiFlagVariantOff,
  'flag-variant-off-outline': I.mdiFlagVariantOffOutline,
  'flag-variant-outline': I.mdiFlagVariantOutline,
  'flag-variant-plus': I.mdiFlagVariantPlus,
  'flag-variant-plus-outline': I.mdiFlagVariantPlusOutline,
  'flag-variant-remove': I.mdiFlagVariantRemove,
  'flag-variant-remove-outline': I.mdiFlagVariantRemoveOutline,
  flare: I.mdiFlare,
  flash: I.mdiFlash,
  'flash-alert': I.mdiFlashAlert,
  'flash-alert-outline': I.mdiFlashAlertOutline,
  'flash-auto': I.mdiFlashAuto,
  'flash-off': I.mdiFlashOff,
  'flash-off-outline': I.mdiFlashOffOutline,
  'flash-outline': I.mdiFlashOutline,
  'flash-red-eye': I.mdiFlashRedEye,
  'flash-triangle': I.mdiFlashTriangle,
  'flash-triangle-outline': I.mdiFlashTriangleOutline,
  flashlight: I.mdiFlashlight,
  'flashlight-off': I.mdiFlashlightOff,
  flask: I.mdiFlask,
  'flask-empty': I.mdiFlaskEmpty,
  'flask-empty-minus': I.mdiFlaskEmptyMinus,
  'flask-empty-minus-outline': I.mdiFlaskEmptyMinusOutline,
  'flask-empty-off': I.mdiFlaskEmptyOff,
  'flask-empty-off-outline': I.mdiFlaskEmptyOffOutline,
  'flask-empty-outline': I.mdiFlaskEmptyOutline,
  'flask-empty-plus': I.mdiFlaskEmptyPlus,
  'flask-empty-plus-outline': I.mdiFlaskEmptyPlusOutline,
  'flask-empty-remove': I.mdiFlaskEmptyRemove,
  'flask-empty-remove-outline': I.mdiFlaskEmptyRemoveOutline,
  'flask-minus': I.mdiFlaskMinus,
  'flask-minus-outline': I.mdiFlaskMinusOutline,
  'flask-off': I.mdiFlaskOff,
  'flask-off-outline': I.mdiFlaskOffOutline,
  'flask-outline': I.mdiFlaskOutline,
  'flask-plus': I.mdiFlaskPlus,
  'flask-plus-outline': I.mdiFlaskPlusOutline,
  'flask-remove': I.mdiFlaskRemove,
  'flask-remove-outline': I.mdiFlaskRemoveOutline,
  'flask-round-bottom': I.mdiFlaskRoundBottom,
  'flask-round-bottom-empty': I.mdiFlaskRoundBottomEmpty,
  'flask-round-bottom-empty-outline': I.mdiFlaskRoundBottomEmptyOutline,
  'flask-round-bottom-outline': I.mdiFlaskRoundBottomOutline,
  'fleur-de-lis': I.mdiFleurDeLis,
  'flip-horizontal': I.mdiFlipHorizontal,
  'flip-to-back': I.mdiFlipToBack,
  'flip-to-front': I.mdiFlipToFront,
  'flip-vertical': I.mdiFlipVertical,
  'floor-lamp': I.mdiFloorLamp,
  'floor-lamp-dual': I.mdiFloorLampDual,
  'floor-lamp-dual-outline': I.mdiFloorLampDualOutline,
  'floor-lamp-outline': I.mdiFloorLampOutline,
  'floor-lamp-torchiere': I.mdiFloorLampTorchiere,
  'floor-lamp-torchiere-outline': I.mdiFloorLampTorchiereOutline,
  'floor-lamp-torchiere-variant': I.mdiFloorLampTorchiereVariant,
  'floor-lamp-torchiere-variant-outline': I.mdiFloorLampTorchiereVariantOutline,
  'floor-plan': I.mdiFloorPlan,
  floppy: I.mdiFloppy,
  'floppy-variant': I.mdiFloppyVariant,
  flower: I.mdiFlower,
  'flower-outline': I.mdiFlowerOutline,
  'flower-pollen': I.mdiFlowerPollen,
  'flower-pollen-outline': I.mdiFlowerPollenOutline,
  'flower-poppy': I.mdiFlowerPoppy,
  'flower-tulip': I.mdiFlowerTulip,
  'flower-tulip-outline': I.mdiFlowerTulipOutline,
  'focus-auto': I.mdiFocusAuto,
  'focus-field': I.mdiFocusField,
  'focus-field-horizontal': I.mdiFocusFieldHorizontal,
  'focus-field-vertical': I.mdiFocusFieldVertical,
  folder: I.mdiFolder,
  'folder-account': I.mdiFolderAccount,
  'folder-account-outline': I.mdiFolderAccountOutline,
  'folder-alert': I.mdiFolderAlert,
  'folder-alert-outline': I.mdiFolderAlertOutline,
  'folder-arrow-down': I.mdiFolderArrowDown,
  'folder-arrow-down-outline': I.mdiFolderArrowDownOutline,
  'folder-arrow-left': I.mdiFolderArrowLeft,
  'folder-arrow-left-outline': I.mdiFolderArrowLeftOutline,
  'folder-arrow-left-right': I.mdiFolderArrowLeftRight,
  'folder-arrow-left-right-outline': I.mdiFolderArrowLeftRightOutline,
  'folder-arrow-right': I.mdiFolderArrowRight,
  'folder-arrow-right-outline': I.mdiFolderArrowRightOutline,
  'folder-arrow-up': I.mdiFolderArrowUp,
  'folder-arrow-up-down': I.mdiFolderArrowUpDown,
  'folder-arrow-up-down-outline': I.mdiFolderArrowUpDownOutline,
  'folder-arrow-up-outline': I.mdiFolderArrowUpOutline,
  'folder-cancel': I.mdiFolderCancel,
  'folder-cancel-outline': I.mdiFolderCancelOutline,
  'folder-check': I.mdiFolderCheck,
  'folder-check-outline': I.mdiFolderCheckOutline,
  'folder-clock': I.mdiFolderClock,
  'folder-clock-outline': I.mdiFolderClockOutline,
  'folder-cog': I.mdiFolderCog,
  'folder-cog-outline': I.mdiFolderCogOutline,
  'folder-download': I.mdiFolderDownload,
  'folder-download-outline': I.mdiFolderDownloadOutline,
  'folder-edit': I.mdiFolderEdit,
  'folder-edit-outline': I.mdiFolderEditOutline,
  'folder-eye': I.mdiFolderEye,
  'folder-eye-outline': I.mdiFolderEyeOutline,
  'folder-file': I.mdiFolderFile,
  'folder-file-outline': I.mdiFolderFileOutline,
  'folder-google-drive': I.mdiFolderGoogleDrive,
  'folder-heart': I.mdiFolderHeart,
  'folder-heart-outline': I.mdiFolderHeartOutline,
  'folder-hidden': I.mdiFolderHidden,
  'folder-home': I.mdiFolderHome,
  'folder-home-outline': I.mdiFolderHomeOutline,
  'folder-image': I.mdiFolderImage,
  'folder-information': I.mdiFolderInformation,
  'folder-information-outline': I.mdiFolderInformationOutline,
  'folder-key': I.mdiFolderKey,
  'folder-key-network': I.mdiFolderKeyNetwork,
  'folder-key-network-outline': I.mdiFolderKeyNetworkOutline,
  'folder-key-outline': I.mdiFolderKeyOutline,
  'folder-lock': I.mdiFolderLock,
  'folder-lock-open': I.mdiFolderLockOpen,
  'folder-lock-open-outline': I.mdiFolderLockOpenOutline,
  'folder-lock-outline': I.mdiFolderLockOutline,
  'folder-marker': I.mdiFolderMarker,
  'folder-marker-outline': I.mdiFolderMarkerOutline,
  'folder-minus': I.mdiFolderMinus,
  'folder-minus-outline': I.mdiFolderMinusOutline,
  'folder-move': I.mdiFolderMove,
  'folder-move-outline': I.mdiFolderMoveOutline,
  'folder-multiple': I.mdiFolderMultiple,
  'folder-multiple-image': I.mdiFolderMultipleImage,
  'folder-multiple-outline': I.mdiFolderMultipleOutline,
  'folder-multiple-plus': I.mdiFolderMultiplePlus,
  'folder-multiple-plus-outline': I.mdiFolderMultiplePlusOutline,
  'folder-music': I.mdiFolderMusic,
  'folder-music-outline': I.mdiFolderMusicOutline,
  'folder-network': I.mdiFolderNetwork,
  'folder-network-outline': I.mdiFolderNetworkOutline,
  'folder-off': I.mdiFolderOff,
  'folder-off-outline': I.mdiFolderOffOutline,
  'folder-open': I.mdiFolderOpen,
  'folder-open-outline': I.mdiFolderOpenOutline,
  'folder-outline': I.mdiFolderOutline,
  'folder-play': I.mdiFolderPlay,
  'folder-play-outline': I.mdiFolderPlayOutline,
  'folder-plus': I.mdiFolderPlus,
  'folder-plus-outline': I.mdiFolderPlusOutline,
  'folder-pound': I.mdiFolderPound,
  'folder-pound-outline': I.mdiFolderPoundOutline,
  'folder-question': I.mdiFolderQuestion,
  'folder-question-outline': I.mdiFolderQuestionOutline,
  'folder-refresh': I.mdiFolderRefresh,
  'folder-refresh-outline': I.mdiFolderRefreshOutline,
  'folder-remove': I.mdiFolderRemove,
  'folder-remove-outline': I.mdiFolderRemoveOutline,
  'folder-search': I.mdiFolderSearch,
  'folder-search-outline': I.mdiFolderSearchOutline,
  'folder-settings': I.mdiFolderSettings,
  'folder-settings-outline': I.mdiFolderSettingsOutline,
  'folder-star': I.mdiFolderStar,
  'folder-star-multiple': I.mdiFolderStarMultiple,
  'folder-star-multiple-outline': I.mdiFolderStarMultipleOutline,
  'folder-star-outline': I.mdiFolderStarOutline,
  'folder-swap': I.mdiFolderSwap,
  'folder-swap-outline': I.mdiFolderSwapOutline,
  'folder-sync': I.mdiFolderSync,
  'folder-sync-outline': I.mdiFolderSyncOutline,
  'folder-table': I.mdiFolderTable,
  'folder-table-outline': I.mdiFolderTableOutline,
  'folder-text': I.mdiFolderText,
  'folder-text-outline': I.mdiFolderTextOutline,
  'folder-upload': I.mdiFolderUpload,
  'folder-upload-outline': I.mdiFolderUploadOutline,
  'folder-wrench': I.mdiFolderWrench,
  'folder-wrench-outline': I.mdiFolderWrenchOutline,
  'folder-zip': I.mdiFolderZip,
  'folder-zip-outline': I.mdiFolderZipOutline,
  'font-awesome': I.mdiFontAwesome,
  food: I.mdiFood,
  'food-apple': I.mdiFoodApple,
  'food-apple-outline': I.mdiFoodAppleOutline,
  'food-croissant': I.mdiFoodCroissant,
  'food-drumstick': I.mdiFoodDrumstick,
  'food-drumstick-off': I.mdiFoodDrumstickOff,
  'food-drumstick-off-outline': I.mdiFoodDrumstickOffOutline,
  'food-drumstick-outline': I.mdiFoodDrumstickOutline,
  'food-fork-drink': I.mdiFoodForkDrink,
  'food-halal': I.mdiFoodHalal,
  'food-hot-dog': I.mdiFoodHotDog,
  'food-kosher': I.mdiFoodKosher,
  'food-off': I.mdiFoodOff,
  'food-off-outline': I.mdiFoodOffOutline,
  'food-outline': I.mdiFoodOutline,
  'food-steak': I.mdiFoodSteak,
  'food-steak-off': I.mdiFoodSteakOff,
  'food-takeout-box': I.mdiFoodTakeoutBox,
  'food-takeout-box-outline': I.mdiFoodTakeoutBoxOutline,
  'food-turkey': I.mdiFoodTurkey,
  'food-variant': I.mdiFoodVariant,
  'food-variant-off': I.mdiFoodVariantOff,
  'foot-print': I.mdiFootPrint,
  football: I.mdiFootball,
  'football-australian': I.mdiFootballAustralian,
  'football-helmet': I.mdiFootballHelmet,
  forest: I.mdiForest,
  forklift: I.mdiForklift,
  'form-dropdown': I.mdiFormDropdown,
  'form-select': I.mdiFormSelect,
  'form-textarea': I.mdiFormTextarea,
  'form-textbox': I.mdiFormTextbox,
  'form-textbox-lock': I.mdiFormTextboxLock,
  'form-textbox-password': I.mdiFormTextboxPassword,
  'format-align-bottom': I.mdiFormatAlignBottom,
  'format-align-center': I.mdiFormatAlignCenter,
  'format-align-justify': I.mdiFormatAlignJustify,
  'format-align-left': I.mdiFormatAlignLeft,
  'format-align-middle': I.mdiFormatAlignMiddle,
  'format-align-right': I.mdiFormatAlignRight,
  'format-align-top': I.mdiFormatAlignTop,
  'format-annotation-minus': I.mdiFormatAnnotationMinus,
  'format-annotation-plus': I.mdiFormatAnnotationPlus,
  'format-bold': I.mdiFormatBold,
  'format-clear': I.mdiFormatClear,
  'format-color-fill': I.mdiFormatColorFill,
  'format-color-highlight': I.mdiFormatColorHighlight,
  'format-color-marker-cancel': I.mdiFormatColorMarkerCancel,
  'format-color-text': I.mdiFormatColorText,
  'format-columns': I.mdiFormatColumns,
  'format-float-center': I.mdiFormatFloatCenter,
  'format-float-left': I.mdiFormatFloatLeft,
  'format-float-none': I.mdiFormatFloatNone,
  'format-float-right': I.mdiFormatFloatRight,
  'format-font': I.mdiFormatFont,
  'format-font-size-decrease': I.mdiFormatFontSizeDecrease,
  'format-font-size-increase': I.mdiFormatFontSizeIncrease,
  'format-header-1': I.mdiFormatHeader1,
  'format-header-2': I.mdiFormatHeader2,
  'format-header-3': I.mdiFormatHeader3,
  'format-header-4': I.mdiFormatHeader4,
  'format-header-5': I.mdiFormatHeader5,
  'format-header-6': I.mdiFormatHeader6,
  'format-header-decrease': I.mdiFormatHeaderDecrease,
  'format-header-equal': I.mdiFormatHeaderEqual,
  'format-header-increase': I.mdiFormatHeaderIncrease,
  'format-header-pound': I.mdiFormatHeaderPound,
  'format-horizontal-align-center': I.mdiFormatHorizontalAlignCenter,
  'format-horizontal-align-left': I.mdiFormatHorizontalAlignLeft,
  'format-horizontal-align-right': I.mdiFormatHorizontalAlignRight,
  'format-indent-decrease': I.mdiFormatIndentDecrease,
  'format-indent-increase': I.mdiFormatIndentIncrease,
  'format-italic': I.mdiFormatItalic,
  'format-letter-case': I.mdiFormatLetterCase,
  'format-letter-case-lower': I.mdiFormatLetterCaseLower,
  'format-letter-case-upper': I.mdiFormatLetterCaseUpper,
  'format-letter-ends-with': I.mdiFormatLetterEndsWith,
  'format-letter-matches': I.mdiFormatLetterMatches,
  'format-letter-spacing': I.mdiFormatLetterSpacing,
  'format-letter-spacing-variant': I.mdiFormatLetterSpacingVariant,
  'format-letter-starts-with': I.mdiFormatLetterStartsWith,
  'format-line-height': I.mdiFormatLineHeight,
  'format-line-spacing': I.mdiFormatLineSpacing,
  'format-line-style': I.mdiFormatLineStyle,
  'format-line-weight': I.mdiFormatLineWeight,
  'format-list-bulleted': I.mdiFormatListBulleted,
  'format-list-bulleted-square': I.mdiFormatListBulletedSquare,
  'format-list-bulleted-triangle': I.mdiFormatListBulletedTriangle,
  'format-list-bulleted-type': I.mdiFormatListBulletedType,
  'format-list-checkbox': I.mdiFormatListCheckbox,
  'format-list-checks': I.mdiFormatListChecks,
  'format-list-group': I.mdiFormatListGroup,
  'format-list-group-plus': I.mdiFormatListGroupPlus,
  'format-list-numbered': I.mdiFormatListNumbered,
  'format-list-numbered-rtl': I.mdiFormatListNumberedRtl,
  'format-list-text': I.mdiFormatListText,
  'format-overline': I.mdiFormatOverline,
  'format-page-break': I.mdiFormatPageBreak,
  'format-page-split': I.mdiFormatPageSplit,
  'format-paint': I.mdiFormatPaint,
  'format-paragraph': I.mdiFormatParagraph,
  'format-paragraph-spacing': I.mdiFormatParagraphSpacing,
  'format-pilcrow': I.mdiFormatPilcrow,
  'format-pilcrow-arrow-left': I.mdiFormatPilcrowArrowLeft,
  'format-pilcrow-arrow-right': I.mdiFormatPilcrowArrowRight,
  'format-quote-close': I.mdiFormatQuoteClose,
  'format-quote-close-outline': I.mdiFormatQuoteCloseOutline,
  'format-quote-open': I.mdiFormatQuoteOpen,
  'format-quote-open-outline': I.mdiFormatQuoteOpenOutline,
  'format-rotate-90': I.mdiFormatRotate90,
  'format-section': I.mdiFormatSection,
  'format-size': I.mdiFormatSize,
  'format-strikethrough': I.mdiFormatStrikethrough,
  'format-strikethrough-variant': I.mdiFormatStrikethroughVariant,
  'format-subscript': I.mdiFormatSubscript,
  'format-superscript': I.mdiFormatSuperscript,
  'format-text': I.mdiFormatText,
  'format-text-rotation-angle-down': I.mdiFormatTextRotationAngleDown,
  'format-text-rotation-angle-up': I.mdiFormatTextRotationAngleUp,
  'format-text-rotation-down': I.mdiFormatTextRotationDown,
  'format-text-rotation-down-vertical': I.mdiFormatTextRotationDownVertical,
  'format-text-rotation-none': I.mdiFormatTextRotationNone,
  'format-text-rotation-up': I.mdiFormatTextRotationUp,
  'format-text-rotation-vertical': I.mdiFormatTextRotationVertical,
  'format-text-variant': I.mdiFormatTextVariant,
  'format-text-variant-outline': I.mdiFormatTextVariantOutline,
  'format-text-wrapping-clip': I.mdiFormatTextWrappingClip,
  'format-text-wrapping-overflow': I.mdiFormatTextWrappingOverflow,
  'format-text-wrapping-wrap': I.mdiFormatTextWrappingWrap,
  'format-textbox': I.mdiFormatTextbox,
  'format-title': I.mdiFormatTitle,
  'format-underline': I.mdiFormatUnderline,
  'format-underline-wavy': I.mdiFormatUnderlineWavy,
  'format-vertical-align-bottom': I.mdiFormatVerticalAlignBottom,
  'format-vertical-align-center': I.mdiFormatVerticalAlignCenter,
  'format-vertical-align-top': I.mdiFormatVerticalAlignTop,
  'format-wrap-inline': I.mdiFormatWrapInline,
  'format-wrap-square': I.mdiFormatWrapSquare,
  'format-wrap-tight': I.mdiFormatWrapTight,
  'format-wrap-top-bottom': I.mdiFormatWrapTopBottom,
  forum: I.mdiForum,
  'forum-minus': I.mdiForumMinus,
  'forum-minus-outline': I.mdiForumMinusOutline,
  'forum-outline': I.mdiForumOutline,
  'forum-plus': I.mdiForumPlus,
  'forum-plus-outline': I.mdiForumPlusOutline,
  'forum-remove': I.mdiForumRemove,
  'forum-remove-outline': I.mdiForumRemoveOutline,
  forward: I.mdiForward,
  forwardburger: I.mdiForwardburger,
  fountain: I.mdiFountain,
  'fountain-pen': I.mdiFountainPen,
  'fountain-pen-tip': I.mdiFountainPenTip,
  'fraction-one-half': I.mdiFractionOneHalf,
  freebsd: I.mdiFreebsd,
  'french-fries': I.mdiFrenchFries,
  'frequently-asked-questions': I.mdiFrequentlyAskedQuestions,
  fridge: I.mdiFridge,
  'fridge-alert': I.mdiFridgeAlert,
  'fridge-alert-outline': I.mdiFridgeAlertOutline,
  'fridge-bottom': I.mdiFridgeBottom,
  'fridge-industrial': I.mdiFridgeIndustrial,
  'fridge-industrial-alert': I.mdiFridgeIndustrialAlert,
  'fridge-industrial-alert-outline': I.mdiFridgeIndustrialAlertOutline,
  'fridge-industrial-off': I.mdiFridgeIndustrialOff,
  'fridge-industrial-off-outline': I.mdiFridgeIndustrialOffOutline,
  'fridge-industrial-outline': I.mdiFridgeIndustrialOutline,
  'fridge-off': I.mdiFridgeOff,
  'fridge-off-outline': I.mdiFridgeOffOutline,
  'fridge-outline': I.mdiFridgeOutline,
  'fridge-top': I.mdiFridgeTop,
  'fridge-variant': I.mdiFridgeVariant,
  'fridge-variant-alert': I.mdiFridgeVariantAlert,
  'fridge-variant-alert-outline': I.mdiFridgeVariantAlertOutline,
  'fridge-variant-off': I.mdiFridgeVariantOff,
  'fridge-variant-off-outline': I.mdiFridgeVariantOffOutline,
  'fridge-variant-outline': I.mdiFridgeVariantOutline,
  'fruit-cherries': I.mdiFruitCherries,
  'fruit-cherries-off': I.mdiFruitCherriesOff,
  'fruit-citrus': I.mdiFruitCitrus,
  'fruit-citrus-off': I.mdiFruitCitrusOff,
  'fruit-grapes': I.mdiFruitGrapes,
  'fruit-grapes-outline': I.mdiFruitGrapesOutline,
  'fruit-pear': I.mdiFruitPear,
  'fruit-pineapple': I.mdiFruitPineapple,
  'fruit-watermelon': I.mdiFruitWatermelon,
  fuel: I.mdiFuel,
  'fuel-cell': I.mdiFuelCell,
  fullscreen: I.mdiFullscreen,
  'fullscreen-exit': I.mdiFullscreenExit,
  function: I.mdiFunction,
  'function-variant': I.mdiFunctionVariant,
  'furigana-horizontal': I.mdiFuriganaHorizontal,
  'furigana-vertical': I.mdiFuriganaVertical,
  fuse: I.mdiFuse,
  'fuse-alert': I.mdiFuseAlert,
  'fuse-blade': I.mdiFuseBlade,
  'fuse-off': I.mdiFuseOff,
  gamepad: I.mdiGamepad,
  'gamepad-circle': I.mdiGamepadCircle,
  'gamepad-circle-down': I.mdiGamepadCircleDown,
  'gamepad-circle-left': I.mdiGamepadCircleLeft,
  'gamepad-circle-outline': I.mdiGamepadCircleOutline,
  'gamepad-circle-right': I.mdiGamepadCircleRight,
  'gamepad-circle-up': I.mdiGamepadCircleUp,
  'gamepad-down': I.mdiGamepadDown,
  'gamepad-left': I.mdiGamepadLeft,
  'gamepad-outline': I.mdiGamepadOutline,
  'gamepad-right': I.mdiGamepadRight,
  'gamepad-round': I.mdiGamepadRound,
  'gamepad-round-down': I.mdiGamepadRoundDown,
  'gamepad-round-left': I.mdiGamepadRoundLeft,
  'gamepad-round-outline': I.mdiGamepadRoundOutline,
  'gamepad-round-right': I.mdiGamepadRoundRight,
  'gamepad-round-up': I.mdiGamepadRoundUp,
  'gamepad-square': I.mdiGamepadSquare,
  'gamepad-square-outline': I.mdiGamepadSquareOutline,
  'gamepad-up': I.mdiGamepadUp,
  'gamepad-variant': I.mdiGamepadVariant,
  'gamepad-variant-outline': I.mdiGamepadVariantOutline,
  gamma: I.mdiGamma,
  'gantry-crane': I.mdiGantryCrane,
  garage: I.mdiGarage,
  'garage-alert': I.mdiGarageAlert,
  'garage-alert-variant': I.mdiGarageAlertVariant,
  'garage-lock': I.mdiGarageLock,
  'garage-open': I.mdiGarageOpen,
  'garage-open-variant': I.mdiGarageOpenVariant,
  'garage-variant': I.mdiGarageVariant,
  'garage-variant-lock': I.mdiGarageVariantLock,
  'gas-burner': I.mdiGasBurner,
  'gas-cylinder': I.mdiGasCylinder,
  'gas-station': I.mdiGasStation,
  'gas-station-off': I.mdiGasStationOff,
  'gas-station-off-outline': I.mdiGasStationOffOutline,
  'gas-station-outline': I.mdiGasStationOutline,
  gate: I.mdiGate,
  'gate-alert': I.mdiGateAlert,
  'gate-and': I.mdiGateAnd,
  'gate-arrow-left': I.mdiGateArrowLeft,
  'gate-arrow-right': I.mdiGateArrowRight,
  'gate-buffer': I.mdiGateBuffer,
  'gate-nand': I.mdiGateNand,
  'gate-nor': I.mdiGateNor,
  'gate-not': I.mdiGateNot,
  'gate-open': I.mdiGateOpen,
  'gate-or': I.mdiGateOr,
  'gate-xnor': I.mdiGateXnor,
  'gate-xor': I.mdiGateXor,
  gatsby: I.mdiGatsby,
  gauge: I.mdiGauge,
  'gauge-empty': I.mdiGaugeEmpty,
  'gauge-full': I.mdiGaugeFull,
  'gauge-low': I.mdiGaugeLow,
  gavel: I.mdiGavel,
  'gender-female': I.mdiGenderFemale,
  'gender-male': I.mdiGenderMale,
  'gender-male-female': I.mdiGenderMaleFemale,
  'gender-male-female-variant': I.mdiGenderMaleFemaleVariant,
  'gender-non-binary': I.mdiGenderNonBinary,
  'gender-transgender': I.mdiGenderTransgender,
  gentoo: I.mdiGentoo,
  gesture: I.mdiGesture,
  'gesture-double-tap': I.mdiGestureDoubleTap,
  'gesture-pinch': I.mdiGesturePinch,
  'gesture-spread': I.mdiGestureSpread,
  'gesture-swipe': I.mdiGestureSwipe,
  'gesture-swipe-down': I.mdiGestureSwipeDown,
  'gesture-swipe-horizontal': I.mdiGestureSwipeHorizontal,
  'gesture-swipe-left': I.mdiGestureSwipeLeft,
  'gesture-swipe-right': I.mdiGestureSwipeRight,
  'gesture-swipe-up': I.mdiGestureSwipeUp,
  'gesture-swipe-vertical': I.mdiGestureSwipeVertical,
  'gesture-tap': I.mdiGestureTap,
  'gesture-tap-box': I.mdiGestureTapBox,
  'gesture-tap-button': I.mdiGestureTapButton,
  'gesture-tap-hold': I.mdiGestureTapHold,
  'gesture-two-double-tap': I.mdiGestureTwoDoubleTap,
  'gesture-two-tap': I.mdiGestureTwoTap,
  ghost: I.mdiGhost,
  'ghost-off': I.mdiGhostOff,
  'ghost-off-outline': I.mdiGhostOffOutline,
  'ghost-outline': I.mdiGhostOutline,
  gift: I.mdiGift,
  'gift-off': I.mdiGiftOff,
  'gift-off-outline': I.mdiGiftOffOutline,
  'gift-open': I.mdiGiftOpen,
  'gift-open-outline': I.mdiGiftOpenOutline,
  'gift-outline': I.mdiGiftOutline,
  git: I.mdiGit,
  github: I.mdiGithub,
  gitlab: I.mdiGitlab,
  'glass-cocktail': I.mdiGlassCocktail,
  'glass-cocktail-off': I.mdiGlassCocktailOff,
  'glass-flute': I.mdiGlassFlute,
  'glass-fragile': I.mdiGlassFragile,
  'glass-mug': I.mdiGlassMug,
  'glass-mug-off': I.mdiGlassMugOff,
  'glass-mug-variant': I.mdiGlassMugVariant,
  'glass-mug-variant-off': I.mdiGlassMugVariantOff,
  'glass-pint-outline': I.mdiGlassPintOutline,
  'glass-stange': I.mdiGlassStange,
  'glass-tulip': I.mdiGlassTulip,
  'glass-wine': I.mdiGlassWine,
  glasses: I.mdiGlasses,
  'globe-light': I.mdiGlobeLight,
  'globe-light-outline': I.mdiGlobeLightOutline,
  'globe-model': I.mdiGlobeModel,
  gmail: I.mdiGmail,
  gnome: I.mdiGnome,
  'go-kart': I.mdiGoKart,
  'go-kart-track': I.mdiGoKartTrack,
  gog: I.mdiGog,
  gold: I.mdiGold,
  golf: I.mdiGolf,
  'golf-cart': I.mdiGolfCart,
  'golf-tee': I.mdiGolfTee,
  gondola: I.mdiGondola,
  goodreads: I.mdiGoodreads,
  google: I.mdiGoogle,
  'google-ads': I.mdiGoogleAds,
  'google-analytics': I.mdiGoogleAnalytics,
  'google-assistant': I.mdiGoogleAssistant,
  'google-cardboard': I.mdiGoogleCardboard,
  'google-chrome': I.mdiGoogleChrome,
  'google-circles': I.mdiGoogleCircles,
  'google-circles-communities': I.mdiGoogleCirclesCommunities,
  'google-circles-extended': I.mdiGoogleCirclesExtended,
  'google-circles-group': I.mdiGoogleCirclesGroup,
  'google-classroom': I.mdiGoogleClassroom,
  'google-cloud': I.mdiGoogleCloud,
  'google-downasaur': I.mdiGoogleDownasaur,
  'google-drive': I.mdiGoogleDrive,
  'google-earth': I.mdiGoogleEarth,
  'google-fit': I.mdiGoogleFit,
  'google-glass': I.mdiGoogleGlass,
  'google-hangouts': I.mdiGoogleHangouts,
  'google-keep': I.mdiGoogleKeep,
  'google-lens': I.mdiGoogleLens,
  'google-maps': I.mdiGoogleMaps,
  'google-my-business': I.mdiGoogleMyBusiness,
  'google-nearby': I.mdiGoogleNearby,
  'google-play': I.mdiGooglePlay,
  'google-plus': I.mdiGooglePlus,
  'google-podcast': I.mdiGooglePodcast,
  'google-spreadsheet': I.mdiGoogleSpreadsheet,
  'google-street-view': I.mdiGoogleStreetView,
  'google-translate': I.mdiGoogleTranslate,
  'gradient-horizontal': I.mdiGradientHorizontal,
  'gradient-vertical': I.mdiGradientVertical,
  grain: I.mdiGrain,
  graph: I.mdiGraph,
  'graph-outline': I.mdiGraphOutline,
  graphql: I.mdiGraphql,
  grass: I.mdiGrass,
  'grave-stone': I.mdiGraveStone,
  'grease-pencil': I.mdiGreasePencil,
  'greater-than': I.mdiGreaterThan,
  'greater-than-or-equal': I.mdiGreaterThanOrEqual,
  greenhouse: I.mdiGreenhouse,
  grid: I.mdiGrid,
  'grid-large': I.mdiGridLarge,
  'grid-off': I.mdiGridOff,
  grill: I.mdiGrill,
  'grill-outline': I.mdiGrillOutline,
  group: I.mdiGroup,
  'guitar-acoustic': I.mdiGuitarAcoustic,
  'guitar-electric': I.mdiGuitarElectric,
  'guitar-pick': I.mdiGuitarPick,
  'guitar-pick-outline': I.mdiGuitarPickOutline,
  'guy-fawkes-mask': I.mdiGuyFawkesMask,
  gymnastics: I.mdiGymnastics,
  hail: I.mdiHail,
  'hair-dryer': I.mdiHairDryer,
  'hair-dryer-outline': I.mdiHairDryerOutline,
  halloween: I.mdiHalloween,
  hamburger: I.mdiHamburger,
  'hamburger-check': I.mdiHamburgerCheck,
  'hamburger-minus': I.mdiHamburgerMinus,
  'hamburger-off': I.mdiHamburgerOff,
  'hamburger-plus': I.mdiHamburgerPlus,
  'hamburger-remove': I.mdiHamburgerRemove,
  hammer: I.mdiHammer,
  'hammer-screwdriver': I.mdiHammerScrewdriver,
  'hammer-sickle': I.mdiHammerSickle,
  'hammer-wrench': I.mdiHammerWrench,
  'hand-back-left': I.mdiHandBackLeft,
  'hand-back-left-off': I.mdiHandBackLeftOff,
  'hand-back-left-off-outline': I.mdiHandBackLeftOffOutline,
  'hand-back-left-outline': I.mdiHandBackLeftOutline,
  'hand-back-right': I.mdiHandBackRight,
  'hand-back-right-off': I.mdiHandBackRightOff,
  'hand-back-right-off-outline': I.mdiHandBackRightOffOutline,
  'hand-back-right-outline': I.mdiHandBackRightOutline,
  'hand-clap': I.mdiHandClap,
  'hand-clap-off': I.mdiHandClapOff,
  'hand-coin': I.mdiHandCoin,
  'hand-coin-outline': I.mdiHandCoinOutline,
  'hand-cycle': I.mdiHandCycle,
  'hand-extended': I.mdiHandExtended,
  'hand-extended-outline': I.mdiHandExtendedOutline,
  'hand-front-left': I.mdiHandFrontLeft,
  'hand-front-left-outline': I.mdiHandFrontLeftOutline,
  'hand-front-right': I.mdiHandFrontRight,
  'hand-front-right-outline': I.mdiHandFrontRightOutline,
  'hand-heart': I.mdiHandHeart,
  'hand-heart-outline': I.mdiHandHeartOutline,
  'hand-okay': I.mdiHandOkay,
  'hand-peace': I.mdiHandPeace,
  'hand-peace-variant': I.mdiHandPeaceVariant,
  'hand-pointing-down': I.mdiHandPointingDown,
  'hand-pointing-left': I.mdiHandPointingLeft,
  'hand-pointing-right': I.mdiHandPointingRight,
  'hand-pointing-up': I.mdiHandPointingUp,
  'hand-saw': I.mdiHandSaw,
  'hand-wash': I.mdiHandWash,
  'hand-wash-outline': I.mdiHandWashOutline,
  'hand-water': I.mdiHandWater,
  'hand-wave': I.mdiHandWave,
  'hand-wave-outline': I.mdiHandWaveOutline,
  handball: I.mdiHandball,
  handcuffs: I.mdiHandcuffs,
  'hands-pray': I.mdiHandsPray,
  handshake: I.mdiHandshake,
  'handshake-outline': I.mdiHandshakeOutline,
  hanger: I.mdiHanger,
  'hard-hat': I.mdiHardHat,
  harddisk: I.mdiHarddisk,
  'harddisk-plus': I.mdiHarddiskPlus,
  'harddisk-remove': I.mdiHarddiskRemove,
  'hat-fedora': I.mdiHatFedora,
  'hazard-lights': I.mdiHazardLights,
  'hdmi-port': I.mdiHdmiPort,
  hdr: I.mdiHdr,
  'hdr-off': I.mdiHdrOff,
  head: I.mdiHead,
  'head-alert': I.mdiHeadAlert,
  'head-alert-outline': I.mdiHeadAlertOutline,
  'head-check': I.mdiHeadCheck,
  'head-check-outline': I.mdiHeadCheckOutline,
  'head-cog': I.mdiHeadCog,
  'head-cog-outline': I.mdiHeadCogOutline,
  'head-dots-horizontal': I.mdiHeadDotsHorizontal,
  'head-dots-horizontal-outline': I.mdiHeadDotsHorizontalOutline,
  'head-flash': I.mdiHeadFlash,
  'head-flash-outline': I.mdiHeadFlashOutline,
  'head-heart': I.mdiHeadHeart,
  'head-heart-outline': I.mdiHeadHeartOutline,
  'head-lightbulb': I.mdiHeadLightbulb,
  'head-lightbulb-outline': I.mdiHeadLightbulbOutline,
  'head-minus': I.mdiHeadMinus,
  'head-minus-outline': I.mdiHeadMinusOutline,
  'head-outline': I.mdiHeadOutline,
  'head-plus': I.mdiHeadPlus,
  'head-plus-outline': I.mdiHeadPlusOutline,
  'head-question': I.mdiHeadQuestion,
  'head-question-outline': I.mdiHeadQuestionOutline,
  'head-remove': I.mdiHeadRemove,
  'head-remove-outline': I.mdiHeadRemoveOutline,
  'head-snowflake': I.mdiHeadSnowflake,
  'head-snowflake-outline': I.mdiHeadSnowflakeOutline,
  'head-sync': I.mdiHeadSync,
  'head-sync-outline': I.mdiHeadSyncOutline,
  headphones: I.mdiHeadphones,
  'headphones-bluetooth': I.mdiHeadphonesBluetooth,
  'headphones-box': I.mdiHeadphonesBox,
  'headphones-off': I.mdiHeadphonesOff,
  'headphones-settings': I.mdiHeadphonesSettings,
  headset: I.mdiHeadset,
  'headset-dock': I.mdiHeadsetDock,
  'headset-off': I.mdiHeadsetOff,
  heart: I.mdiHeart,
  'heart-box': I.mdiHeartBox,
  'heart-box-outline': I.mdiHeartBoxOutline,
  'heart-broken': I.mdiHeartBroken,
  'heart-broken-outline': I.mdiHeartBrokenOutline,
  'heart-circle': I.mdiHeartCircle,
  'heart-circle-outline': I.mdiHeartCircleOutline,
  'heart-cog': I.mdiHeartCog,
  'heart-cog-outline': I.mdiHeartCogOutline,
  'heart-flash': I.mdiHeartFlash,
  'heart-half': I.mdiHeartHalf,
  'heart-half-full': I.mdiHeartHalfFull,
  'heart-half-outline': I.mdiHeartHalfOutline,
  'heart-minus': I.mdiHeartMinus,
  'heart-minus-outline': I.mdiHeartMinusOutline,
  'heart-multiple': I.mdiHeartMultiple,
  'heart-multiple-outline': I.mdiHeartMultipleOutline,
  'heart-off': I.mdiHeartOff,
  'heart-off-outline': I.mdiHeartOffOutline,
  'heart-outline': I.mdiHeartOutline,
  'heart-plus': I.mdiHeartPlus,
  'heart-plus-outline': I.mdiHeartPlusOutline,
  'heart-pulse': I.mdiHeartPulse,
  'heart-remove': I.mdiHeartRemove,
  'heart-remove-outline': I.mdiHeartRemoveOutline,
  'heart-settings': I.mdiHeartSettings,
  'heart-settings-outline': I.mdiHeartSettingsOutline,
  'heat-pump': I.mdiHeatPump,
  'heat-pump-outline': I.mdiHeatPumpOutline,
  'heat-wave': I.mdiHeatWave,
  'heating-coil': I.mdiHeatingCoil,
  helicopter: I.mdiHelicopter,
  help: I.mdiHelp,
  'help-box': I.mdiHelpBox,
  'help-circle': I.mdiHelpCircle,
  'help-circle-outline': I.mdiHelpCircleOutline,
  'help-network': I.mdiHelpNetwork,
  'help-network-outline': I.mdiHelpNetworkOutline,
  'help-rhombus': I.mdiHelpRhombus,
  'help-rhombus-outline': I.mdiHelpRhombusOutline,
  hexadecimal: I.mdiHexadecimal,
  hexagon: I.mdiHexagon,
  'hexagon-multiple': I.mdiHexagonMultiple,
  'hexagon-multiple-outline': I.mdiHexagonMultipleOutline,
  'hexagon-outline': I.mdiHexagonOutline,
  'hexagon-slice-1': I.mdiHexagonSlice1,
  'hexagon-slice-2': I.mdiHexagonSlice2,
  'hexagon-slice-3': I.mdiHexagonSlice3,
  'hexagon-slice-4': I.mdiHexagonSlice4,
  'hexagon-slice-5': I.mdiHexagonSlice5,
  'hexagon-slice-6': I.mdiHexagonSlice6,
  hexagram: I.mdiHexagram,
  'hexagram-outline': I.mdiHexagramOutline,
  'high-definition': I.mdiHighDefinition,
  'high-definition-box': I.mdiHighDefinitionBox,
  highway: I.mdiHighway,
  hiking: I.mdiHiking,
  history: I.mdiHistory,
  'hockey-puck': I.mdiHockeyPuck,
  'hockey-sticks': I.mdiHockeySticks,
  hololens: I.mdiHololens,
  home: I.mdiHome,
  'home-account': I.mdiHomeAccount,
  'home-alert': I.mdiHomeAlert,
  'home-alert-outline': I.mdiHomeAlertOutline,
  'home-analytics': I.mdiHomeAnalytics,
  'home-assistant': I.mdiHomeAssistant,
  'home-automation': I.mdiHomeAutomation,
  'home-battery': I.mdiHomeBattery,
  'home-battery-outline': I.mdiHomeBatteryOutline,
  'home-circle': I.mdiHomeCircle,
  'home-circle-outline': I.mdiHomeCircleOutline,
  'home-city': I.mdiHomeCity,
  'home-city-outline': I.mdiHomeCityOutline,
  'home-clock': I.mdiHomeClock,
  'home-clock-outline': I.mdiHomeClockOutline,
  'home-edit': I.mdiHomeEdit,
  'home-edit-outline': I.mdiHomeEditOutline,
  'home-export-outline': I.mdiHomeExportOutline,
  'home-flood': I.mdiHomeFlood,
  'home-floor-0': I.mdiHomeFloor0,
  'home-floor-1': I.mdiHomeFloor1,
  'home-floor-2': I.mdiHomeFloor2,
  'home-floor-3': I.mdiHomeFloor3,
  'home-floor-a': I.mdiHomeFloorA,
  'home-floor-b': I.mdiHomeFloorB,
  'home-floor-g': I.mdiHomeFloorG,
  'home-floor-l': I.mdiHomeFloorL,
  'home-floor-negative-1': I.mdiHomeFloorNegative1,
  'home-group': I.mdiHomeGroup,
  'home-group-minus': I.mdiHomeGroupMinus,
  'home-group-plus': I.mdiHomeGroupPlus,
  'home-group-remove': I.mdiHomeGroupRemove,
  'home-heart': I.mdiHomeHeart,
  'home-import-outline': I.mdiHomeImportOutline,
  'home-lightbulb': I.mdiHomeLightbulb,
  'home-lightbulb-outline': I.mdiHomeLightbulbOutline,
  'home-lightning-bolt': I.mdiHomeLightningBolt,
  'home-lightning-bolt-outline': I.mdiHomeLightningBoltOutline,
  'home-lock': I.mdiHomeLock,
  'home-lock-open': I.mdiHomeLockOpen,
  'home-map-marker': I.mdiHomeMapMarker,
  'home-minus': I.mdiHomeMinus,
  'home-minus-outline': I.mdiHomeMinusOutline,
  'home-modern': I.mdiHomeModern,
  'home-off': I.mdiHomeOff,
  'home-off-outline': I.mdiHomeOffOutline,
  'home-outline': I.mdiHomeOutline,
  'home-plus': I.mdiHomePlus,
  'home-plus-outline': I.mdiHomePlusOutline,
  'home-remove': I.mdiHomeRemove,
  'home-remove-outline': I.mdiHomeRemoveOutline,
  'home-roof': I.mdiHomeRoof,
  'home-search': I.mdiHomeSearch,
  'home-search-outline': I.mdiHomeSearchOutline,
  'home-silo': I.mdiHomeSilo,
  'home-silo-outline': I.mdiHomeSiloOutline,
  'home-switch': I.mdiHomeSwitch,
  'home-switch-outline': I.mdiHomeSwitchOutline,
  'home-thermometer': I.mdiHomeThermometer,
  'home-thermometer-outline': I.mdiHomeThermometerOutline,
  'home-variant': I.mdiHomeVariant,
  'home-variant-outline': I.mdiHomeVariantOutline,
  hook: I.mdiHook,
  'hook-off': I.mdiHookOff,
  'hoop-house': I.mdiHoopHouse,
  hops: I.mdiHops,
  'horizontal-rotate-clockwise': I.mdiHorizontalRotateClockwise,
  'horizontal-rotate-counterclockwise': I.mdiHorizontalRotateCounterclockwise,
  horse: I.mdiHorse,
  'horse-human': I.mdiHorseHuman,
  'horse-variant': I.mdiHorseVariant,
  'horse-variant-fast': I.mdiHorseVariantFast,
  horseshoe: I.mdiHorseshoe,
  hospital: I.mdiHospital,
  'hospital-box': I.mdiHospitalBox,
  'hospital-box-outline': I.mdiHospitalBoxOutline,
  'hospital-building': I.mdiHospitalBuilding,
  'hospital-marker': I.mdiHospitalMarker,
  'hot-tub': I.mdiHotTub,
  'hours-24': I.mdiHours24,
  hubspot: I.mdiHubspot,
  hulu: I.mdiHulu,
  human: I.mdiHuman,
  'human-baby-changing-table': I.mdiHumanBabyChangingTable,
  'human-cane': I.mdiHumanCane,
  'human-capacity-decrease': I.mdiHumanCapacityDecrease,
  'human-capacity-increase': I.mdiHumanCapacityIncrease,
  'human-child': I.mdiHumanChild,
  'human-dolly': I.mdiHumanDolly,
  'human-edit': I.mdiHumanEdit,
  'human-female': I.mdiHumanFemale,
  'human-female-boy': I.mdiHumanFemaleBoy,
  'human-female-dance': I.mdiHumanFemaleDance,
  'human-female-female': I.mdiHumanFemaleFemale,
  'human-female-girl': I.mdiHumanFemaleGirl,
  'human-greeting': I.mdiHumanGreeting,
  'human-greeting-proximity': I.mdiHumanGreetingProximity,
  'human-greeting-variant': I.mdiHumanGreetingVariant,
  'human-handsdown': I.mdiHumanHandsdown,
  'human-handsup': I.mdiHumanHandsup,
  'human-male': I.mdiHumanMale,
  'human-male-board': I.mdiHumanMaleBoard,
  'human-male-board-poll': I.mdiHumanMaleBoardPoll,
  'human-male-boy': I.mdiHumanMaleBoy,
  'human-male-child': I.mdiHumanMaleChild,
  'human-male-female': I.mdiHumanMaleFemale,
  'human-male-female-child': I.mdiHumanMaleFemaleChild,
  'human-male-girl': I.mdiHumanMaleGirl,
  'human-male-height': I.mdiHumanMaleHeight,
  'human-male-height-variant': I.mdiHumanMaleHeightVariant,
  'human-male-male': I.mdiHumanMaleMale,
  'human-non-binary': I.mdiHumanNonBinary,
  'human-pregnant': I.mdiHumanPregnant,
  'human-queue': I.mdiHumanQueue,
  'human-scooter': I.mdiHumanScooter,
  'human-walker': I.mdiHumanWalker,
  'human-wheelchair': I.mdiHumanWheelchair,
  'human-white-cane': I.mdiHumanWhiteCane,
  'humble-bundle': I.mdiHumbleBundle,
  hvac: I.mdiHvac,
  'hvac-off': I.mdiHvacOff,
  'hydraulic-oil-level': I.mdiHydraulicOilLevel,
  'hydraulic-oil-temperature': I.mdiHydraulicOilTemperature,
  'hydro-power': I.mdiHydroPower,
  'hydrogen-station': I.mdiHydrogenStation,
  'ice-cream': I.mdiIceCream,
  'ice-cream-off': I.mdiIceCreamOff,
  'ice-pop': I.mdiIcePop,
  'id-card': I.mdiIdCard,
  identifier: I.mdiIdentifier,
  'ideogram-cjk': I.mdiIdeogramCjk,
  'ideogram-cjk-variant': I.mdiIdeogramCjkVariant,
  image: I.mdiImage,
  'image-album': I.mdiImageAlbum,
  'image-area': I.mdiImageArea,
  'image-area-close': I.mdiImageAreaClose,
  'image-auto-adjust': I.mdiImageAutoAdjust,
  'image-broken': I.mdiImageBroken,
  'image-broken-variant': I.mdiImageBrokenVariant,
  'image-check': I.mdiImageCheck,
  'image-check-outline': I.mdiImageCheckOutline,
  'image-edit': I.mdiImageEdit,
  'image-edit-outline': I.mdiImageEditOutline,
  'image-filter-black-white': I.mdiImageFilterBlackWhite,
  'image-filter-center-focus': I.mdiImageFilterCenterFocus,
  'image-filter-center-focus-strong': I.mdiImageFilterCenterFocusStrong,
  'image-filter-center-focus-strong-outline':
    I.mdiImageFilterCenterFocusStrongOutline,
  'image-filter-center-focus-weak': I.mdiImageFilterCenterFocusWeak,
  'image-filter-drama': I.mdiImageFilterDrama,
  'image-filter-frames': I.mdiImageFilterFrames,
  'image-filter-hdr': I.mdiImageFilterHdr,
  'image-filter-none': I.mdiImageFilterNone,
  'image-filter-tilt-shift': I.mdiImageFilterTiltShift,
  'image-filter-vintage': I.mdiImageFilterVintage,
  'image-frame': I.mdiImageFrame,
  'image-lock': I.mdiImageLock,
  'image-lock-outline': I.mdiImageLockOutline,
  'image-marker': I.mdiImageMarker,
  'image-marker-outline': I.mdiImageMarkerOutline,
  'image-minus': I.mdiImageMinus,
  'image-minus-outline': I.mdiImageMinusOutline,
  'image-move': I.mdiImageMove,
  'image-multiple': I.mdiImageMultiple,
  'image-multiple-outline': I.mdiImageMultipleOutline,
  'image-off': I.mdiImageOff,
  'image-off-outline': I.mdiImageOffOutline,
  'image-outline': I.mdiImageOutline,
  'image-plus': I.mdiImagePlus,
  'image-plus-outline': I.mdiImagePlusOutline,
  'image-refresh': I.mdiImageRefresh,
  'image-refresh-outline': I.mdiImageRefreshOutline,
  'image-remove': I.mdiImageRemove,
  'image-remove-outline': I.mdiImageRemoveOutline,
  'image-search': I.mdiImageSearch,
  'image-search-outline': I.mdiImageSearchOutline,
  'image-size-select-actual': I.mdiImageSizeSelectActual,
  'image-size-select-large': I.mdiImageSizeSelectLarge,
  'image-size-select-small': I.mdiImageSizeSelectSmall,
  'image-sync': I.mdiImageSync,
  'image-sync-outline': I.mdiImageSyncOutline,
  'image-text': I.mdiImageText,
  import: I.mdiImport,
  inbox: I.mdiInbox,
  'inbox-arrow-down': I.mdiInboxArrowDown,
  'inbox-arrow-down-outline': I.mdiInboxArrowDownOutline,
  'inbox-arrow-up': I.mdiInboxArrowUp,
  'inbox-arrow-up-outline': I.mdiInboxArrowUpOutline,
  'inbox-full': I.mdiInboxFull,
  'inbox-full-outline': I.mdiInboxFullOutline,
  'inbox-multiple': I.mdiInboxMultiple,
  'inbox-multiple-outline': I.mdiInboxMultipleOutline,
  'inbox-outline': I.mdiInboxOutline,
  'inbox-remove': I.mdiInboxRemove,
  'inbox-remove-outline': I.mdiInboxRemoveOutline,
  incognito: I.mdiIncognito,
  'incognito-circle': I.mdiIncognitoCircle,
  'incognito-circle-off': I.mdiIncognitoCircleOff,
  'incognito-off': I.mdiIncognitoOff,
  induction: I.mdiInduction,
  infinity: I.mdiInfinity,
  information: I.mdiInformation,
  'information-off': I.mdiInformationOff,
  'information-off-outline': I.mdiInformationOffOutline,
  'information-outline': I.mdiInformationOutline,
  'information-variant': I.mdiInformationVariant,
  instagram: I.mdiInstagram,
  'instrument-triangle': I.mdiInstrumentTriangle,
  'integrated-circuit-chip': I.mdiIntegratedCircuitChip,
  'invert-colors': I.mdiInvertColors,
  'invert-colors-off': I.mdiInvertColorsOff,
  iobroker: I.mdiIobroker,
  ip: I.mdiIp,
  'ip-network': I.mdiIpNetwork,
  'ip-network-outline': I.mdiIpNetworkOutline,
  'ip-outline': I.mdiIpOutline,
  ipod: I.mdiIpod,
  iron: I.mdiIron,
  'iron-board': I.mdiIronBoard,
  'iron-outline': I.mdiIronOutline,
  island: I.mdiIsland,
  'iv-bag': I.mdiIvBag,
  jabber: I.mdiJabber,
  jeepney: I.mdiJeepney,
  jellyfish: I.mdiJellyfish,
  'jellyfish-outline': I.mdiJellyfishOutline,
  jira: I.mdiJira,
  jquery: I.mdiJquery,
  jsfiddle: I.mdiJsfiddle,
  'jump-rope': I.mdiJumpRope,
  kabaddi: I.mdiKabaddi,
  kangaroo: I.mdiKangaroo,
  karate: I.mdiKarate,
  kayaking: I.mdiKayaking,
  keg: I.mdiKeg,
  kettle: I.mdiKettle,
  'kettle-alert': I.mdiKettleAlert,
  'kettle-alert-outline': I.mdiKettleAlertOutline,
  'kettle-off': I.mdiKettleOff,
  'kettle-off-outline': I.mdiKettleOffOutline,
  'kettle-outline': I.mdiKettleOutline,
  'kettle-pour-over': I.mdiKettlePourOver,
  'kettle-steam': I.mdiKettleSteam,
  'kettle-steam-outline': I.mdiKettleSteamOutline,
  kettlebell: I.mdiKettlebell,
  key: I.mdiKey,
  'key-alert': I.mdiKeyAlert,
  'key-alert-outline': I.mdiKeyAlertOutline,
  'key-arrow-right': I.mdiKeyArrowRight,
  'key-chain': I.mdiKeyChain,
  'key-chain-variant': I.mdiKeyChainVariant,
  'key-change': I.mdiKeyChange,
  'key-link': I.mdiKeyLink,
  'key-minus': I.mdiKeyMinus,
  'key-outline': I.mdiKeyOutline,
  'key-plus': I.mdiKeyPlus,
  'key-remove': I.mdiKeyRemove,
  'key-star': I.mdiKeyStar,
  'key-variant': I.mdiKeyVariant,
  'key-wireless': I.mdiKeyWireless,
  keyboard: I.mdiKeyboard,
  'keyboard-backspace': I.mdiKeyboardBackspace,
  'keyboard-caps': I.mdiKeyboardCaps,
  'keyboard-close': I.mdiKeyboardClose,
  'keyboard-esc': I.mdiKeyboardEsc,
  'keyboard-f-1': I.mdiKeyboardF1,
  'keyboard-f-2': I.mdiKeyboardF2,
  'keyboard-f-3': I.mdiKeyboardF3,
  'keyboard-f-4': I.mdiKeyboardF4,
  'keyboard-f-5': I.mdiKeyboardF5,
  'keyboard-f-6': I.mdiKeyboardF6,
  'keyboard-f-7': I.mdiKeyboardF7,
  'keyboard-f-8': I.mdiKeyboardF8,
  'keyboard-f-9': I.mdiKeyboardF9,
  'keyboard-f-10': I.mdiKeyboardF10,
  'keyboard-f-11': I.mdiKeyboardF11,
  'keyboard-f-12': I.mdiKeyboardF12,
  'keyboard-off': I.mdiKeyboardOff,
  'keyboard-off-outline': I.mdiKeyboardOffOutline,
  'keyboard-outline': I.mdiKeyboardOutline,
  'keyboard-return': I.mdiKeyboardReturn,
  'keyboard-settings': I.mdiKeyboardSettings,
  'keyboard-settings-outline': I.mdiKeyboardSettingsOutline,
  'keyboard-space': I.mdiKeyboardSpace,
  'keyboard-tab': I.mdiKeyboardTab,
  'keyboard-tab-reverse': I.mdiKeyboardTabReverse,
  'keyboard-variant': I.mdiKeyboardVariant,
  khanda: I.mdiKhanda,
  kickstarter: I.mdiKickstarter,
  kite: I.mdiKite,
  'kite-outline': I.mdiKiteOutline,
  kitesurfing: I.mdiKitesurfing,
  klingon: I.mdiKlingon,
  knife: I.mdiKnife,
  'knife-military': I.mdiKnifeMilitary,
  knob: I.mdiKnob,
  koala: I.mdiKoala,
  kodi: I.mdiKodi,
  kubernetes: I.mdiKubernetes,
  label: I.mdiLabel,
  'label-multiple': I.mdiLabelMultiple,
  'label-multiple-outline': I.mdiLabelMultipleOutline,
  'label-off': I.mdiLabelOff,
  'label-off-outline': I.mdiLabelOffOutline,
  'label-outline': I.mdiLabelOutline,
  'label-percent': I.mdiLabelPercent,
  'label-percent-outline': I.mdiLabelPercentOutline,
  'label-variant': I.mdiLabelVariant,
  'label-variant-outline': I.mdiLabelVariantOutline,
  ladder: I.mdiLadder,
  ladybug: I.mdiLadybug,
  lambda: I.mdiLambda,
  lamp: I.mdiLamp,
  'lamp-outline': I.mdiLampOutline,
  lamps: I.mdiLamps,
  'lamps-outline': I.mdiLampsOutline,
  lan: I.mdiLan,
  'lan-check': I.mdiLanCheck,
  'lan-connect': I.mdiLanConnect,
  'lan-disconnect': I.mdiLanDisconnect,
  'lan-pending': I.mdiLanPending,
  'land-fields': I.mdiLandFields,
  'land-plots': I.mdiLandPlots,
  'land-plots-circle': I.mdiLandPlotsCircle,
  'land-plots-circle-variant': I.mdiLandPlotsCircleVariant,
  'land-rows-horizontal': I.mdiLandRowsHorizontal,
  'land-rows-vertical': I.mdiLandRowsVertical,
  landslide: I.mdiLandslide,
  'landslide-outline': I.mdiLandslideOutline,
  'language-c': I.mdiLanguageC,
  'language-cpp': I.mdiLanguageCpp,
  'language-csharp': I.mdiLanguageCsharp,
  'language-css-3': I.mdiLanguageCss3,
  'language-fortran': I.mdiLanguageFortran,
  'language-go': I.mdiLanguageGo,
  'language-haskell': I.mdiLanguageHaskell,
  'language-html-5': I.mdiLanguageHtml5,
  'language-java': I.mdiLanguageJava,
  'language-javascript': I.mdiLanguageJavascript,
  'language-kotlin': I.mdiLanguageKotlin,
  'language-lua': I.mdiLanguageLua,
  'language-markdown': I.mdiLanguageMarkdown,
  'language-markdown-outline': I.mdiLanguageMarkdownOutline,
  'language-php': I.mdiLanguagePhp,
  'language-python': I.mdiLanguagePython,
  'language-r': I.mdiLanguageR,
  'language-ruby': I.mdiLanguageRuby,
  'language-ruby-on-rails': I.mdiLanguageRubyOnRails,
  'language-rust': I.mdiLanguageRust,
  'language-swift': I.mdiLanguageSwift,
  'language-typescript': I.mdiLanguageTypescript,
  'language-xaml': I.mdiLanguageXaml,
  laptop: I.mdiLaptop,
  'laptop-account': I.mdiLaptopAccount,
  'laptop-off': I.mdiLaptopOff,
  laravel: I.mdiLaravel,
  'laser-pointer': I.mdiLaserPointer,
  lasso: I.mdiLasso,
  lastpass: I.mdiLastpass,
  latitude: I.mdiLatitude,
  launch: I.mdiLaunch,
  'lava-lamp': I.mdiLavaLamp,
  layers: I.mdiLayers,
  'layers-edit': I.mdiLayersEdit,
  'layers-minus': I.mdiLayersMinus,
  'layers-off': I.mdiLayersOff,
  'layers-off-outline': I.mdiLayersOffOutline,
  'layers-outline': I.mdiLayersOutline,
  'layers-plus': I.mdiLayersPlus,
  'layers-remove': I.mdiLayersRemove,
  'layers-search': I.mdiLayersSearch,
  'layers-search-outline': I.mdiLayersSearchOutline,
  'layers-triple': I.mdiLayersTriple,
  'layers-triple-outline': I.mdiLayersTripleOutline,
  'lead-pencil': I.mdiLeadPencil,
  leaf: I.mdiLeaf,
  'leaf-circle': I.mdiLeafCircle,
  'leaf-circle-outline': I.mdiLeafCircleOutline,
  'leaf-maple': I.mdiLeafMaple,
  'leaf-maple-off': I.mdiLeafMapleOff,
  'leaf-off': I.mdiLeafOff,
  leak: I.mdiLeak,
  'leak-off': I.mdiLeakOff,
  lectern: I.mdiLectern,
  'led-off': I.mdiLedOff,
  'led-on': I.mdiLedOn,
  'led-outline': I.mdiLedOutline,
  'led-strip': I.mdiLedStrip,
  'led-strip-variant': I.mdiLedStripVariant,
  'led-strip-variant-off': I.mdiLedStripVariantOff,
  'led-variant-off': I.mdiLedVariantOff,
  'led-variant-on': I.mdiLedVariantOn,
  'led-variant-outline': I.mdiLedVariantOutline,
  leek: I.mdiLeek,
  'less-than': I.mdiLessThan,
  'less-than-or-equal': I.mdiLessThanOrEqual,
  library: I.mdiLibrary,
  'library-outline': I.mdiLibraryOutline,
  'library-shelves': I.mdiLibraryShelves,
  license: I.mdiLicense,
  lifebuoy: I.mdiLifebuoy,
  'light-flood-down': I.mdiLightFloodDown,
  'light-flood-up': I.mdiLightFloodUp,
  'light-recessed': I.mdiLightRecessed,
  'light-switch': I.mdiLightSwitch,
  'light-switch-off': I.mdiLightSwitchOff,
  lightbulb: I.mdiLightbulb,
  'lightbulb-alert': I.mdiLightbulbAlert,
  'lightbulb-alert-outline': I.mdiLightbulbAlertOutline,
  'lightbulb-auto': I.mdiLightbulbAuto,
  'lightbulb-auto-outline': I.mdiLightbulbAutoOutline,
  'lightbulb-cfl': I.mdiLightbulbCfl,
  'lightbulb-cfl-off': I.mdiLightbulbCflOff,
  'lightbulb-cfl-spiral': I.mdiLightbulbCflSpiral,
  'lightbulb-cfl-spiral-off': I.mdiLightbulbCflSpiralOff,
  'lightbulb-fluorescent-tube': I.mdiLightbulbFluorescentTube,
  'lightbulb-fluorescent-tube-outline': I.mdiLightbulbFluorescentTubeOutline,
  'lightbulb-group': I.mdiLightbulbGroup,
  'lightbulb-group-off': I.mdiLightbulbGroupOff,
  'lightbulb-group-off-outline': I.mdiLightbulbGroupOffOutline,
  'lightbulb-group-outline': I.mdiLightbulbGroupOutline,
  'lightbulb-multiple': I.mdiLightbulbMultiple,
  'lightbulb-multiple-off': I.mdiLightbulbMultipleOff,
  'lightbulb-multiple-off-outline': I.mdiLightbulbMultipleOffOutline,
  'lightbulb-multiple-outline': I.mdiLightbulbMultipleOutline,
  'lightbulb-night': I.mdiLightbulbNight,
  'lightbulb-night-outline': I.mdiLightbulbNightOutline,
  'lightbulb-off': I.mdiLightbulbOff,
  'lightbulb-off-outline': I.mdiLightbulbOffOutline,
  'lightbulb-on': I.mdiLightbulbOn,
  'lightbulb-on-10': I.mdiLightbulbOn10,
  'lightbulb-on-20': I.mdiLightbulbOn20,
  'lightbulb-on-30': I.mdiLightbulbOn30,
  'lightbulb-on-40': I.mdiLightbulbOn40,
  'lightbulb-on-50': I.mdiLightbulbOn50,
  'lightbulb-on-60': I.mdiLightbulbOn60,
  'lightbulb-on-70': I.mdiLightbulbOn70,
  'lightbulb-on-80': I.mdiLightbulbOn80,
  'lightbulb-on-90': I.mdiLightbulbOn90,
  'lightbulb-on-outline': I.mdiLightbulbOnOutline,
  'lightbulb-outline': I.mdiLightbulbOutline,
  'lightbulb-question': I.mdiLightbulbQuestion,
  'lightbulb-question-outline': I.mdiLightbulbQuestionOutline,
  'lightbulb-spot': I.mdiLightbulbSpot,
  'lightbulb-spot-off': I.mdiLightbulbSpotOff,
  'lightbulb-variant': I.mdiLightbulbVariant,
  'lightbulb-variant-outline': I.mdiLightbulbVariantOutline,
  lighthouse: I.mdiLighthouse,
  'lighthouse-on': I.mdiLighthouseOn,
  'lightning-bolt': I.mdiLightningBolt,
  'lightning-bolt-circle': I.mdiLightningBoltCircle,
  'lightning-bolt-outline': I.mdiLightningBoltOutline,
  'line-scan': I.mdiLineScan,
  lingerie: I.mdiLingerie,
  link: I.mdiLink,
  'link-box': I.mdiLinkBox,
  'link-box-outline': I.mdiLinkBoxOutline,
  'link-box-variant': I.mdiLinkBoxVariant,
  'link-box-variant-outline': I.mdiLinkBoxVariantOutline,
  'link-lock': I.mdiLinkLock,
  'link-off': I.mdiLinkOff,
  'link-plus': I.mdiLinkPlus,
  'link-variant': I.mdiLinkVariant,
  'link-variant-minus': I.mdiLinkVariantMinus,
  'link-variant-off': I.mdiLinkVariantOff,
  'link-variant-plus': I.mdiLinkVariantPlus,
  'link-variant-remove': I.mdiLinkVariantRemove,
  linkedin: I.mdiLinkedin,
  linux: I.mdiLinux,
  'linux-mint': I.mdiLinuxMint,
  lipstick: I.mdiLipstick,
  'liquid-spot': I.mdiLiquidSpot,
  liquor: I.mdiLiquor,
  'list-box': I.mdiListBox,
  'list-box-outline': I.mdiListBoxOutline,
  'list-status': I.mdiListStatus,
  litecoin: I.mdiLitecoin,
  loading: I.mdiLoading,
  'location-enter': I.mdiLocationEnter,
  'location-exit': I.mdiLocationExit,
  lock: I.mdiLock,
  'lock-alert': I.mdiLockAlert,
  'lock-alert-outline': I.mdiLockAlertOutline,
  'lock-check': I.mdiLockCheck,
  'lock-check-outline': I.mdiLockCheckOutline,
  'lock-clock': I.mdiLockClock,
  'lock-minus': I.mdiLockMinus,
  'lock-minus-outline': I.mdiLockMinusOutline,
  'lock-off': I.mdiLockOff,
  'lock-off-outline': I.mdiLockOffOutline,
  'lock-open': I.mdiLockOpen,
  'lock-open-alert': I.mdiLockOpenAlert,
  'lock-open-alert-outline': I.mdiLockOpenAlertOutline,
  'lock-open-check': I.mdiLockOpenCheck,
  'lock-open-check-outline': I.mdiLockOpenCheckOutline,
  'lock-open-minus': I.mdiLockOpenMinus,
  'lock-open-minus-outline': I.mdiLockOpenMinusOutline,
  'lock-open-outline': I.mdiLockOpenOutline,
  'lock-open-plus': I.mdiLockOpenPlus,
  'lock-open-plus-outline': I.mdiLockOpenPlusOutline,
  'lock-open-remove': I.mdiLockOpenRemove,
  'lock-open-remove-outline': I.mdiLockOpenRemoveOutline,
  'lock-open-variant': I.mdiLockOpenVariant,
  'lock-open-variant-outline': I.mdiLockOpenVariantOutline,
  'lock-outline': I.mdiLockOutline,
  'lock-pattern': I.mdiLockPattern,
  'lock-plus': I.mdiLockPlus,
  'lock-plus-outline': I.mdiLockPlusOutline,
  'lock-question': I.mdiLockQuestion,
  'lock-remove': I.mdiLockRemove,
  'lock-remove-outline': I.mdiLockRemoveOutline,
  'lock-reset': I.mdiLockReset,
  'lock-smart': I.mdiLockSmart,
  locker: I.mdiLocker,
  'locker-multiple': I.mdiLockerMultiple,
  login: I.mdiLogin,
  'login-variant': I.mdiLoginVariant,
  logout: I.mdiLogout,
  'logout-variant': I.mdiLogoutVariant,
  longitude: I.mdiLongitude,
  looks: I.mdiLooks,
  lotion: I.mdiLotion,
  'lotion-outline': I.mdiLotionOutline,
  'lotion-plus': I.mdiLotionPlus,
  'lotion-plus-outline': I.mdiLotionPlusOutline,
  loupe: I.mdiLoupe,
  lumx: I.mdiLumx,
  lungs: I.mdiLungs,
  mace: I.mdiMace,
  'magazine-pistol': I.mdiMagazinePistol,
  'magazine-rifle': I.mdiMagazineRifle,
  'magic-staff': I.mdiMagicStaff,
  magnet: I.mdiMagnet,
  'magnet-on': I.mdiMagnetOn,
  magnify: I.mdiMagnify,
  'magnify-close': I.mdiMagnifyClose,
  'magnify-expand': I.mdiMagnifyExpand,
  'magnify-minus': I.mdiMagnifyMinus,
  'magnify-minus-cursor': I.mdiMagnifyMinusCursor,
  'magnify-minus-outline': I.mdiMagnifyMinusOutline,
  'magnify-plus': I.mdiMagnifyPlus,
  'magnify-plus-cursor': I.mdiMagnifyPlusCursor,
  'magnify-plus-outline': I.mdiMagnifyPlusOutline,
  'magnify-remove-cursor': I.mdiMagnifyRemoveCursor,
  'magnify-remove-outline': I.mdiMagnifyRemoveOutline,
  'magnify-scan': I.mdiMagnifyScan,
  mail: I.mdiMail,
  mailbox: I.mdiMailbox,
  'mailbox-open': I.mdiMailboxOpen,
  'mailbox-open-outline': I.mdiMailboxOpenOutline,
  'mailbox-open-up': I.mdiMailboxOpenUp,
  'mailbox-open-up-outline': I.mdiMailboxOpenUpOutline,
  'mailbox-outline': I.mdiMailboxOutline,
  'mailbox-up': I.mdiMailboxUp,
  'mailbox-up-outline': I.mdiMailboxUpOutline,
  manjaro: I.mdiManjaro,
  map: I.mdiMap,
  'map-check': I.mdiMapCheck,
  'map-check-outline': I.mdiMapCheckOutline,
  'map-clock': I.mdiMapClock,
  'map-clock-outline': I.mdiMapClockOutline,
  'map-legend': I.mdiMapLegend,
  'map-marker': I.mdiMapMarker,
  'map-marker-account': I.mdiMapMarkerAccount,
  'map-marker-account-outline': I.mdiMapMarkerAccountOutline,
  'map-marker-alert': I.mdiMapMarkerAlert,
  'map-marker-alert-outline': I.mdiMapMarkerAlertOutline,
  'map-marker-check': I.mdiMapMarkerCheck,
  'map-marker-check-outline': I.mdiMapMarkerCheckOutline,
  'map-marker-circle': I.mdiMapMarkerCircle,
  'map-marker-distance': I.mdiMapMarkerDistance,
  'map-marker-down': I.mdiMapMarkerDown,
  'map-marker-left': I.mdiMapMarkerLeft,
  'map-marker-left-outline': I.mdiMapMarkerLeftOutline,
  'map-marker-minus': I.mdiMapMarkerMinus,
  'map-marker-minus-outline': I.mdiMapMarkerMinusOutline,
  'map-marker-multiple': I.mdiMapMarkerMultiple,
  'map-marker-multiple-outline': I.mdiMapMarkerMultipleOutline,
  'map-marker-off': I.mdiMapMarkerOff,
  'map-marker-off-outline': I.mdiMapMarkerOffOutline,
  'map-marker-outline': I.mdiMapMarkerOutline,
  'map-marker-path': I.mdiMapMarkerPath,
  'map-marker-plus': I.mdiMapMarkerPlus,
  'map-marker-plus-outline': I.mdiMapMarkerPlusOutline,
  'map-marker-question': I.mdiMapMarkerQuestion,
  'map-marker-question-outline': I.mdiMapMarkerQuestionOutline,
  'map-marker-radius': I.mdiMapMarkerRadius,
  'map-marker-radius-outline': I.mdiMapMarkerRadiusOutline,
  'map-marker-remove': I.mdiMapMarkerRemove,
  'map-marker-remove-outline': I.mdiMapMarkerRemoveOutline,
  'map-marker-remove-variant': I.mdiMapMarkerRemoveVariant,
  'map-marker-right': I.mdiMapMarkerRight,
  'map-marker-right-outline': I.mdiMapMarkerRightOutline,
  'map-marker-star': I.mdiMapMarkerStar,
  'map-marker-star-outline': I.mdiMapMarkerStarOutline,
  'map-marker-up': I.mdiMapMarkerUp,
  'map-minus': I.mdiMapMinus,
  'map-outline': I.mdiMapOutline,
  'map-plus': I.mdiMapPlus,
  'map-search': I.mdiMapSearch,
  'map-search-outline': I.mdiMapSearchOutline,
  mapbox: I.mdiMapbox,
  margin: I.mdiMargin,
  marker: I.mdiMarker,
  'marker-cancel': I.mdiMarkerCancel,
  'marker-check': I.mdiMarkerCheck,
  mastodon: I.mdiMastodon,
  'material-design': I.mdiMaterialDesign,
  'material-ui': I.mdiMaterialUi,
  'math-compass': I.mdiMathCompass,
  'math-cos': I.mdiMathCos,
  'math-integral': I.mdiMathIntegral,
  'math-integral-box': I.mdiMathIntegralBox,
  'math-log': I.mdiMathLog,
  'math-norm': I.mdiMathNorm,
  'math-norm-box': I.mdiMathNormBox,
  'math-sin': I.mdiMathSin,
  'math-tan': I.mdiMathTan,
  matrix: I.mdiMatrix,
  medal: I.mdiMedal,
  'medal-outline': I.mdiMedalOutline,
  'medical-bag': I.mdiMedicalBag,
  'medical-cotton-swab': I.mdiMedicalCottonSwab,
  medication: I.mdiMedication,
  'medication-outline': I.mdiMedicationOutline,
  meditation: I.mdiMeditation,
  memory: I.mdiMemory,
  menorah: I.mdiMenorah,
  'menorah-fire': I.mdiMenorahFire,
  menu: I.mdiMenu,
  'menu-down': I.mdiMenuDown,
  'menu-down-outline': I.mdiMenuDownOutline,
  'menu-left': I.mdiMenuLeft,
  'menu-left-outline': I.mdiMenuLeftOutline,
  'menu-open': I.mdiMenuOpen,
  'menu-right': I.mdiMenuRight,
  'menu-right-outline': I.mdiMenuRightOutline,
  'menu-swap': I.mdiMenuSwap,
  'menu-swap-outline': I.mdiMenuSwapOutline,
  'menu-up': I.mdiMenuUp,
  'menu-up-outline': I.mdiMenuUpOutline,
  merge: I.mdiMerge,
  message: I.mdiMessage,
  'message-alert': I.mdiMessageAlert,
  'message-alert-outline': I.mdiMessageAlertOutline,
  'message-arrow-left': I.mdiMessageArrowLeft,
  'message-arrow-left-outline': I.mdiMessageArrowLeftOutline,
  'message-arrow-right': I.mdiMessageArrowRight,
  'message-arrow-right-outline': I.mdiMessageArrowRightOutline,
  'message-badge': I.mdiMessageBadge,
  'message-badge-outline': I.mdiMessageBadgeOutline,
  'message-bookmark': I.mdiMessageBookmark,
  'message-bookmark-outline': I.mdiMessageBookmarkOutline,
  'message-bulleted': I.mdiMessageBulleted,
  'message-bulleted-off': I.mdiMessageBulletedOff,
  'message-check': I.mdiMessageCheck,
  'message-check-outline': I.mdiMessageCheckOutline,
  'message-cog': I.mdiMessageCog,
  'message-cog-outline': I.mdiMessageCogOutline,
  'message-draw': I.mdiMessageDraw,
  'message-fast': I.mdiMessageFast,
  'message-fast-outline': I.mdiMessageFastOutline,
  'message-flash': I.mdiMessageFlash,
  'message-flash-outline': I.mdiMessageFlashOutline,
  'message-image': I.mdiMessageImage,
  'message-image-outline': I.mdiMessageImageOutline,
  'message-lock': I.mdiMessageLock,
  'message-lock-outline': I.mdiMessageLockOutline,
  'message-minus': I.mdiMessageMinus,
  'message-minus-outline': I.mdiMessageMinusOutline,
  'message-off': I.mdiMessageOff,
  'message-off-outline': I.mdiMessageOffOutline,
  'message-outline': I.mdiMessageOutline,
  'message-plus': I.mdiMessagePlus,
  'message-plus-outline': I.mdiMessagePlusOutline,
  'message-processing': I.mdiMessageProcessing,
  'message-processing-outline': I.mdiMessageProcessingOutline,
  'message-question': I.mdiMessageQuestion,
  'message-question-outline': I.mdiMessageQuestionOutline,
  'message-reply': I.mdiMessageReply,
  'message-reply-outline': I.mdiMessageReplyOutline,
  'message-reply-text': I.mdiMessageReplyText,
  'message-reply-text-outline': I.mdiMessageReplyTextOutline,
  'message-settings': I.mdiMessageSettings,
  'message-settings-outline': I.mdiMessageSettingsOutline,
  'message-star': I.mdiMessageStar,
  'message-star-outline': I.mdiMessageStarOutline,
  'message-text': I.mdiMessageText,
  'message-text-clock': I.mdiMessageTextClock,
  'message-text-clock-outline': I.mdiMessageTextClockOutline,
  'message-text-fast': I.mdiMessageTextFast,
  'message-text-fast-outline': I.mdiMessageTextFastOutline,
  'message-text-lock': I.mdiMessageTextLock,
  'message-text-lock-outline': I.mdiMessageTextLockOutline,
  'message-text-outline': I.mdiMessageTextOutline,
  'message-video': I.mdiMessageVideo,
  meteor: I.mdiMeteor,
  'meter-electric': I.mdiMeterElectric,
  'meter-electric-outline': I.mdiMeterElectricOutline,
  'meter-gas': I.mdiMeterGas,
  'meter-gas-outline': I.mdiMeterGasOutline,
  metronome: I.mdiMetronome,
  'metronome-tick': I.mdiMetronomeTick,
  'micro-sd': I.mdiMicroSd,
  microphone: I.mdiMicrophone,
  'microphone-message': I.mdiMicrophoneMessage,
  'microphone-message-off': I.mdiMicrophoneMessageOff,
  'microphone-minus': I.mdiMicrophoneMinus,
  'microphone-off': I.mdiMicrophoneOff,
  'microphone-outline': I.mdiMicrophoneOutline,
  'microphone-plus': I.mdiMicrophonePlus,
  'microphone-question': I.mdiMicrophoneQuestion,
  'microphone-question-outline': I.mdiMicrophoneQuestionOutline,
  'microphone-settings': I.mdiMicrophoneSettings,
  'microphone-variant': I.mdiMicrophoneVariant,
  'microphone-variant-off': I.mdiMicrophoneVariantOff,
  microscope: I.mdiMicroscope,
  microsoft: I.mdiMicrosoft,
  'microsoft-access': I.mdiMicrosoftAccess,
  'microsoft-azure': I.mdiMicrosoftAzure,
  'microsoft-azure-devops': I.mdiMicrosoftAzureDevops,
  'microsoft-bing': I.mdiMicrosoftBing,
  'microsoft-dynamics-365': I.mdiMicrosoftDynamics365,
  'microsoft-edge': I.mdiMicrosoftEdge,
  'microsoft-excel': I.mdiMicrosoftExcel,
  'microsoft-internet-explorer': I.mdiMicrosoftInternetExplorer,
  'microsoft-office': I.mdiMicrosoftOffice,
  'microsoft-onedrive': I.mdiMicrosoftOnedrive,
  'microsoft-onenote': I.mdiMicrosoftOnenote,
  'microsoft-outlook': I.mdiMicrosoftOutlook,
  'microsoft-powerpoint': I.mdiMicrosoftPowerpoint,
  'microsoft-sharepoint': I.mdiMicrosoftSharepoint,
  'microsoft-teams': I.mdiMicrosoftTeams,
  'microsoft-visual-studio': I.mdiMicrosoftVisualStudio,
  'microsoft-visual-studio-code': I.mdiMicrosoftVisualStudioCode,
  'microsoft-windows': I.mdiMicrosoftWindows,
  'microsoft-windows-classic': I.mdiMicrosoftWindowsClassic,
  'microsoft-word': I.mdiMicrosoftWord,
  'microsoft-xbox': I.mdiMicrosoftXbox,
  'microsoft-xbox-controller': I.mdiMicrosoftXboxController,
  'microsoft-xbox-controller-battery-alert':
    I.mdiMicrosoftXboxControllerBatteryAlert,
  'microsoft-xbox-controller-battery-charging':
    I.mdiMicrosoftXboxControllerBatteryCharging,
  'microsoft-xbox-controller-battery-empty':
    I.mdiMicrosoftXboxControllerBatteryEmpty,
  'microsoft-xbox-controller-battery-full':
    I.mdiMicrosoftXboxControllerBatteryFull,
  'microsoft-xbox-controller-battery-low':
    I.mdiMicrosoftXboxControllerBatteryLow,
  'microsoft-xbox-controller-battery-medium':
    I.mdiMicrosoftXboxControllerBatteryMedium,
  'microsoft-xbox-controller-battery-unknown':
    I.mdiMicrosoftXboxControllerBatteryUnknown,
  'microsoft-xbox-controller-menu': I.mdiMicrosoftXboxControllerMenu,
  'microsoft-xbox-controller-off': I.mdiMicrosoftXboxControllerOff,
  'microsoft-xbox-controller-view': I.mdiMicrosoftXboxControllerView,
  microwave: I.mdiMicrowave,
  'microwave-off': I.mdiMicrowaveOff,
  middleware: I.mdiMiddleware,
  'middleware-outline': I.mdiMiddlewareOutline,
  midi: I.mdiMidi,
  'midi-port': I.mdiMidiPort,
  mine: I.mdiMine,
  minecraft: I.mdiMinecraft,
  'mini-sd': I.mdiMiniSd,
  minidisc: I.mdiMinidisc,
  minus: I.mdiMinus,
  'minus-box': I.mdiMinusBox,
  'minus-box-multiple': I.mdiMinusBoxMultiple,
  'minus-box-multiple-outline': I.mdiMinusBoxMultipleOutline,
  'minus-box-outline': I.mdiMinusBoxOutline,
  'minus-circle': I.mdiMinusCircle,
  'minus-circle-multiple': I.mdiMinusCircleMultiple,
  'minus-circle-multiple-outline': I.mdiMinusCircleMultipleOutline,
  'minus-circle-off': I.mdiMinusCircleOff,
  'minus-circle-off-outline': I.mdiMinusCircleOffOutline,
  'minus-circle-outline': I.mdiMinusCircleOutline,
  'minus-network': I.mdiMinusNetwork,
  'minus-network-outline': I.mdiMinusNetworkOutline,
  'minus-thick': I.mdiMinusThick,
  mirror: I.mdiMirror,
  'mirror-rectangle': I.mdiMirrorRectangle,
  'mirror-variant': I.mdiMirrorVariant,
  'mixed-martial-arts': I.mdiMixedMartialArts,
  'mixed-reality': I.mdiMixedReality,
  molecule: I.mdiMolecule,
  'molecule-co': I.mdiMoleculeCo,
  'molecule-co-2': I.mdiMoleculeCo2,
  monitor: I.mdiMonitor,
  'monitor-account': I.mdiMonitorAccount,
  'monitor-arrow-down': I.mdiMonitorArrowDown,
  'monitor-arrow-down-variant': I.mdiMonitorArrowDownVariant,
  'monitor-cellphone': I.mdiMonitorCellphone,
  'monitor-cellphone-star': I.mdiMonitorCellphoneStar,
  'monitor-dashboard': I.mdiMonitorDashboard,
  'monitor-edit': I.mdiMonitorEdit,
  'monitor-eye': I.mdiMonitorEye,
  'monitor-lock': I.mdiMonitorLock,
  'monitor-multiple': I.mdiMonitorMultiple,
  'monitor-off': I.mdiMonitorOff,
  'monitor-screenshot': I.mdiMonitorScreenshot,
  'monitor-share': I.mdiMonitorShare,
  'monitor-shimmer': I.mdiMonitorShimmer,
  'monitor-small': I.mdiMonitorSmall,
  'monitor-speaker': I.mdiMonitorSpeaker,
  'monitor-speaker-off': I.mdiMonitorSpeakerOff,
  'monitor-star': I.mdiMonitorStar,
  'moon-first-quarter': I.mdiMoonFirstQuarter,
  'moon-full': I.mdiMoonFull,
  'moon-last-quarter': I.mdiMoonLastQuarter,
  'moon-new': I.mdiMoonNew,
  'moon-waning-crescent': I.mdiMoonWaningCrescent,
  'moon-waning-gibbous': I.mdiMoonWaningGibbous,
  'moon-waxing-crescent': I.mdiMoonWaxingCrescent,
  'moon-waxing-gibbous': I.mdiMoonWaxingGibbous,
  moped: I.mdiMoped,
  'moped-electric': I.mdiMopedElectric,
  'moped-electric-outline': I.mdiMopedElectricOutline,
  'moped-outline': I.mdiMopedOutline,
  more: I.mdiMore,
  'mortar-pestle': I.mdiMortarPestle,
  'mortar-pestle-plus': I.mdiMortarPestlePlus,
  mosque: I.mdiMosque,
  'mosque-outline': I.mdiMosqueOutline,
  'mother-heart': I.mdiMotherHeart,
  'mother-nurse': I.mdiMotherNurse,
  motion: I.mdiMotion,
  'motion-outline': I.mdiMotionOutline,
  'motion-pause': I.mdiMotionPause,
  'motion-pause-outline': I.mdiMotionPauseOutline,
  'motion-play': I.mdiMotionPlay,
  'motion-play-outline': I.mdiMotionPlayOutline,
  'motion-sensor': I.mdiMotionSensor,
  'motion-sensor-off': I.mdiMotionSensorOff,
  motorbike: I.mdiMotorbike,
  'motorbike-electric': I.mdiMotorbikeElectric,
  'motorbike-off': I.mdiMotorbikeOff,
  mouse: I.mdiMouse,
  'mouse-bluetooth': I.mdiMouseBluetooth,
  'mouse-move-down': I.mdiMouseMoveDown,
  'mouse-move-up': I.mdiMouseMoveUp,
  'mouse-move-vertical': I.mdiMouseMoveVertical,
  'mouse-off': I.mdiMouseOff,
  'mouse-variant': I.mdiMouseVariant,
  'mouse-variant-off': I.mdiMouseVariantOff,
  'move-resize': I.mdiMoveResize,
  'move-resize-variant': I.mdiMoveResizeVariant,
  movie: I.mdiMovie,
  'movie-check': I.mdiMovieCheck,
  'movie-check-outline': I.mdiMovieCheckOutline,
  'movie-cog': I.mdiMovieCog,
  'movie-cog-outline': I.mdiMovieCogOutline,
  'movie-edit': I.mdiMovieEdit,
  'movie-edit-outline': I.mdiMovieEditOutline,
  'movie-filter': I.mdiMovieFilter,
  'movie-filter-outline': I.mdiMovieFilterOutline,
  'movie-minus': I.mdiMovieMinus,
  'movie-minus-outline': I.mdiMovieMinusOutline,
  'movie-off': I.mdiMovieOff,
  'movie-off-outline': I.mdiMovieOffOutline,
  'movie-open': I.mdiMovieOpen,
  'movie-open-check': I.mdiMovieOpenCheck,
  'movie-open-check-outline': I.mdiMovieOpenCheckOutline,
  'movie-open-cog': I.mdiMovieOpenCog,
  'movie-open-cog-outline': I.mdiMovieOpenCogOutline,
  'movie-open-edit': I.mdiMovieOpenEdit,
  'movie-open-edit-outline': I.mdiMovieOpenEditOutline,
  'movie-open-minus': I.mdiMovieOpenMinus,
  'movie-open-minus-outline': I.mdiMovieOpenMinusOutline,
  'movie-open-off': I.mdiMovieOpenOff,
  'movie-open-off-outline': I.mdiMovieOpenOffOutline,
  'movie-open-outline': I.mdiMovieOpenOutline,
  'movie-open-play': I.mdiMovieOpenPlay,
  'movie-open-play-outline': I.mdiMovieOpenPlayOutline,
  'movie-open-plus': I.mdiMovieOpenPlus,
  'movie-open-plus-outline': I.mdiMovieOpenPlusOutline,
  'movie-open-remove': I.mdiMovieOpenRemove,
  'movie-open-remove-outline': I.mdiMovieOpenRemoveOutline,
  'movie-open-settings': I.mdiMovieOpenSettings,
  'movie-open-settings-outline': I.mdiMovieOpenSettingsOutline,
  'movie-open-star': I.mdiMovieOpenStar,
  'movie-open-star-outline': I.mdiMovieOpenStarOutline,
  'movie-outline': I.mdiMovieOutline,
  'movie-play': I.mdiMoviePlay,
  'movie-play-outline': I.mdiMoviePlayOutline,
  'movie-plus': I.mdiMoviePlus,
  'movie-plus-outline': I.mdiMoviePlusOutline,
  'movie-remove': I.mdiMovieRemove,
  'movie-remove-outline': I.mdiMovieRemoveOutline,
  'movie-roll': I.mdiMovieRoll,
  'movie-search': I.mdiMovieSearch,
  'movie-search-outline': I.mdiMovieSearchOutline,
  'movie-settings': I.mdiMovieSettings,
  'movie-settings-outline': I.mdiMovieSettingsOutline,
  'movie-star': I.mdiMovieStar,
  'movie-star-outline': I.mdiMovieStarOutline,
  mower: I.mdiMower,
  'mower-bag': I.mdiMowerBag,
  'mower-bag-on': I.mdiMowerBagOn,
  'mower-on': I.mdiMowerOn,
  muffin: I.mdiMuffin,
  multicast: I.mdiMulticast,
  multimedia: I.mdiMultimedia,
  multiplication: I.mdiMultiplication,
  'multiplication-box': I.mdiMultiplicationBox,
  mushroom: I.mdiMushroom,
  'mushroom-off': I.mdiMushroomOff,
  'mushroom-off-outline': I.mdiMushroomOffOutline,
  'mushroom-outline': I.mdiMushroomOutline,
  music: I.mdiMusic,
  'music-accidental-double-flat': I.mdiMusicAccidentalDoubleFlat,
  'music-accidental-double-sharp': I.mdiMusicAccidentalDoubleSharp,
  'music-accidental-flat': I.mdiMusicAccidentalFlat,
  'music-accidental-natural': I.mdiMusicAccidentalNatural,
  'music-accidental-sharp': I.mdiMusicAccidentalSharp,
  'music-box': I.mdiMusicBox,
  'music-box-multiple': I.mdiMusicBoxMultiple,
  'music-box-multiple-outline': I.mdiMusicBoxMultipleOutline,
  'music-box-outline': I.mdiMusicBoxOutline,
  'music-circle': I.mdiMusicCircle,
  'music-circle-outline': I.mdiMusicCircleOutline,
  'music-clef-alto': I.mdiMusicClefAlto,
  'music-clef-bass': I.mdiMusicClefBass,
  'music-clef-treble': I.mdiMusicClefTreble,
  'music-note': I.mdiMusicNote,
  'music-note-bluetooth': I.mdiMusicNoteBluetooth,
  'music-note-bluetooth-off': I.mdiMusicNoteBluetoothOff,
  'music-note-eighth': I.mdiMusicNoteEighth,
  'music-note-eighth-dotted': I.mdiMusicNoteEighthDotted,
  'music-note-half': I.mdiMusicNoteHalf,
  'music-note-half-dotted': I.mdiMusicNoteHalfDotted,
  'music-note-minus': I.mdiMusicNoteMinus,
  'music-note-off': I.mdiMusicNoteOff,
  'music-note-off-outline': I.mdiMusicNoteOffOutline,
  'music-note-outline': I.mdiMusicNoteOutline,
  'music-note-plus': I.mdiMusicNotePlus,
  'music-note-quarter': I.mdiMusicNoteQuarter,
  'music-note-quarter-dotted': I.mdiMusicNoteQuarterDotted,
  'music-note-sixteenth': I.mdiMusicNoteSixteenth,
  'music-note-sixteenth-dotted': I.mdiMusicNoteSixteenthDotted,
  'music-note-whole': I.mdiMusicNoteWhole,
  'music-note-whole-dotted': I.mdiMusicNoteWholeDotted,
  'music-off': I.mdiMusicOff,
  'music-rest-eighth': I.mdiMusicRestEighth,
  'music-rest-half': I.mdiMusicRestHalf,
  'music-rest-quarter': I.mdiMusicRestQuarter,
  'music-rest-sixteenth': I.mdiMusicRestSixteenth,
  'music-rest-whole': I.mdiMusicRestWhole,
  mustache: I.mdiMustache,
  nail: I.mdiNail,
  nas: I.mdiNas,
  nativescript: I.mdiNativescript,
  nature: I.mdiNature,
  'nature-people': I.mdiNaturePeople,
  navigation: I.mdiNavigation,
  'navigation-outline': I.mdiNavigationOutline,
  'navigation-variant': I.mdiNavigationVariant,
  'navigation-variant-outline': I.mdiNavigationVariantOutline,
  'near-me': I.mdiNearMe,
  necklace: I.mdiNecklace,
  needle: I.mdiNeedle,
  'needle-off': I.mdiNeedleOff,
  netflix: I.mdiNetflix,
  network: I.mdiNetwork,
  'network-off': I.mdiNetworkOff,
  'network-off-outline': I.mdiNetworkOffOutline,
  'network-outline': I.mdiNetworkOutline,
  'network-pos': I.mdiNetworkPos,
  'network-strength-1': I.mdiNetworkStrength1,
  'network-strength-1-alert': I.mdiNetworkStrength1Alert,
  'network-strength-2': I.mdiNetworkStrength2,
  'network-strength-2-alert': I.mdiNetworkStrength2Alert,
  'network-strength-3': I.mdiNetworkStrength3,
  'network-strength-3-alert': I.mdiNetworkStrength3Alert,
  'network-strength-4': I.mdiNetworkStrength4,
  'network-strength-4-alert': I.mdiNetworkStrength4Alert,
  'network-strength-4-cog': I.mdiNetworkStrength4Cog,
  'network-strength-off': I.mdiNetworkStrengthOff,
  'network-strength-off-outline': I.mdiNetworkStrengthOffOutline,
  'network-strength-outline': I.mdiNetworkStrengthOutline,
  'new-box': I.mdiNewBox,
  newspaper: I.mdiNewspaper,
  'newspaper-check': I.mdiNewspaperCheck,
  'newspaper-minus': I.mdiNewspaperMinus,
  'newspaper-plus': I.mdiNewspaperPlus,
  'newspaper-remove': I.mdiNewspaperRemove,
  'newspaper-variant': I.mdiNewspaperVariant,
  'newspaper-variant-multiple': I.mdiNewspaperVariantMultiple,
  'newspaper-variant-multiple-outline': I.mdiNewspaperVariantMultipleOutline,
  'newspaper-variant-outline': I.mdiNewspaperVariantOutline,
  nfc: I.mdiNfc,
  'nfc-search-variant': I.mdiNfcSearchVariant,
  'nfc-tap': I.mdiNfcTap,
  'nfc-variant': I.mdiNfcVariant,
  'nfc-variant-off': I.mdiNfcVariantOff,
  ninja: I.mdiNinja,
  'nintendo-game-boy': I.mdiNintendoGameBoy,
  'nintendo-switch': I.mdiNintendoSwitch,
  'nintendo-wii': I.mdiNintendoWii,
  'nintendo-wiiu': I.mdiNintendoWiiu,
  nix: I.mdiNix,
  nodejs: I.mdiNodejs,
  noodles: I.mdiNoodles,
  'not-equal': I.mdiNotEqual,
  'not-equal-variant': I.mdiNotEqualVariant,
  note: I.mdiNote,
  'note-alert': I.mdiNoteAlert,
  'note-alert-outline': I.mdiNoteAlertOutline,
  'note-check': I.mdiNoteCheck,
  'note-check-outline': I.mdiNoteCheckOutline,
  'note-edit': I.mdiNoteEdit,
  'note-edit-outline': I.mdiNoteEditOutline,
  'note-minus': I.mdiNoteMinus,
  'note-minus-outline': I.mdiNoteMinusOutline,
  'note-multiple': I.mdiNoteMultiple,
  'note-multiple-outline': I.mdiNoteMultipleOutline,
  'note-off': I.mdiNoteOff,
  'note-off-outline': I.mdiNoteOffOutline,
  'note-outline': I.mdiNoteOutline,
  'note-plus': I.mdiNotePlus,
  'note-plus-outline': I.mdiNotePlusOutline,
  'note-remove': I.mdiNoteRemove,
  'note-remove-outline': I.mdiNoteRemoveOutline,
  'note-search': I.mdiNoteSearch,
  'note-search-outline': I.mdiNoteSearchOutline,
  'note-text': I.mdiNoteText,
  'note-text-outline': I.mdiNoteTextOutline,
  notebook: I.mdiNotebook,
  'notebook-check': I.mdiNotebookCheck,
  'notebook-check-outline': I.mdiNotebookCheckOutline,
  'notebook-edit': I.mdiNotebookEdit,
  'notebook-edit-outline': I.mdiNotebookEditOutline,
  'notebook-heart': I.mdiNotebookHeart,
  'notebook-heart-outline': I.mdiNotebookHeartOutline,
  'notebook-minus': I.mdiNotebookMinus,
  'notebook-minus-outline': I.mdiNotebookMinusOutline,
  'notebook-multiple': I.mdiNotebookMultiple,
  'notebook-outline': I.mdiNotebookOutline,
  'notebook-plus': I.mdiNotebookPlus,
  'notebook-plus-outline': I.mdiNotebookPlusOutline,
  'notebook-remove': I.mdiNotebookRemove,
  'notebook-remove-outline': I.mdiNotebookRemoveOutline,
  'notification-clear-all': I.mdiNotificationClearAll,
  npm: I.mdiNpm,
  nuke: I.mdiNuke,
  null: I.mdiNull,
  numeric: I.mdiNumeric,
  'numeric-0': I.mdiNumeric0,
  'numeric-0-box': I.mdiNumeric0Box,
  'numeric-0-box-multiple': I.mdiNumeric0BoxMultiple,
  'numeric-0-box-multiple-outline': I.mdiNumeric0BoxMultipleOutline,
  'numeric-0-box-outline': I.mdiNumeric0BoxOutline,
  'numeric-0-circle': I.mdiNumeric0Circle,
  'numeric-0-circle-outline': I.mdiNumeric0CircleOutline,
  'numeric-1': I.mdiNumeric1,
  'numeric-1-box': I.mdiNumeric1Box,
  'numeric-1-box-multiple': I.mdiNumeric1BoxMultiple,
  'numeric-1-box-multiple-outline': I.mdiNumeric1BoxMultipleOutline,
  'numeric-1-box-outline': I.mdiNumeric1BoxOutline,
  'numeric-1-circle': I.mdiNumeric1Circle,
  'numeric-1-circle-outline': I.mdiNumeric1CircleOutline,
  'numeric-2': I.mdiNumeric2,
  'numeric-2-box': I.mdiNumeric2Box,
  'numeric-2-box-multiple': I.mdiNumeric2BoxMultiple,
  'numeric-2-box-multiple-outline': I.mdiNumeric2BoxMultipleOutline,
  'numeric-2-box-outline': I.mdiNumeric2BoxOutline,
  'numeric-2-circle': I.mdiNumeric2Circle,
  'numeric-2-circle-outline': I.mdiNumeric2CircleOutline,
  'numeric-3': I.mdiNumeric3,
  'numeric-3-box': I.mdiNumeric3Box,
  'numeric-3-box-multiple': I.mdiNumeric3BoxMultiple,
  'numeric-3-box-multiple-outline': I.mdiNumeric3BoxMultipleOutline,
  'numeric-3-box-outline': I.mdiNumeric3BoxOutline,
  'numeric-3-circle': I.mdiNumeric3Circle,
  'numeric-3-circle-outline': I.mdiNumeric3CircleOutline,
  'numeric-4': I.mdiNumeric4,
  'numeric-4-box': I.mdiNumeric4Box,
  'numeric-4-box-multiple': I.mdiNumeric4BoxMultiple,
  'numeric-4-box-multiple-outline': I.mdiNumeric4BoxMultipleOutline,
  'numeric-4-box-outline': I.mdiNumeric4BoxOutline,
  'numeric-4-circle': I.mdiNumeric4Circle,
  'numeric-4-circle-outline': I.mdiNumeric4CircleOutline,
  'numeric-5': I.mdiNumeric5,
  'numeric-5-box': I.mdiNumeric5Box,
  'numeric-5-box-multiple': I.mdiNumeric5BoxMultiple,
  'numeric-5-box-multiple-outline': I.mdiNumeric5BoxMultipleOutline,
  'numeric-5-box-outline': I.mdiNumeric5BoxOutline,
  'numeric-5-circle': I.mdiNumeric5Circle,
  'numeric-5-circle-outline': I.mdiNumeric5CircleOutline,
  'numeric-6': I.mdiNumeric6,
  'numeric-6-box': I.mdiNumeric6Box,
  'numeric-6-box-multiple': I.mdiNumeric6BoxMultiple,
  'numeric-6-box-multiple-outline': I.mdiNumeric6BoxMultipleOutline,
  'numeric-6-box-outline': I.mdiNumeric6BoxOutline,
  'numeric-6-circle': I.mdiNumeric6Circle,
  'numeric-6-circle-outline': I.mdiNumeric6CircleOutline,
  'numeric-7': I.mdiNumeric7,
  'numeric-7-box': I.mdiNumeric7Box,
  'numeric-7-box-multiple': I.mdiNumeric7BoxMultiple,
  'numeric-7-box-multiple-outline': I.mdiNumeric7BoxMultipleOutline,
  'numeric-7-box-outline': I.mdiNumeric7BoxOutline,
  'numeric-7-circle': I.mdiNumeric7Circle,
  'numeric-7-circle-outline': I.mdiNumeric7CircleOutline,
  'numeric-8': I.mdiNumeric8,
  'numeric-8-box': I.mdiNumeric8Box,
  'numeric-8-box-multiple': I.mdiNumeric8BoxMultiple,
  'numeric-8-box-multiple-outline': I.mdiNumeric8BoxMultipleOutline,
  'numeric-8-box-outline': I.mdiNumeric8BoxOutline,
  'numeric-8-circle': I.mdiNumeric8Circle,
  'numeric-8-circle-outline': I.mdiNumeric8CircleOutline,
  'numeric-9': I.mdiNumeric9,
  'numeric-9-box': I.mdiNumeric9Box,
  'numeric-9-box-multiple': I.mdiNumeric9BoxMultiple,
  'numeric-9-box-multiple-outline': I.mdiNumeric9BoxMultipleOutline,
  'numeric-9-box-outline': I.mdiNumeric9BoxOutline,
  'numeric-9-circle': I.mdiNumeric9Circle,
  'numeric-9-circle-outline': I.mdiNumeric9CircleOutline,
  'numeric-9-plus': I.mdiNumeric9Plus,
  'numeric-9-plus-box': I.mdiNumeric9PlusBox,
  'numeric-9-plus-box-multiple': I.mdiNumeric9PlusBoxMultiple,
  'numeric-9-plus-box-multiple-outline': I.mdiNumeric9PlusBoxMultipleOutline,
  'numeric-9-plus-box-outline': I.mdiNumeric9PlusBoxOutline,
  'numeric-9-plus-circle': I.mdiNumeric9PlusCircle,
  'numeric-9-plus-circle-outline': I.mdiNumeric9PlusCircleOutline,
  'numeric-10': I.mdiNumeric10,
  'numeric-10-box': I.mdiNumeric10Box,
  'numeric-10-box-multiple': I.mdiNumeric10BoxMultiple,
  'numeric-10-box-multiple-outline': I.mdiNumeric10BoxMultipleOutline,
  'numeric-10-box-outline': I.mdiNumeric10BoxOutline,
  'numeric-10-circle': I.mdiNumeric10Circle,
  'numeric-10-circle-outline': I.mdiNumeric10CircleOutline,
  'numeric-negative-1': I.mdiNumericNegative1,
  'numeric-off': I.mdiNumericOff,
  'numeric-positive-1': I.mdiNumericPositive1,
  nut: I.mdiNut,
  nutrition: I.mdiNutrition,
  nuxt: I.mdiNuxt,
  oar: I.mdiOar,
  ocarina: I.mdiOcarina,
  oci: I.mdiOci,
  ocr: I.mdiOcr,
  octagon: I.mdiOctagon,
  'octagon-outline': I.mdiOctagonOutline,
  octagram: I.mdiOctagram,
  'octagram-outline': I.mdiOctagramOutline,
  octahedron: I.mdiOctahedron,
  'octahedron-off': I.mdiOctahedronOff,
  odnoklassniki: I.mdiOdnoklassniki,
  offer: I.mdiOffer,
  'office-building': I.mdiOfficeBuilding,
  'office-building-cog': I.mdiOfficeBuildingCog,
  'office-building-cog-outline': I.mdiOfficeBuildingCogOutline,
  'office-building-marker': I.mdiOfficeBuildingMarker,
  'office-building-marker-outline': I.mdiOfficeBuildingMarkerOutline,
  'office-building-minus': I.mdiOfficeBuildingMinus,
  'office-building-minus-outline': I.mdiOfficeBuildingMinusOutline,
  'office-building-outline': I.mdiOfficeBuildingOutline,
  'office-building-plus': I.mdiOfficeBuildingPlus,
  'office-building-plus-outline': I.mdiOfficeBuildingPlusOutline,
  'office-building-remove': I.mdiOfficeBuildingRemove,
  'office-building-remove-outline': I.mdiOfficeBuildingRemoveOutline,
  oil: I.mdiOil,
  'oil-lamp': I.mdiOilLamp,
  'oil-level': I.mdiOilLevel,
  'oil-temperature': I.mdiOilTemperature,
  om: I.mdiOm,
  omega: I.mdiOmega,
  'one-up': I.mdiOneUp,
  onepassword: I.mdiOnepassword,
  opacity: I.mdiOpacity,
  'open-in-app': I.mdiOpenInApp,
  'open-in-new': I.mdiOpenInNew,
  'open-source-initiative': I.mdiOpenSourceInitiative,
  openid: I.mdiOpenid,
  opera: I.mdiOpera,
  orbit: I.mdiOrbit,
  'orbit-variant': I.mdiOrbitVariant,
  'order-alphabetical-ascending': I.mdiOrderAlphabeticalAscending,
  'order-alphabetical-descending': I.mdiOrderAlphabeticalDescending,
  'order-bool-ascending': I.mdiOrderBoolAscending,
  'order-bool-ascending-variant': I.mdiOrderBoolAscendingVariant,
  'order-bool-descending': I.mdiOrderBoolDescending,
  'order-bool-descending-variant': I.mdiOrderBoolDescendingVariant,
  'order-numeric-ascending': I.mdiOrderNumericAscending,
  'order-numeric-descending': I.mdiOrderNumericDescending,
  origin: I.mdiOrigin,
  ornament: I.mdiOrnament,
  'ornament-variant': I.mdiOrnamentVariant,
  'outdoor-lamp': I.mdiOutdoorLamp,
  overscan: I.mdiOverscan,
  owl: I.mdiOwl,
  'pac-man': I.mdiPacMan,
  package: I.mdiPackage,
  'package-check': I.mdiPackageCheck,
  'package-down': I.mdiPackageDown,
  'package-up': I.mdiPackageUp,
  'package-variant': I.mdiPackageVariant,
  'package-variant-closed': I.mdiPackageVariantClosed,
  'package-variant-closed-check': I.mdiPackageVariantClosedCheck,
  'package-variant-closed-minus': I.mdiPackageVariantClosedMinus,
  'package-variant-closed-plus': I.mdiPackageVariantClosedPlus,
  'package-variant-closed-remove': I.mdiPackageVariantClosedRemove,
  'package-variant-minus': I.mdiPackageVariantMinus,
  'package-variant-plus': I.mdiPackageVariantPlus,
  'package-variant-remove': I.mdiPackageVariantRemove,
  'page-first': I.mdiPageFirst,
  'page-last': I.mdiPageLast,
  'page-layout-body': I.mdiPageLayoutBody,
  'page-layout-footer': I.mdiPageLayoutFooter,
  'page-layout-header': I.mdiPageLayoutHeader,
  'page-layout-header-footer': I.mdiPageLayoutHeaderFooter,
  'page-layout-sidebar-left': I.mdiPageLayoutSidebarLeft,
  'page-layout-sidebar-right': I.mdiPageLayoutSidebarRight,
  'page-next': I.mdiPageNext,
  'page-next-outline': I.mdiPageNextOutline,
  'page-previous': I.mdiPagePrevious,
  'page-previous-outline': I.mdiPagePreviousOutline,
  pail: I.mdiPail,
  'pail-minus': I.mdiPailMinus,
  'pail-minus-outline': I.mdiPailMinusOutline,
  'pail-off': I.mdiPailOff,
  'pail-off-outline': I.mdiPailOffOutline,
  'pail-outline': I.mdiPailOutline,
  'pail-plus': I.mdiPailPlus,
  'pail-plus-outline': I.mdiPailPlusOutline,
  'pail-remove': I.mdiPailRemove,
  'pail-remove-outline': I.mdiPailRemoveOutline,
  palette: I.mdiPalette,
  'palette-advanced': I.mdiPaletteAdvanced,
  'palette-outline': I.mdiPaletteOutline,
  'palette-swatch': I.mdiPaletteSwatch,
  'palette-swatch-outline': I.mdiPaletteSwatchOutline,
  'palette-swatch-variant': I.mdiPaletteSwatchVariant,
  'palm-tree': I.mdiPalmTree,
  pan: I.mdiPan,
  'pan-bottom-left': I.mdiPanBottomLeft,
  'pan-bottom-right': I.mdiPanBottomRight,
  'pan-down': I.mdiPanDown,
  'pan-horizontal': I.mdiPanHorizontal,
  'pan-left': I.mdiPanLeft,
  'pan-right': I.mdiPanRight,
  'pan-top-left': I.mdiPanTopLeft,
  'pan-top-right': I.mdiPanTopRight,
  'pan-up': I.mdiPanUp,
  'pan-vertical': I.mdiPanVertical,
  panda: I.mdiPanda,
  pandora: I.mdiPandora,
  panorama: I.mdiPanorama,
  'panorama-fisheye': I.mdiPanoramaFisheye,
  'panorama-horizontal': I.mdiPanoramaHorizontal,
  'panorama-horizontal-outline': I.mdiPanoramaHorizontalOutline,
  'panorama-outline': I.mdiPanoramaOutline,
  'panorama-sphere': I.mdiPanoramaSphere,
  'panorama-sphere-outline': I.mdiPanoramaSphereOutline,
  'panorama-variant': I.mdiPanoramaVariant,
  'panorama-variant-outline': I.mdiPanoramaVariantOutline,
  'panorama-vertical': I.mdiPanoramaVertical,
  'panorama-vertical-outline': I.mdiPanoramaVerticalOutline,
  'panorama-wide-angle': I.mdiPanoramaWideAngle,
  'panorama-wide-angle-outline': I.mdiPanoramaWideAngleOutline,
  'paper-cut-vertical': I.mdiPaperCutVertical,
  'paper-roll': I.mdiPaperRoll,
  'paper-roll-outline': I.mdiPaperRollOutline,
  paperclip: I.mdiPaperclip,
  'paperclip-check': I.mdiPaperclipCheck,
  'paperclip-lock': I.mdiPaperclipLock,
  'paperclip-minus': I.mdiPaperclipMinus,
  'paperclip-off': I.mdiPaperclipOff,
  'paperclip-plus': I.mdiPaperclipPlus,
  'paperclip-remove': I.mdiPaperclipRemove,
  parachute: I.mdiParachute,
  'parachute-outline': I.mdiParachuteOutline,
  paragliding: I.mdiParagliding,
  parking: I.mdiParking,
  'party-popper': I.mdiPartyPopper,
  passport: I.mdiPassport,
  'passport-biometric': I.mdiPassportBiometric,
  pasta: I.mdiPasta,
  'patio-heater': I.mdiPatioHeater,
  patreon: I.mdiPatreon,
  pause: I.mdiPause,
  'pause-box': I.mdiPauseBox,
  'pause-box-outline': I.mdiPauseBoxOutline,
  'pause-circle': I.mdiPauseCircle,
  'pause-circle-outline': I.mdiPauseCircleOutline,
  'pause-octagon': I.mdiPauseOctagon,
  'pause-octagon-outline': I.mdiPauseOctagonOutline,
  paw: I.mdiPaw,
  'paw-off': I.mdiPawOff,
  'paw-off-outline': I.mdiPawOffOutline,
  'paw-outline': I.mdiPawOutline,
  peace: I.mdiPeace,
  peanut: I.mdiPeanut,
  'peanut-off': I.mdiPeanutOff,
  'peanut-off-outline': I.mdiPeanutOffOutline,
  'peanut-outline': I.mdiPeanutOutline,
  pen: I.mdiPen,
  'pen-lock': I.mdiPenLock,
  'pen-minus': I.mdiPenMinus,
  'pen-off': I.mdiPenOff,
  'pen-plus': I.mdiPenPlus,
  'pen-remove': I.mdiPenRemove,
  pencil: I.mdiPencil,
  'pencil-box': I.mdiPencilBox,
  'pencil-box-multiple': I.mdiPencilBoxMultiple,
  'pencil-box-multiple-outline': I.mdiPencilBoxMultipleOutline,
  'pencil-box-outline': I.mdiPencilBoxOutline,
  'pencil-circle': I.mdiPencilCircle,
  'pencil-circle-outline': I.mdiPencilCircleOutline,
  'pencil-lock': I.mdiPencilLock,
  'pencil-lock-outline': I.mdiPencilLockOutline,
  'pencil-minus': I.mdiPencilMinus,
  'pencil-minus-outline': I.mdiPencilMinusOutline,
  'pencil-off': I.mdiPencilOff,
  'pencil-off-outline': I.mdiPencilOffOutline,
  'pencil-outline': I.mdiPencilOutline,
  'pencil-plus': I.mdiPencilPlus,
  'pencil-plus-outline': I.mdiPencilPlusOutline,
  'pencil-remove': I.mdiPencilRemove,
  'pencil-remove-outline': I.mdiPencilRemoveOutline,
  'pencil-ruler': I.mdiPencilRuler,
  penguin: I.mdiPenguin,
  pentagon: I.mdiPentagon,
  'pentagon-outline': I.mdiPentagonOutline,
  pentagram: I.mdiPentagram,
  percent: I.mdiPercent,
  'percent-box': I.mdiPercentBox,
  'percent-box-outline': I.mdiPercentBoxOutline,
  'percent-circle': I.mdiPercentCircle,
  'percent-circle-outline': I.mdiPercentCircleOutline,
  'percent-outline': I.mdiPercentOutline,
  'periodic-table': I.mdiPeriodicTable,
  'perspective-less': I.mdiPerspectiveLess,
  'perspective-more': I.mdiPerspectiveMore,
  ph: I.mdiPh,
  phone: I.mdiPhone,
  'phone-alert': I.mdiPhoneAlert,
  'phone-alert-outline': I.mdiPhoneAlertOutline,
  'phone-bluetooth': I.mdiPhoneBluetooth,
  'phone-bluetooth-outline': I.mdiPhoneBluetoothOutline,
  'phone-cancel': I.mdiPhoneCancel,
  'phone-cancel-outline': I.mdiPhoneCancelOutline,
  'phone-check': I.mdiPhoneCheck,
  'phone-check-outline': I.mdiPhoneCheckOutline,
  'phone-classic': I.mdiPhoneClassic,
  'phone-classic-off': I.mdiPhoneClassicOff,
  'phone-clock': I.mdiPhoneClock,
  'phone-dial': I.mdiPhoneDial,
  'phone-dial-outline': I.mdiPhoneDialOutline,
  'phone-forward': I.mdiPhoneForward,
  'phone-forward-outline': I.mdiPhoneForwardOutline,
  'phone-hangup': I.mdiPhoneHangup,
  'phone-hangup-outline': I.mdiPhoneHangupOutline,
  'phone-in-talk': I.mdiPhoneInTalk,
  'phone-in-talk-outline': I.mdiPhoneInTalkOutline,
  'phone-incoming': I.mdiPhoneIncoming,
  'phone-incoming-outgoing': I.mdiPhoneIncomingOutgoing,
  'phone-incoming-outgoing-outline': I.mdiPhoneIncomingOutgoingOutline,
  'phone-incoming-outline': I.mdiPhoneIncomingOutline,
  'phone-lock': I.mdiPhoneLock,
  'phone-lock-outline': I.mdiPhoneLockOutline,
  'phone-log': I.mdiPhoneLog,
  'phone-log-outline': I.mdiPhoneLogOutline,
  'phone-message': I.mdiPhoneMessage,
  'phone-message-outline': I.mdiPhoneMessageOutline,
  'phone-minus': I.mdiPhoneMinus,
  'phone-minus-outline': I.mdiPhoneMinusOutline,
  'phone-missed': I.mdiPhoneMissed,
  'phone-missed-outline': I.mdiPhoneMissedOutline,
  'phone-off': I.mdiPhoneOff,
  'phone-off-outline': I.mdiPhoneOffOutline,
  'phone-outgoing': I.mdiPhoneOutgoing,
  'phone-outgoing-outline': I.mdiPhoneOutgoingOutline,
  'phone-outline': I.mdiPhoneOutline,
  'phone-paused': I.mdiPhonePaused,
  'phone-paused-outline': I.mdiPhonePausedOutline,
  'phone-plus': I.mdiPhonePlus,
  'phone-plus-outline': I.mdiPhonePlusOutline,
  'phone-refresh': I.mdiPhoneRefresh,
  'phone-refresh-outline': I.mdiPhoneRefreshOutline,
  'phone-remove': I.mdiPhoneRemove,
  'phone-remove-outline': I.mdiPhoneRemoveOutline,
  'phone-return': I.mdiPhoneReturn,
  'phone-return-outline': I.mdiPhoneReturnOutline,
  'phone-ring': I.mdiPhoneRing,
  'phone-ring-outline': I.mdiPhoneRingOutline,
  'phone-rotate-landscape': I.mdiPhoneRotateLandscape,
  'phone-rotate-portrait': I.mdiPhoneRotatePortrait,
  'phone-settings': I.mdiPhoneSettings,
  'phone-settings-outline': I.mdiPhoneSettingsOutline,
  'phone-sync': I.mdiPhoneSync,
  'phone-sync-outline': I.mdiPhoneSyncOutline,
  'phone-voip': I.mdiPhoneVoip,
  pi: I.mdiPi,
  'pi-box': I.mdiPiBox,
  'pi-hole': I.mdiPiHole,
  piano: I.mdiPiano,
  'piano-off': I.mdiPianoOff,
  pickaxe: I.mdiPickaxe,
  'picture-in-picture-bottom-right': I.mdiPictureInPictureBottomRight,
  'picture-in-picture-bottom-right-outline':
    I.mdiPictureInPictureBottomRightOutline,
  'picture-in-picture-top-right': I.mdiPictureInPictureTopRight,
  'picture-in-picture-top-right-outline': I.mdiPictureInPictureTopRightOutline,
  pier: I.mdiPier,
  'pier-crane': I.mdiPierCrane,
  pig: I.mdiPig,
  'pig-variant': I.mdiPigVariant,
  'pig-variant-outline': I.mdiPigVariantOutline,
  'piggy-bank': I.mdiPiggyBank,
  'piggy-bank-outline': I.mdiPiggyBankOutline,
  pill: I.mdiPill,
  'pill-multiple': I.mdiPillMultiple,
  'pill-off': I.mdiPillOff,
  pillar: I.mdiPillar,
  pin: I.mdiPin,
  'pin-off': I.mdiPinOff,
  'pin-off-outline': I.mdiPinOffOutline,
  'pin-outline': I.mdiPinOutline,
  'pine-tree': I.mdiPineTree,
  'pine-tree-box': I.mdiPineTreeBox,
  'pine-tree-fire': I.mdiPineTreeFire,
  pinterest: I.mdiPinterest,
  pinwheel: I.mdiPinwheel,
  'pinwheel-outline': I.mdiPinwheelOutline,
  pipe: I.mdiPipe,
  'pipe-disconnected': I.mdiPipeDisconnected,
  'pipe-leak': I.mdiPipeLeak,
  'pipe-valve': I.mdiPipeValve,
  'pipe-wrench': I.mdiPipeWrench,
  pirate: I.mdiPirate,
  pistol: I.mdiPistol,
  piston: I.mdiPiston,
  pitchfork: I.mdiPitchfork,
  pizza: I.mdiPizza,
  'plane-car': I.mdiPlaneCar,
  'plane-train': I.mdiPlaneTrain,
  play: I.mdiPlay,
  'play-box': I.mdiPlayBox,
  'play-box-lock': I.mdiPlayBoxLock,
  'play-box-lock-open': I.mdiPlayBoxLockOpen,
  'play-box-lock-open-outline': I.mdiPlayBoxLockOpenOutline,
  'play-box-lock-outline': I.mdiPlayBoxLockOutline,
  'play-box-multiple': I.mdiPlayBoxMultiple,
  'play-box-multiple-outline': I.mdiPlayBoxMultipleOutline,
  'play-box-outline': I.mdiPlayBoxOutline,
  'play-circle': I.mdiPlayCircle,
  'play-circle-outline': I.mdiPlayCircleOutline,
  'play-network': I.mdiPlayNetwork,
  'play-network-outline': I.mdiPlayNetworkOutline,
  'play-outline': I.mdiPlayOutline,
  'play-pause': I.mdiPlayPause,
  'play-protected-content': I.mdiPlayProtectedContent,
  'play-speed': I.mdiPlaySpeed,
  'playlist-check': I.mdiPlaylistCheck,
  'playlist-edit': I.mdiPlaylistEdit,
  'playlist-minus': I.mdiPlaylistMinus,
  'playlist-music': I.mdiPlaylistMusic,
  'playlist-music-outline': I.mdiPlaylistMusicOutline,
  'playlist-play': I.mdiPlaylistPlay,
  'playlist-plus': I.mdiPlaylistPlus,
  'playlist-remove': I.mdiPlaylistRemove,
  'playlist-star': I.mdiPlaylistStar,
  plex: I.mdiPlex,
  pliers: I.mdiPliers,
  plus: I.mdiPlus,
  'plus-box': I.mdiPlusBox,
  'plus-box-multiple': I.mdiPlusBoxMultiple,
  'plus-box-multiple-outline': I.mdiPlusBoxMultipleOutline,
  'plus-box-outline': I.mdiPlusBoxOutline,
  'plus-circle': I.mdiPlusCircle,
  'plus-circle-multiple': I.mdiPlusCircleMultiple,
  'plus-circle-multiple-outline': I.mdiPlusCircleMultipleOutline,
  'plus-circle-outline': I.mdiPlusCircleOutline,
  'plus-lock': I.mdiPlusLock,
  'plus-lock-open': I.mdiPlusLockOpen,
  'plus-minus': I.mdiPlusMinus,
  'plus-minus-box': I.mdiPlusMinusBox,
  'plus-minus-variant': I.mdiPlusMinusVariant,
  'plus-network': I.mdiPlusNetwork,
  'plus-network-outline': I.mdiPlusNetworkOutline,
  'plus-outline': I.mdiPlusOutline,
  'plus-thick': I.mdiPlusThick,
  podcast: I.mdiPodcast,
  podium: I.mdiPodium,
  'podium-bronze': I.mdiPodiumBronze,
  'podium-gold': I.mdiPodiumGold,
  'podium-silver': I.mdiPodiumSilver,
  'point-of-sale': I.mdiPointOfSale,
  pokeball: I.mdiPokeball,
  'pokemon-go': I.mdiPokemonGo,
  'poker-chip': I.mdiPokerChip,
  polaroid: I.mdiPolaroid,
  'police-badge': I.mdiPoliceBadge,
  'police-badge-outline': I.mdiPoliceBadgeOutline,
  'police-station': I.mdiPoliceStation,
  poll: I.mdiPoll,
  polo: I.mdiPolo,
  polymer: I.mdiPolymer,
  pool: I.mdiPool,
  'pool-thermometer': I.mdiPoolThermometer,
  popcorn: I.mdiPopcorn,
  post: I.mdiPost,
  'post-lamp': I.mdiPostLamp,
  'post-outline': I.mdiPostOutline,
  'postage-stamp': I.mdiPostageStamp,
  pot: I.mdiPot,
  'pot-mix': I.mdiPotMix,
  'pot-mix-outline': I.mdiPotMixOutline,
  'pot-outline': I.mdiPotOutline,
  'pot-steam': I.mdiPotSteam,
  'pot-steam-outline': I.mdiPotSteamOutline,
  pound: I.mdiPound,
  'pound-box': I.mdiPoundBox,
  'pound-box-outline': I.mdiPoundBoxOutline,
  power: I.mdiPower,
  'power-cycle': I.mdiPowerCycle,
  'power-off': I.mdiPowerOff,
  'power-on': I.mdiPowerOn,
  'power-plug': I.mdiPowerPlug,
  'power-plug-off': I.mdiPowerPlugOff,
  'power-plug-off-outline': I.mdiPowerPlugOffOutline,
  'power-plug-outline': I.mdiPowerPlugOutline,
  'power-settings': I.mdiPowerSettings,
  'power-sleep': I.mdiPowerSleep,
  'power-socket': I.mdiPowerSocket,
  'power-socket-au': I.mdiPowerSocketAu,
  'power-socket-ch': I.mdiPowerSocketCh,
  'power-socket-de': I.mdiPowerSocketDe,
  'power-socket-eu': I.mdiPowerSocketEu,
  'power-socket-fr': I.mdiPowerSocketFr,
  'power-socket-it': I.mdiPowerSocketIt,
  'power-socket-jp': I.mdiPowerSocketJp,
  'power-socket-uk': I.mdiPowerSocketUk,
  'power-socket-us': I.mdiPowerSocketUs,
  'power-standby': I.mdiPowerStandby,
  powershell: I.mdiPowershell,
  prescription: I.mdiPrescription,
  presentation: I.mdiPresentation,
  'presentation-play': I.mdiPresentationPlay,
  pretzel: I.mdiPretzel,
  printer: I.mdiPrinter,
  'printer-3-d': I.mdiPrinter3d,
  'printer-3-d-nozzle': I.mdiPrinter3dNozzle,
  'printer-3-d-nozzle-alert': I.mdiPrinter3dNozzleAlert,
  'printer-3-d-nozzle-alert-outline': I.mdiPrinter3dNozzleAlertOutline,
  'printer-3-d-nozzle-heat': I.mdiPrinter3dNozzleHeat,
  'printer-3-d-nozzle-heat-outline': I.mdiPrinter3dNozzleHeatOutline,
  'printer-3-d-nozzle-off': I.mdiPrinter3dNozzleOff,
  'printer-3-d-nozzle-off-outline': I.mdiPrinter3dNozzleOffOutline,
  'printer-3-d-nozzle-outline': I.mdiPrinter3dNozzleOutline,
  'printer-3-d-off': I.mdiPrinter3dOff,
  'printer-alert': I.mdiPrinterAlert,
  'printer-check': I.mdiPrinterCheck,
  'printer-eye': I.mdiPrinterEye,
  'printer-off': I.mdiPrinterOff,
  'printer-off-outline': I.mdiPrinterOffOutline,
  'printer-outline': I.mdiPrinterOutline,
  'printer-pos': I.mdiPrinterPos,
  'printer-search': I.mdiPrinterSearch,
  'printer-settings': I.mdiPrinterSettings,
  'printer-wireless': I.mdiPrinterWireless,
  'priority-high': I.mdiPriorityHigh,
  'priority-low': I.mdiPriorityLow,
  'professional-hexagon': I.mdiProfessionalHexagon,
  'progress-alert': I.mdiProgressAlert,
  'progress-check': I.mdiProgressCheck,
  'progress-clock': I.mdiProgressClock,
  'progress-close': I.mdiProgressClose,
  'progress-download': I.mdiProgressDownload,
  'progress-helper': I.mdiProgressHelper,
  'progress-pencil': I.mdiProgressPencil,
  'progress-question': I.mdiProgressQuestion,
  'progress-star': I.mdiProgressStar,
  'progress-upload': I.mdiProgressUpload,
  'progress-wrench': I.mdiProgressWrench,
  projector: I.mdiProjector,
  'projector-off': I.mdiProjectorOff,
  'projector-screen': I.mdiProjectorScreen,
  'projector-screen-off': I.mdiProjectorScreenOff,
  'projector-screen-off-outline': I.mdiProjectorScreenOffOutline,
  'projector-screen-outline': I.mdiProjectorScreenOutline,
  'projector-screen-variant': I.mdiProjectorScreenVariant,
  'projector-screen-variant-off': I.mdiProjectorScreenVariantOff,
  'projector-screen-variant-off-outline': I.mdiProjectorScreenVariantOffOutline,
  'projector-screen-variant-outline': I.mdiProjectorScreenVariantOutline,
  'propane-tank': I.mdiPropaneTank,
  'propane-tank-outline': I.mdiPropaneTankOutline,
  protocol: I.mdiProtocol,
  publish: I.mdiPublish,
  'publish-off': I.mdiPublishOff,
  pulse: I.mdiPulse,
  pump: I.mdiPump,
  'pump-off': I.mdiPumpOff,
  pumpkin: I.mdiPumpkin,
  purse: I.mdiPurse,
  'purse-outline': I.mdiPurseOutline,
  puzzle: I.mdiPuzzle,
  'puzzle-check': I.mdiPuzzleCheck,
  'puzzle-check-outline': I.mdiPuzzleCheckOutline,
  'puzzle-edit': I.mdiPuzzleEdit,
  'puzzle-edit-outline': I.mdiPuzzleEditOutline,
  'puzzle-heart': I.mdiPuzzleHeart,
  'puzzle-heart-outline': I.mdiPuzzleHeartOutline,
  'puzzle-minus': I.mdiPuzzleMinus,
  'puzzle-minus-outline': I.mdiPuzzleMinusOutline,
  'puzzle-outline': I.mdiPuzzleOutline,
  'puzzle-plus': I.mdiPuzzlePlus,
  'puzzle-plus-outline': I.mdiPuzzlePlusOutline,
  'puzzle-remove': I.mdiPuzzleRemove,
  'puzzle-remove-outline': I.mdiPuzzleRemoveOutline,
  'puzzle-star': I.mdiPuzzleStar,
  'puzzle-star-outline': I.mdiPuzzleStarOutline,
  pyramid: I.mdiPyramid,
  'pyramid-off': I.mdiPyramidOff,
  qi: I.mdiQi,
  qqchat: I.mdiQqchat,
  qrcode: I.mdiQrcode,
  'qrcode-edit': I.mdiQrcodeEdit,
  'qrcode-minus': I.mdiQrcodeMinus,
  'qrcode-plus': I.mdiQrcodePlus,
  'qrcode-remove': I.mdiQrcodeRemove,
  'qrcode-scan': I.mdiQrcodeScan,
  quadcopter: I.mdiQuadcopter,
  'quality-high': I.mdiQualityHigh,
  'quality-low': I.mdiQualityLow,
  'quality-medium': I.mdiQualityMedium,
  quora: I.mdiQuora,
  rabbit: I.mdiRabbit,
  'rabbit-variant': I.mdiRabbitVariant,
  'rabbit-variant-outline': I.mdiRabbitVariantOutline,
  'racing-helmet': I.mdiRacingHelmet,
  racquetball: I.mdiRacquetball,
  radar: I.mdiRadar,
  radiator: I.mdiRadiator,
  'radiator-disabled': I.mdiRadiatorDisabled,
  'radiator-off': I.mdiRadiatorOff,
  radio: I.mdiRadio,
  'radio-am': I.mdiRadioAm,
  'radio-fm': I.mdiRadioFm,
  'radio-handheld': I.mdiRadioHandheld,
  'radio-off': I.mdiRadioOff,
  'radio-tower': I.mdiRadioTower,
  radioactive: I.mdiRadioactive,
  'radioactive-circle': I.mdiRadioactiveCircle,
  'radioactive-circle-outline': I.mdiRadioactiveCircleOutline,
  'radioactive-off': I.mdiRadioactiveOff,
  'radiobox-blank': I.mdiRadioboxBlank,
  'radiobox-marked': I.mdiRadioboxMarked,
  'radiology-box': I.mdiRadiologyBox,
  'radiology-box-outline': I.mdiRadiologyBoxOutline,
  radius: I.mdiRadius,
  'radius-outline': I.mdiRadiusOutline,
  'railroad-light': I.mdiRailroadLight,
  rake: I.mdiRake,
  'raspberry-pi': I.mdiRaspberryPi,
  raw: I.mdiRaw,
  'raw-off': I.mdiRawOff,
  'ray-end': I.mdiRayEnd,
  'ray-end-arrow': I.mdiRayEndArrow,
  'ray-start': I.mdiRayStart,
  'ray-start-arrow': I.mdiRayStartArrow,
  'ray-start-end': I.mdiRayStartEnd,
  'ray-start-vertex-end': I.mdiRayStartVertexEnd,
  'ray-vertex': I.mdiRayVertex,
  'razor-double-edge': I.mdiRazorDoubleEdge,
  'razor-single-edge': I.mdiRazorSingleEdge,
  react: I.mdiReact,
  read: I.mdiRead,
  receipt: I.mdiReceipt,
  'receipt-outline': I.mdiReceiptOutline,
  'receipt-text': I.mdiReceiptText,
  'receipt-text-check': I.mdiReceiptTextCheck,
  'receipt-text-check-outline': I.mdiReceiptTextCheckOutline,
  'receipt-text-minus': I.mdiReceiptTextMinus,
  'receipt-text-minus-outline': I.mdiReceiptTextMinusOutline,
  'receipt-text-outline': I.mdiReceiptTextOutline,
  'receipt-text-plus': I.mdiReceiptTextPlus,
  'receipt-text-plus-outline': I.mdiReceiptTextPlusOutline,
  'receipt-text-remove': I.mdiReceiptTextRemove,
  'receipt-text-remove-outline': I.mdiReceiptTextRemoveOutline,
  record: I.mdiRecord,
  'record-circle': I.mdiRecordCircle,
  'record-circle-outline': I.mdiRecordCircleOutline,
  'record-player': I.mdiRecordPlayer,
  'record-rec': I.mdiRecordRec,
  rectangle: I.mdiRectangle,
  'rectangle-outline': I.mdiRectangleOutline,
  recycle: I.mdiRecycle,
  'recycle-variant': I.mdiRecycleVariant,
  reddit: I.mdiReddit,
  redhat: I.mdiRedhat,
  redo: I.mdiRedo,
  'redo-variant': I.mdiRedoVariant,
  'reflect-horizontal': I.mdiReflectHorizontal,
  'reflect-vertical': I.mdiReflectVertical,
  refresh: I.mdiRefresh,
  'refresh-auto': I.mdiRefreshAuto,
  'refresh-circle': I.mdiRefreshCircle,
  regex: I.mdiRegex,
  'registered-trademark': I.mdiRegisteredTrademark,
  reiterate: I.mdiReiterate,
  'relation-many-to-many': I.mdiRelationManyToMany,
  'relation-many-to-one': I.mdiRelationManyToOne,
  'relation-many-to-one-or-many': I.mdiRelationManyToOneOrMany,
  'relation-many-to-only-one': I.mdiRelationManyToOnlyOne,
  'relation-many-to-zero-or-many': I.mdiRelationManyToZeroOrMany,
  'relation-many-to-zero-or-one': I.mdiRelationManyToZeroOrOne,
  'relation-one-or-many-to-many': I.mdiRelationOneOrManyToMany,
  'relation-one-or-many-to-one': I.mdiRelationOneOrManyToOne,
  'relation-one-or-many-to-one-or-many': I.mdiRelationOneOrManyToOneOrMany,
  'relation-one-or-many-to-only-one': I.mdiRelationOneOrManyToOnlyOne,
  'relation-one-or-many-to-zero-or-many': I.mdiRelationOneOrManyToZeroOrMany,
  'relation-one-or-many-to-zero-or-one': I.mdiRelationOneOrManyToZeroOrOne,
  'relation-one-to-many': I.mdiRelationOneToMany,
  'relation-one-to-one': I.mdiRelationOneToOne,
  'relation-one-to-one-or-many': I.mdiRelationOneToOneOrMany,
  'relation-one-to-only-one': I.mdiRelationOneToOnlyOne,
  'relation-one-to-zero-or-many': I.mdiRelationOneToZeroOrMany,
  'relation-one-to-zero-or-one': I.mdiRelationOneToZeroOrOne,
  'relation-only-one-to-many': I.mdiRelationOnlyOneToMany,
  'relation-only-one-to-one': I.mdiRelationOnlyOneToOne,
  'relation-only-one-to-one-or-many': I.mdiRelationOnlyOneToOneOrMany,
  'relation-only-one-to-only-one': I.mdiRelationOnlyOneToOnlyOne,
  'relation-only-one-to-zero-or-many': I.mdiRelationOnlyOneToZeroOrMany,
  'relation-only-one-to-zero-or-one': I.mdiRelationOnlyOneToZeroOrOne,
  'relation-zero-or-many-to-many': I.mdiRelationZeroOrManyToMany,
  'relation-zero-or-many-to-one': I.mdiRelationZeroOrManyToOne,
  'relation-zero-or-many-to-one-or-many': I.mdiRelationZeroOrManyToOneOrMany,
  'relation-zero-or-many-to-only-one': I.mdiRelationZeroOrManyToOnlyOne,
  'relation-zero-or-many-to-zero-or-many': I.mdiRelationZeroOrManyToZeroOrMany,
  'relation-zero-or-many-to-zero-or-one': I.mdiRelationZeroOrManyToZeroOrOne,
  'relation-zero-or-one-to-many': I.mdiRelationZeroOrOneToMany,
  'relation-zero-or-one-to-one': I.mdiRelationZeroOrOneToOne,
  'relation-zero-or-one-to-one-or-many': I.mdiRelationZeroOrOneToOneOrMany,
  'relation-zero-or-one-to-only-one': I.mdiRelationZeroOrOneToOnlyOne,
  'relation-zero-or-one-to-zero-or-many': I.mdiRelationZeroOrOneToZeroOrMany,
  'relation-zero-or-one-to-zero-or-one': I.mdiRelationZeroOrOneToZeroOrOne,
  'relative-scale': I.mdiRelativeScale,
  reload: I.mdiReload,
  'reload-alert': I.mdiReloadAlert,
  reminder: I.mdiReminder,
  remote: I.mdiRemote,
  'remote-desktop': I.mdiRemoteDesktop,
  'remote-off': I.mdiRemoteOff,
  'remote-tv': I.mdiRemoteTv,
  'remote-tv-off': I.mdiRemoteTvOff,
  'rename-box': I.mdiRenameBox,
  'reorder-horizontal': I.mdiReorderHorizontal,
  'reorder-vertical': I.mdiReorderVertical,
  repeat: I.mdiRepeat,
  'repeat-off': I.mdiRepeatOff,
  'repeat-once': I.mdiRepeatOnce,
  'repeat-variant': I.mdiRepeatVariant,
  replay: I.mdiReplay,
  reply: I.mdiReply,
  'reply-all': I.mdiReplyAll,
  'reply-all-outline': I.mdiReplyAllOutline,
  'reply-circle': I.mdiReplyCircle,
  'reply-outline': I.mdiReplyOutline,
  reproduction: I.mdiReproduction,
  resistor: I.mdiResistor,
  'resistor-nodes': I.mdiResistorNodes,
  resize: I.mdiResize,
  'resize-bottom-right': I.mdiResizeBottomRight,
  responsive: I.mdiResponsive,
  restart: I.mdiRestart,
  'restart-alert': I.mdiRestartAlert,
  'restart-off': I.mdiRestartOff,
  restore: I.mdiRestore,
  'restore-alert': I.mdiRestoreAlert,
  rewind: I.mdiRewind,
  'rewind-5': I.mdiRewind5,
  'rewind-10': I.mdiRewind10,
  'rewind-15': I.mdiRewind15,
  'rewind-30': I.mdiRewind30,
  'rewind-45': I.mdiRewind45,
  'rewind-60': I.mdiRewind60,
  'rewind-outline': I.mdiRewindOutline,
  rhombus: I.mdiRhombus,
  'rhombus-medium': I.mdiRhombusMedium,
  'rhombus-medium-outline': I.mdiRhombusMediumOutline,
  'rhombus-outline': I.mdiRhombusOutline,
  'rhombus-split': I.mdiRhombusSplit,
  'rhombus-split-outline': I.mdiRhombusSplitOutline,
  ribbon: I.mdiRibbon,
  rice: I.mdiRice,
  rickshaw: I.mdiRickshaw,
  'rickshaw-electric': I.mdiRickshawElectric,
  ring: I.mdiRing,
  rivet: I.mdiRivet,
  road: I.mdiRoad,
  'road-variant': I.mdiRoadVariant,
  robber: I.mdiRobber,
  robot: I.mdiRobot,
  'robot-angry': I.mdiRobotAngry,
  'robot-angry-outline': I.mdiRobotAngryOutline,
  'robot-confused': I.mdiRobotConfused,
  'robot-confused-outline': I.mdiRobotConfusedOutline,
  'robot-dead': I.mdiRobotDead,
  'robot-dead-outline': I.mdiRobotDeadOutline,
  'robot-excited': I.mdiRobotExcited,
  'robot-excited-outline': I.mdiRobotExcitedOutline,
  'robot-happy': I.mdiRobotHappy,
  'robot-happy-outline': I.mdiRobotHappyOutline,
  'robot-industrial': I.mdiRobotIndustrial,
  'robot-industrial-outline': I.mdiRobotIndustrialOutline,
  'robot-love': I.mdiRobotLove,
  'robot-love-outline': I.mdiRobotLoveOutline,
  'robot-mower': I.mdiRobotMower,
  'robot-mower-outline': I.mdiRobotMowerOutline,
  'robot-off': I.mdiRobotOff,
  'robot-off-outline': I.mdiRobotOffOutline,
  'robot-outline': I.mdiRobotOutline,
  'robot-vacuum': I.mdiRobotVacuum,
  'robot-vacuum-alert': I.mdiRobotVacuumAlert,
  'robot-vacuum-variant': I.mdiRobotVacuumVariant,
  'robot-vacuum-variant-alert': I.mdiRobotVacuumVariantAlert,
  rocket: I.mdiRocket,
  'rocket-launch': I.mdiRocketLaunch,
  'rocket-launch-outline': I.mdiRocketLaunchOutline,
  'rocket-outline': I.mdiRocketOutline,
  rodent: I.mdiRodent,
  'roller-shade': I.mdiRollerShade,
  'roller-shade-closed': I.mdiRollerShadeClosed,
  'roller-skate': I.mdiRollerSkate,
  'roller-skate-off': I.mdiRollerSkateOff,
  rollerblade: I.mdiRollerblade,
  'rollerblade-off': I.mdiRollerbladeOff,
  rollupjs: I.mdiRollupjs,
  rolodex: I.mdiRolodex,
  'rolodex-outline': I.mdiRolodexOutline,
  'roman-numeral-1': I.mdiRomanNumeral1,
  'roman-numeral-2': I.mdiRomanNumeral2,
  'roman-numeral-3': I.mdiRomanNumeral3,
  'roman-numeral-4': I.mdiRomanNumeral4,
  'roman-numeral-5': I.mdiRomanNumeral5,
  'roman-numeral-6': I.mdiRomanNumeral6,
  'roman-numeral-7': I.mdiRomanNumeral7,
  'roman-numeral-8': I.mdiRomanNumeral8,
  'roman-numeral-9': I.mdiRomanNumeral9,
  'roman-numeral-10': I.mdiRomanNumeral10,
  'room-service': I.mdiRoomService,
  'room-service-outline': I.mdiRoomServiceOutline,
  'rotate-3-d': I.mdiRotate3d,
  'rotate-3-d-variant': I.mdiRotate3dVariant,
  'rotate-360': I.mdiRotate360,
  'rotate-left': I.mdiRotateLeft,
  'rotate-left-variant': I.mdiRotateLeftVariant,
  'rotate-orbit': I.mdiRotateOrbit,
  'rotate-right': I.mdiRotateRight,
  'rotate-right-variant': I.mdiRotateRightVariant,
  'rounded-corner': I.mdiRoundedCorner,
  router: I.mdiRouter,
  'router-network': I.mdiRouterNetwork,
  'router-wireless': I.mdiRouterWireless,
  'router-wireless-off': I.mdiRouterWirelessOff,
  'router-wireless-settings': I.mdiRouterWirelessSettings,
  routes: I.mdiRoutes,
  'routes-clock': I.mdiRoutesClock,
  rowing: I.mdiRowing,
  rss: I.mdiRss,
  'rss-box': I.mdiRssBox,
  'rss-off': I.mdiRssOff,
  rug: I.mdiRug,
  rugby: I.mdiRugby,
  ruler: I.mdiRuler,
  'ruler-square': I.mdiRulerSquare,
  'ruler-square-compass': I.mdiRulerSquareCompass,
  run: I.mdiRun,
  'run-fast': I.mdiRunFast,
  'rv-truck': I.mdiRvTruck,
  sack: I.mdiSack,
  'sack-percent': I.mdiSackPercent,
  safe: I.mdiSafe,
  'safe-square': I.mdiSafeSquare,
  'safe-square-outline': I.mdiSafeSquareOutline,
  'safety-goggles': I.mdiSafetyGoggles,
  'sail-boat': I.mdiSailBoat,
  'sail-boat-sink': I.mdiSailBoatSink,
  sale: I.mdiSale,
  'sale-outline': I.mdiSaleOutline,
  salesforce: I.mdiSalesforce,
  sass: I.mdiSass,
  satellite: I.mdiSatellite,
  'satellite-uplink': I.mdiSatelliteUplink,
  'satellite-variant': I.mdiSatelliteVariant,
  sausage: I.mdiSausage,
  'sausage-off': I.mdiSausageOff,
  'saw-blade': I.mdiSawBlade,
  'sawtooth-wave': I.mdiSawtoothWave,
  saxophone: I.mdiSaxophone,
  scale: I.mdiScale,
  'scale-balance': I.mdiScaleBalance,
  'scale-bathroom': I.mdiScaleBathroom,
  'scale-off': I.mdiScaleOff,
  'scale-unbalanced': I.mdiScaleUnbalanced,
  'scan-helper': I.mdiScanHelper,
  scanner: I.mdiScanner,
  'scanner-off': I.mdiScannerOff,
  'scatter-plot': I.mdiScatterPlot,
  'scatter-plot-outline': I.mdiScatterPlotOutline,
  scent: I.mdiScent,
  'scent-off': I.mdiScentOff,
  school: I.mdiSchool,
  'school-outline': I.mdiSchoolOutline,
  'scissors-cutting': I.mdiScissorsCutting,
  scooter: I.mdiScooter,
  'scooter-electric': I.mdiScooterElectric,
  scoreboard: I.mdiScoreboard,
  'scoreboard-outline': I.mdiScoreboardOutline,
  'screen-rotation': I.mdiScreenRotation,
  'screen-rotation-lock': I.mdiScreenRotationLock,
  'screw-flat-top': I.mdiScrewFlatTop,
  'screw-lag': I.mdiScrewLag,
  'screw-machine-flat-top': I.mdiScrewMachineFlatTop,
  'screw-machine-round-top': I.mdiScrewMachineRoundTop,
  'screw-round-top': I.mdiScrewRoundTop,
  screwdriver: I.mdiScrewdriver,
  script: I.mdiScript,
  'script-outline': I.mdiScriptOutline,
  'script-text': I.mdiScriptText,
  'script-text-key': I.mdiScriptTextKey,
  'script-text-key-outline': I.mdiScriptTextKeyOutline,
  'script-text-outline': I.mdiScriptTextOutline,
  'script-text-play': I.mdiScriptTextPlay,
  'script-text-play-outline': I.mdiScriptTextPlayOutline,
  sd: I.mdiSd,
  seal: I.mdiSeal,
  'seal-variant': I.mdiSealVariant,
  'search-web': I.mdiSearchWeb,
  seat: I.mdiSeat,
  'seat-flat': I.mdiSeatFlat,
  'seat-flat-angled': I.mdiSeatFlatAngled,
  'seat-individual-suite': I.mdiSeatIndividualSuite,
  'seat-legroom-extra': I.mdiSeatLegroomExtra,
  'seat-legroom-normal': I.mdiSeatLegroomNormal,
  'seat-legroom-reduced': I.mdiSeatLegroomReduced,
  'seat-outline': I.mdiSeatOutline,
  'seat-passenger': I.mdiSeatPassenger,
  'seat-recline-extra': I.mdiSeatReclineExtra,
  'seat-recline-normal': I.mdiSeatReclineNormal,
  seatbelt: I.mdiSeatbelt,
  security: I.mdiSecurity,
  'security-network': I.mdiSecurityNetwork,
  seed: I.mdiSeed,
  'seed-off': I.mdiSeedOff,
  'seed-off-outline': I.mdiSeedOffOutline,
  'seed-outline': I.mdiSeedOutline,
  'seed-plus': I.mdiSeedPlus,
  'seed-plus-outline': I.mdiSeedPlusOutline,
  seesaw: I.mdiSeesaw,
  segment: I.mdiSegment,
  select: I.mdiSelect,
  'select-all': I.mdiSelectAll,
  'select-arrow-down': I.mdiSelectArrowDown,
  'select-arrow-up': I.mdiSelectArrowUp,
  'select-color': I.mdiSelectColor,
  'select-compare': I.mdiSelectCompare,
  'select-drag': I.mdiSelectDrag,
  'select-group': I.mdiSelectGroup,
  'select-inverse': I.mdiSelectInverse,
  'select-marker': I.mdiSelectMarker,
  'select-multiple': I.mdiSelectMultiple,
  'select-multiple-marker': I.mdiSelectMultipleMarker,
  'select-off': I.mdiSelectOff,
  'select-place': I.mdiSelectPlace,
  'select-remove': I.mdiSelectRemove,
  'select-search': I.mdiSelectSearch,
  selection: I.mdiSelection,
  'selection-drag': I.mdiSelectionDrag,
  'selection-ellipse': I.mdiSelectionEllipse,
  'selection-ellipse-arrow-inside': I.mdiSelectionEllipseArrowInside,
  'selection-ellipse-remove': I.mdiSelectionEllipseRemove,
  'selection-marker': I.mdiSelectionMarker,
  'selection-multiple': I.mdiSelectionMultiple,
  'selection-multiple-marker': I.mdiSelectionMultipleMarker,
  'selection-off': I.mdiSelectionOff,
  'selection-remove': I.mdiSelectionRemove,
  'selection-search': I.mdiSelectionSearch,
  'semantic-web': I.mdiSemanticWeb,
  send: I.mdiSend,
  'send-check': I.mdiSendCheck,
  'send-check-outline': I.mdiSendCheckOutline,
  'send-circle': I.mdiSendCircle,
  'send-circle-outline': I.mdiSendCircleOutline,
  'send-clock': I.mdiSendClock,
  'send-clock-outline': I.mdiSendClockOutline,
  'send-lock': I.mdiSendLock,
  'send-lock-outline': I.mdiSendLockOutline,
  'send-outline': I.mdiSendOutline,
  'serial-port': I.mdiSerialPort,
  server: I.mdiServer,
  'server-minus': I.mdiServerMinus,
  'server-network': I.mdiServerNetwork,
  'server-network-off': I.mdiServerNetworkOff,
  'server-off': I.mdiServerOff,
  'server-plus': I.mdiServerPlus,
  'server-remove': I.mdiServerRemove,
  'server-security': I.mdiServerSecurity,
  'set-all': I.mdiSetAll,
  'set-center': I.mdiSetCenter,
  'set-center-right': I.mdiSetCenterRight,
  'set-left': I.mdiSetLeft,
  'set-left-center': I.mdiSetLeftCenter,
  'set-left-right': I.mdiSetLeftRight,
  'set-merge': I.mdiSetMerge,
  'set-none': I.mdiSetNone,
  'set-right': I.mdiSetRight,
  'set-split': I.mdiSetSplit,
  'set-square': I.mdiSetSquare,
  'set-top-box': I.mdiSetTopBox,
  'settings-helper': I.mdiSettingsHelper,
  shaker: I.mdiShaker,
  'shaker-outline': I.mdiShakerOutline,
  shape: I.mdiShape,
  'shape-circle-plus': I.mdiShapeCirclePlus,
  'shape-outline': I.mdiShapeOutline,
  'shape-oval-plus': I.mdiShapeOvalPlus,
  'shape-plus': I.mdiShapePlus,
  'shape-polygon-plus': I.mdiShapePolygonPlus,
  'shape-rectangle-plus': I.mdiShapeRectanglePlus,
  'shape-square-plus': I.mdiShapeSquarePlus,
  'shape-square-rounded-plus': I.mdiShapeSquareRoundedPlus,
  share: I.mdiShare,
  'share-all': I.mdiShareAll,
  'share-all-outline': I.mdiShareAllOutline,
  'share-circle': I.mdiShareCircle,
  'share-off': I.mdiShareOff,
  'share-off-outline': I.mdiShareOffOutline,
  'share-outline': I.mdiShareOutline,
  'share-variant': I.mdiShareVariant,
  'share-variant-outline': I.mdiShareVariantOutline,
  shark: I.mdiShark,
  'shark-fin': I.mdiSharkFin,
  'shark-fin-outline': I.mdiSharkFinOutline,
  'shark-off': I.mdiSharkOff,
  sheep: I.mdiSheep,
  shield: I.mdiShield,
  'shield-account': I.mdiShieldAccount,
  'shield-account-outline': I.mdiShieldAccountOutline,
  'shield-account-variant': I.mdiShieldAccountVariant,
  'shield-account-variant-outline': I.mdiShieldAccountVariantOutline,
  'shield-airplane': I.mdiShieldAirplane,
  'shield-airplane-outline': I.mdiShieldAirplaneOutline,
  'shield-alert': I.mdiShieldAlert,
  'shield-alert-outline': I.mdiShieldAlertOutline,
  'shield-bug': I.mdiShieldBug,
  'shield-bug-outline': I.mdiShieldBugOutline,
  'shield-car': I.mdiShieldCar,
  'shield-check': I.mdiShieldCheck,
  'shield-check-outline': I.mdiShieldCheckOutline,
  'shield-cross': I.mdiShieldCross,
  'shield-cross-outline': I.mdiShieldCrossOutline,
  'shield-crown': I.mdiShieldCrown,
  'shield-crown-outline': I.mdiShieldCrownOutline,
  'shield-edit': I.mdiShieldEdit,
  'shield-edit-outline': I.mdiShieldEditOutline,
  'shield-half': I.mdiShieldHalf,
  'shield-half-full': I.mdiShieldHalfFull,
  'shield-home': I.mdiShieldHome,
  'shield-home-outline': I.mdiShieldHomeOutline,
  'shield-key': I.mdiShieldKey,
  'shield-key-outline': I.mdiShieldKeyOutline,
  'shield-link-variant': I.mdiShieldLinkVariant,
  'shield-link-variant-outline': I.mdiShieldLinkVariantOutline,
  'shield-lock': I.mdiShieldLock,
  'shield-lock-open': I.mdiShieldLockOpen,
  'shield-lock-open-outline': I.mdiShieldLockOpenOutline,
  'shield-lock-outline': I.mdiShieldLockOutline,
  'shield-moon': I.mdiShieldMoon,
  'shield-moon-outline': I.mdiShieldMoonOutline,
  'shield-off': I.mdiShieldOff,
  'shield-off-outline': I.mdiShieldOffOutline,
  'shield-outline': I.mdiShieldOutline,
  'shield-plus': I.mdiShieldPlus,
  'shield-plus-outline': I.mdiShieldPlusOutline,
  'shield-refresh': I.mdiShieldRefresh,
  'shield-refresh-outline': I.mdiShieldRefreshOutline,
  'shield-remove': I.mdiShieldRemove,
  'shield-remove-outline': I.mdiShieldRemoveOutline,
  'shield-search': I.mdiShieldSearch,
  'shield-star': I.mdiShieldStar,
  'shield-star-outline': I.mdiShieldStarOutline,
  'shield-sun': I.mdiShieldSun,
  'shield-sun-outline': I.mdiShieldSunOutline,
  'shield-sword': I.mdiShieldSword,
  'shield-sword-outline': I.mdiShieldSwordOutline,
  'shield-sync': I.mdiShieldSync,
  'shield-sync-outline': I.mdiShieldSyncOutline,
  shimmer: I.mdiShimmer,
  'ship-wheel': I.mdiShipWheel,
  'shipping-pallet': I.mdiShippingPallet,
  'shoe-ballet': I.mdiShoeBallet,
  'shoe-cleat': I.mdiShoeCleat,
  'shoe-formal': I.mdiShoeFormal,
  'shoe-heel': I.mdiShoeHeel,
  'shoe-print': I.mdiShoePrint,
  'shoe-sneaker': I.mdiShoeSneaker,
  shopping: I.mdiShopping,
  'shopping-music': I.mdiShoppingMusic,
  'shopping-outline': I.mdiShoppingOutline,
  'shopping-search': I.mdiShoppingSearch,
  'shopping-search-outline': I.mdiShoppingSearchOutline,
  shore: I.mdiShore,
  shovel: I.mdiShovel,
  'shovel-off': I.mdiShovelOff,
  shower: I.mdiShower,
  'shower-head': I.mdiShowerHead,
  shredder: I.mdiShredder,
  shuffle: I.mdiShuffle,
  'shuffle-disabled': I.mdiShuffleDisabled,
  'shuffle-variant': I.mdiShuffleVariant,
  shuriken: I.mdiShuriken,
  sickle: I.mdiSickle,
  sigma: I.mdiSigma,
  'sigma-lower': I.mdiSigmaLower,
  'sign-caution': I.mdiSignCaution,
  'sign-direction': I.mdiSignDirection,
  'sign-direction-minus': I.mdiSignDirectionMinus,
  'sign-direction-plus': I.mdiSignDirectionPlus,
  'sign-direction-remove': I.mdiSignDirectionRemove,
  'sign-language': I.mdiSignLanguage,
  'sign-language-outline': I.mdiSignLanguageOutline,
  'sign-pole': I.mdiSignPole,
  'sign-real-estate': I.mdiSignRealEstate,
  'sign-text': I.mdiSignText,
  'sign-yield': I.mdiSignYield,
  signal: I.mdiSignal,
  'signal-2-g': I.mdiSignal2g,
  'signal-3-g': I.mdiSignal3g,
  'signal-4-g': I.mdiSignal4g,
  'signal-5-g': I.mdiSignal5g,
  'signal-cellular-1': I.mdiSignalCellular1,
  'signal-cellular-2': I.mdiSignalCellular2,
  'signal-cellular-3': I.mdiSignalCellular3,
  'signal-cellular-outline': I.mdiSignalCellularOutline,
  'signal-distance-variant': I.mdiSignalDistanceVariant,
  'signal-hspa': I.mdiSignalHspa,
  'signal-hspa-plus': I.mdiSignalHspaPlus,
  'signal-off': I.mdiSignalOff,
  'signal-variant': I.mdiSignalVariant,
  signature: I.mdiSignature,
  'signature-freehand': I.mdiSignatureFreehand,
  'signature-image': I.mdiSignatureImage,
  'signature-text': I.mdiSignatureText,
  silo: I.mdiSilo,
  'silo-outline': I.mdiSiloOutline,
  silverware: I.mdiSilverware,
  'silverware-clean': I.mdiSilverwareClean,
  'silverware-fork': I.mdiSilverwareFork,
  'silverware-fork-knife': I.mdiSilverwareForkKnife,
  'silverware-spoon': I.mdiSilverwareSpoon,
  'silverware-variant': I.mdiSilverwareVariant,
  sim: I.mdiSim,
  'sim-alert': I.mdiSimAlert,
  'sim-alert-outline': I.mdiSimAlertOutline,
  'sim-off': I.mdiSimOff,
  'sim-off-outline': I.mdiSimOffOutline,
  'sim-outline': I.mdiSimOutline,
  'simple-icons': I.mdiSimpleIcons,
  'sina-weibo': I.mdiSinaWeibo,
  'sine-wave': I.mdiSineWave,
  sitemap: I.mdiSitemap,
  'sitemap-outline': I.mdiSitemapOutline,
  'size-l': I.mdiSizeL,
  'size-m': I.mdiSizeM,
  'size-s': I.mdiSizeS,
  'size-xl': I.mdiSizeXl,
  'size-xs': I.mdiSizeXs,
  'size-xxl': I.mdiSizeXxl,
  'size-xxs': I.mdiSizeXxs,
  'size-xxxl': I.mdiSizeXxxl,
  skate: I.mdiSkate,
  'skate-off': I.mdiSkateOff,
  skateboard: I.mdiSkateboard,
  skateboarding: I.mdiSkateboarding,
  'skew-less': I.mdiSkewLess,
  'skew-more': I.mdiSkewMore,
  ski: I.mdiSki,
  'ski-cross-country': I.mdiSkiCrossCountry,
  'ski-water': I.mdiSkiWater,
  'skip-backward': I.mdiSkipBackward,
  'skip-backward-outline': I.mdiSkipBackwardOutline,
  'skip-forward': I.mdiSkipForward,
  'skip-forward-outline': I.mdiSkipForwardOutline,
  'skip-next': I.mdiSkipNext,
  'skip-next-circle': I.mdiSkipNextCircle,
  'skip-next-circle-outline': I.mdiSkipNextCircleOutline,
  'skip-next-outline': I.mdiSkipNextOutline,
  'skip-previous': I.mdiSkipPrevious,
  'skip-previous-circle': I.mdiSkipPreviousCircle,
  'skip-previous-circle-outline': I.mdiSkipPreviousCircleOutline,
  'skip-previous-outline': I.mdiSkipPreviousOutline,
  skull: I.mdiSkull,
  'skull-crossbones': I.mdiSkullCrossbones,
  'skull-crossbones-outline': I.mdiSkullCrossbonesOutline,
  'skull-outline': I.mdiSkullOutline,
  'skull-scan': I.mdiSkullScan,
  'skull-scan-outline': I.mdiSkullScanOutline,
  skype: I.mdiSkype,
  'skype-business': I.mdiSkypeBusiness,
  slack: I.mdiSlack,
  'slash-forward': I.mdiSlashForward,
  'slash-forward-box': I.mdiSlashForwardBox,
  sledding: I.mdiSledding,
  sleep: I.mdiSleep,
  'sleep-off': I.mdiSleepOff,
  slide: I.mdiSlide,
  'slope-downhill': I.mdiSlopeDownhill,
  'slope-uphill': I.mdiSlopeUphill,
  'slot-machine': I.mdiSlotMachine,
  'slot-machine-outline': I.mdiSlotMachineOutline,
  'smart-card': I.mdiSmartCard,
  'smart-card-off': I.mdiSmartCardOff,
  'smart-card-off-outline': I.mdiSmartCardOffOutline,
  'smart-card-outline': I.mdiSmartCardOutline,
  'smart-card-reader': I.mdiSmartCardReader,
  'smart-card-reader-outline': I.mdiSmartCardReaderOutline,
  smog: I.mdiSmog,
  smoke: I.mdiSmoke,
  'smoke-detector': I.mdiSmokeDetector,
  'smoke-detector-alert': I.mdiSmokeDetectorAlert,
  'smoke-detector-alert-outline': I.mdiSmokeDetectorAlertOutline,
  'smoke-detector-off': I.mdiSmokeDetectorOff,
  'smoke-detector-off-outline': I.mdiSmokeDetectorOffOutline,
  'smoke-detector-outline': I.mdiSmokeDetectorOutline,
  'smoke-detector-variant': I.mdiSmokeDetectorVariant,
  'smoke-detector-variant-alert': I.mdiSmokeDetectorVariantAlert,
  'smoke-detector-variant-off': I.mdiSmokeDetectorVariantOff,
  smoking: I.mdiSmoking,
  'smoking-off': I.mdiSmokingOff,
  'smoking-pipe': I.mdiSmokingPipe,
  'smoking-pipe-off': I.mdiSmokingPipeOff,
  snail: I.mdiSnail,
  snake: I.mdiSnake,
  snapchat: I.mdiSnapchat,
  snowboard: I.mdiSnowboard,
  snowflake: I.mdiSnowflake,
  'snowflake-alert': I.mdiSnowflakeAlert,
  'snowflake-check': I.mdiSnowflakeCheck,
  'snowflake-melt': I.mdiSnowflakeMelt,
  'snowflake-off': I.mdiSnowflakeOff,
  'snowflake-thermometer': I.mdiSnowflakeThermometer,
  'snowflake-variant': I.mdiSnowflakeVariant,
  snowman: I.mdiSnowman,
  snowmobile: I.mdiSnowmobile,
  snowshoeing: I.mdiSnowshoeing,
  soccer: I.mdiSoccer,
  'soccer-field': I.mdiSoccerField,
  'social-distance-2-meters': I.mdiSocialDistance2Meters,
  'social-distance-6-feet': I.mdiSocialDistance6Feet,
  sofa: I.mdiSofa,
  'sofa-outline': I.mdiSofaOutline,
  'sofa-single': I.mdiSofaSingle,
  'sofa-single-outline': I.mdiSofaSingleOutline,
  'solar-panel': I.mdiSolarPanel,
  'solar-panel-large': I.mdiSolarPanelLarge,
  'solar-power': I.mdiSolarPower,
  'solar-power-variant': I.mdiSolarPowerVariant,
  'solar-power-variant-outline': I.mdiSolarPowerVariantOutline,
  'soldering-iron': I.mdiSolderingIron,
  solid: I.mdiSolid,
  'sony-playstation': I.mdiSonyPlaystation,
  sort: I.mdiSort,
  'sort-alphabetical-ascending': I.mdiSortAlphabeticalAscending,
  'sort-alphabetical-ascending-variant': I.mdiSortAlphabeticalAscendingVariant,
  'sort-alphabetical-descending': I.mdiSortAlphabeticalDescending,
  'sort-alphabetical-descending-variant':
    I.mdiSortAlphabeticalDescendingVariant,
  'sort-alphabetical-variant': I.mdiSortAlphabeticalVariant,
  'sort-ascending': I.mdiSortAscending,
  'sort-bool-ascending': I.mdiSortBoolAscending,
  'sort-bool-ascending-variant': I.mdiSortBoolAscendingVariant,
  'sort-bool-descending': I.mdiSortBoolDescending,
  'sort-bool-descending-variant': I.mdiSortBoolDescendingVariant,
  'sort-calendar-ascending': I.mdiSortCalendarAscending,
  'sort-calendar-descending': I.mdiSortCalendarDescending,
  'sort-clock-ascending': I.mdiSortClockAscending,
  'sort-clock-ascending-outline': I.mdiSortClockAscendingOutline,
  'sort-clock-descending': I.mdiSortClockDescending,
  'sort-clock-descending-outline': I.mdiSortClockDescendingOutline,
  'sort-descending': I.mdiSortDescending,
  'sort-numeric-ascending': I.mdiSortNumericAscending,
  'sort-numeric-ascending-variant': I.mdiSortNumericAscendingVariant,
  'sort-numeric-descending': I.mdiSortNumericDescending,
  'sort-numeric-descending-variant': I.mdiSortNumericDescendingVariant,
  'sort-numeric-variant': I.mdiSortNumericVariant,
  'sort-reverse-variant': I.mdiSortReverseVariant,
  'sort-variant': I.mdiSortVariant,
  'sort-variant-lock': I.mdiSortVariantLock,
  'sort-variant-lock-open': I.mdiSortVariantLockOpen,
  'sort-variant-off': I.mdiSortVariantOff,
  'sort-variant-remove': I.mdiSortVariantRemove,
  soundbar: I.mdiSoundbar,
  soundcloud: I.mdiSoundcloud,
  'source-branch': I.mdiSourceBranch,
  'source-branch-check': I.mdiSourceBranchCheck,
  'source-branch-minus': I.mdiSourceBranchMinus,
  'source-branch-plus': I.mdiSourceBranchPlus,
  'source-branch-refresh': I.mdiSourceBranchRefresh,
  'source-branch-remove': I.mdiSourceBranchRemove,
  'source-branch-sync': I.mdiSourceBranchSync,
  'source-commit': I.mdiSourceCommit,
  'source-commit-end': I.mdiSourceCommitEnd,
  'source-commit-end-local': I.mdiSourceCommitEndLocal,
  'source-commit-local': I.mdiSourceCommitLocal,
  'source-commit-next-local': I.mdiSourceCommitNextLocal,
  'source-commit-start': I.mdiSourceCommitStart,
  'source-commit-start-next-local': I.mdiSourceCommitStartNextLocal,
  'source-fork': I.mdiSourceFork,
  'source-merge': I.mdiSourceMerge,
  'source-pull': I.mdiSourcePull,
  'source-repository': I.mdiSourceRepository,
  'source-repository-multiple': I.mdiSourceRepositoryMultiple,
  'soy-sauce': I.mdiSoySauce,
  'soy-sauce-off': I.mdiSoySauceOff,
  spa: I.mdiSpa,
  'spa-outline': I.mdiSpaOutline,
  'space-invaders': I.mdiSpaceInvaders,
  'space-station': I.mdiSpaceStation,
  spade: I.mdiSpade,
  speaker: I.mdiSpeaker,
  'speaker-bluetooth': I.mdiSpeakerBluetooth,
  'speaker-message': I.mdiSpeakerMessage,
  'speaker-multiple': I.mdiSpeakerMultiple,
  'speaker-off': I.mdiSpeakerOff,
  'speaker-pause': I.mdiSpeakerPause,
  'speaker-play': I.mdiSpeakerPlay,
  'speaker-stop': I.mdiSpeakerStop,
  'speaker-wireless': I.mdiSpeakerWireless,
  spear: I.mdiSpear,
  speedometer: I.mdiSpeedometer,
  'speedometer-medium': I.mdiSpeedometerMedium,
  'speedometer-slow': I.mdiSpeedometerSlow,
  spellcheck: I.mdiSpellcheck,
  sphere: I.mdiSphere,
  'sphere-off': I.mdiSphereOff,
  spider: I.mdiSpider,
  'spider-thread': I.mdiSpiderThread,
  'spider-web': I.mdiSpiderWeb,
  'spirit-level': I.mdiSpiritLevel,
  'spoon-sugar': I.mdiSpoonSugar,
  spotify: I.mdiSpotify,
  spotlight: I.mdiSpotlight,
  'spotlight-beam': I.mdiSpotlightBeam,
  spray: I.mdiSpray,
  'spray-bottle': I.mdiSprayBottle,
  sprinkler: I.mdiSprinkler,
  'sprinkler-fire': I.mdiSprinklerFire,
  'sprinkler-variant': I.mdiSprinklerVariant,
  sprout: I.mdiSprout,
  'sprout-outline': I.mdiSproutOutline,
  square: I.mdiSquare,
  'square-circle': I.mdiSquareCircle,
  'square-edit-outline': I.mdiSquareEditOutline,
  'square-medium': I.mdiSquareMedium,
  'square-medium-outline': I.mdiSquareMediumOutline,
  'square-off': I.mdiSquareOff,
  'square-off-outline': I.mdiSquareOffOutline,
  'square-opacity': I.mdiSquareOpacity,
  'square-outline': I.mdiSquareOutline,
  'square-root': I.mdiSquareRoot,
  'square-root-box': I.mdiSquareRootBox,
  'square-rounded': I.mdiSquareRounded,
  'square-rounded-badge': I.mdiSquareRoundedBadge,
  'square-rounded-badge-outline': I.mdiSquareRoundedBadgeOutline,
  'square-rounded-outline': I.mdiSquareRoundedOutline,
  'square-small': I.mdiSquareSmall,
  'square-wave': I.mdiSquareWave,
  squeegee: I.mdiSqueegee,
  ssh: I.mdiSsh,
  'stack-exchange': I.mdiStackExchange,
  'stack-overflow': I.mdiStackOverflow,
  stackpath: I.mdiStackpath,
  stadium: I.mdiStadium,
  'stadium-outline': I.mdiStadiumOutline,
  'stadium-variant': I.mdiStadiumVariant,
  stairs: I.mdiStairs,
  'stairs-box': I.mdiStairsBox,
  'stairs-down': I.mdiStairsDown,
  'stairs-up': I.mdiStairsUp,
  stamper: I.mdiStamper,
  'standard-definition': I.mdiStandardDefinition,
  star: I.mdiStar,
  'star-box': I.mdiStarBox,
  'star-box-multiple': I.mdiStarBoxMultiple,
  'star-box-multiple-outline': I.mdiStarBoxMultipleOutline,
  'star-box-outline': I.mdiStarBoxOutline,
  'star-check': I.mdiStarCheck,
  'star-check-outline': I.mdiStarCheckOutline,
  'star-circle': I.mdiStarCircle,
  'star-circle-outline': I.mdiStarCircleOutline,
  'star-cog': I.mdiStarCog,
  'star-cog-outline': I.mdiStarCogOutline,
  'star-crescent': I.mdiStarCrescent,
  'star-david': I.mdiStarDavid,
  'star-face': I.mdiStarFace,
  'star-four-points': I.mdiStarFourPoints,
  'star-four-points-outline': I.mdiStarFourPointsOutline,
  'star-half': I.mdiStarHalf,
  'star-half-full': I.mdiStarHalfFull,
  'star-minus': I.mdiStarMinus,
  'star-minus-outline': I.mdiStarMinusOutline,
  'star-off': I.mdiStarOff,
  'star-off-outline': I.mdiStarOffOutline,
  'star-outline': I.mdiStarOutline,
  'star-plus': I.mdiStarPlus,
  'star-plus-outline': I.mdiStarPlusOutline,
  'star-remove': I.mdiStarRemove,
  'star-remove-outline': I.mdiStarRemoveOutline,
  'star-settings': I.mdiStarSettings,
  'star-settings-outline': I.mdiStarSettingsOutline,
  'star-shooting': I.mdiStarShooting,
  'star-shooting-outline': I.mdiStarShootingOutline,
  'star-three-points': I.mdiStarThreePoints,
  'star-three-points-outline': I.mdiStarThreePointsOutline,
  'state-machine': I.mdiStateMachine,
  steam: I.mdiSteam,
  steering: I.mdiSteering,
  'steering-off': I.mdiSteeringOff,
  'step-backward': I.mdiStepBackward,
  'step-backward-2': I.mdiStepBackward2,
  'step-forward': I.mdiStepForward,
  'step-forward-2': I.mdiStepForward2,
  stethoscope: I.mdiStethoscope,
  sticker: I.mdiSticker,
  'sticker-alert': I.mdiStickerAlert,
  'sticker-alert-outline': I.mdiStickerAlertOutline,
  'sticker-check': I.mdiStickerCheck,
  'sticker-check-outline': I.mdiStickerCheckOutline,
  'sticker-circle-outline': I.mdiStickerCircleOutline,
  'sticker-emoji': I.mdiStickerEmoji,
  'sticker-minus': I.mdiStickerMinus,
  'sticker-minus-outline': I.mdiStickerMinusOutline,
  'sticker-outline': I.mdiStickerOutline,
  'sticker-plus': I.mdiStickerPlus,
  'sticker-plus-outline': I.mdiStickerPlusOutline,
  'sticker-remove': I.mdiStickerRemove,
  'sticker-remove-outline': I.mdiStickerRemoveOutline,
  'sticker-text': I.mdiStickerText,
  'sticker-text-outline': I.mdiStickerTextOutline,
  stocking: I.mdiStocking,
  stomach: I.mdiStomach,
  stool: I.mdiStool,
  'stool-outline': I.mdiStoolOutline,
  stop: I.mdiStop,
  'stop-circle': I.mdiStopCircle,
  'stop-circle-outline': I.mdiStopCircleOutline,
  'storage-tank': I.mdiStorageTank,
  'storage-tank-outline': I.mdiStorageTankOutline,
  store: I.mdiStore,
  'store-24-hour': I.mdiStore24Hour,
  'store-alert': I.mdiStoreAlert,
  'store-alert-outline': I.mdiStoreAlertOutline,
  'store-check': I.mdiStoreCheck,
  'store-check-outline': I.mdiStoreCheckOutline,
  'store-clock': I.mdiStoreClock,
  'store-clock-outline': I.mdiStoreClockOutline,
  'store-cog': I.mdiStoreCog,
  'store-cog-outline': I.mdiStoreCogOutline,
  'store-edit': I.mdiStoreEdit,
  'store-edit-outline': I.mdiStoreEditOutline,
  'store-marker': I.mdiStoreMarker,
  'store-marker-outline': I.mdiStoreMarkerOutline,
  'store-minus': I.mdiStoreMinus,
  'store-minus-outline': I.mdiStoreMinusOutline,
  'store-off': I.mdiStoreOff,
  'store-off-outline': I.mdiStoreOffOutline,
  'store-outline': I.mdiStoreOutline,
  'store-plus': I.mdiStorePlus,
  'store-plus-outline': I.mdiStorePlusOutline,
  'store-remove': I.mdiStoreRemove,
  'store-remove-outline': I.mdiStoreRemoveOutline,
  'store-search': I.mdiStoreSearch,
  'store-search-outline': I.mdiStoreSearchOutline,
  'store-settings': I.mdiStoreSettings,
  'store-settings-outline': I.mdiStoreSettingsOutline,
  storefront: I.mdiStorefront,
  'storefront-check': I.mdiStorefrontCheck,
  'storefront-check-outline': I.mdiStorefrontCheckOutline,
  'storefront-edit': I.mdiStorefrontEdit,
  'storefront-edit-outline': I.mdiStorefrontEditOutline,
  'storefront-minus': I.mdiStorefrontMinus,
  'storefront-minus-outline': I.mdiStorefrontMinusOutline,
  'storefront-outline': I.mdiStorefrontOutline,
  'storefront-plus': I.mdiStorefrontPlus,
  'storefront-plus-outline': I.mdiStorefrontPlusOutline,
  'storefront-remove': I.mdiStorefrontRemove,
  'storefront-remove-outline': I.mdiStorefrontRemoveOutline,
  stove: I.mdiStove,
  strategy: I.mdiStrategy,
  'stretch-to-page': I.mdiStretchToPage,
  'stretch-to-page-outline': I.mdiStretchToPageOutline,
  'string-lights': I.mdiStringLights,
  'string-lights-off': I.mdiStringLightsOff,
  'subdirectory-arrow-left': I.mdiSubdirectoryArrowLeft,
  'subdirectory-arrow-right': I.mdiSubdirectoryArrowRight,
  submarine: I.mdiSubmarine,
  subtitles: I.mdiSubtitles,
  'subtitles-outline': I.mdiSubtitlesOutline,
  subway: I.mdiSubway,
  'subway-alert-variant': I.mdiSubwayAlertVariant,
  'subway-variant': I.mdiSubwayVariant,
  summit: I.mdiSummit,
  'sun-angle': I.mdiSunAngle,
  'sun-angle-outline': I.mdiSunAngleOutline,
  'sun-clock': I.mdiSunClock,
  'sun-clock-outline': I.mdiSunClockOutline,
  'sun-compass': I.mdiSunCompass,
  'sun-snowflake': I.mdiSunSnowflake,
  'sun-snowflake-variant': I.mdiSunSnowflakeVariant,
  'sun-thermometer': I.mdiSunThermometer,
  'sun-thermometer-outline': I.mdiSunThermometerOutline,
  'sun-wireless': I.mdiSunWireless,
  'sun-wireless-outline': I.mdiSunWirelessOutline,
  sunglasses: I.mdiSunglasses,
  surfing: I.mdiSurfing,
  'surround-sound': I.mdiSurroundSound,
  'surround-sound-20': I.mdiSurroundSound20,
  'surround-sound-21': I.mdiSurroundSound21,
  'surround-sound-31': I.mdiSurroundSound31,
  'surround-sound-51': I.mdiSurroundSound51,
  'surround-sound-71': I.mdiSurroundSound71,
  'surround-sound-512': I.mdiSurroundSound512,
  svg: I.mdiSvg,
  'swap-horizontal': I.mdiSwapHorizontal,
  'swap-horizontal-bold': I.mdiSwapHorizontalBold,
  'swap-horizontal-circle': I.mdiSwapHorizontalCircle,
  'swap-horizontal-circle-outline': I.mdiSwapHorizontalCircleOutline,
  'swap-horizontal-variant': I.mdiSwapHorizontalVariant,
  'swap-vertical': I.mdiSwapVertical,
  'swap-vertical-bold': I.mdiSwapVerticalBold,
  'swap-vertical-circle': I.mdiSwapVerticalCircle,
  'swap-vertical-circle-outline': I.mdiSwapVerticalCircleOutline,
  'swap-vertical-variant': I.mdiSwapVerticalVariant,
  swim: I.mdiSwim,
  switch: I.mdiSwitch,
  sword: I.mdiSword,
  'sword-cross': I.mdiSwordCross,
  'syllabary-hangul': I.mdiSyllabaryHangul,
  'syllabary-hiragana': I.mdiSyllabaryHiragana,
  'syllabary-katakana': I.mdiSyllabaryKatakana,
  'syllabary-katakana-halfwidth': I.mdiSyllabaryKatakanaHalfwidth,
  symbol: I.mdiSymbol,
  symfony: I.mdiSymfony,
  synagogue: I.mdiSynagogue,
  'synagogue-outline': I.mdiSynagogueOutline,
  sync: I.mdiSync,
  'sync-alert': I.mdiSyncAlert,
  'sync-circle': I.mdiSyncCircle,
  'sync-off': I.mdiSyncOff,
  tab: I.mdiTab,
  'tab-minus': I.mdiTabMinus,
  'tab-plus': I.mdiTabPlus,
  'tab-remove': I.mdiTabRemove,
  'tab-search': I.mdiTabSearch,
  'tab-unselected': I.mdiTabUnselected,
  table: I.mdiTable,
  'table-account': I.mdiTableAccount,
  'table-alert': I.mdiTableAlert,
  'table-arrow-down': I.mdiTableArrowDown,
  'table-arrow-left': I.mdiTableArrowLeft,
  'table-arrow-right': I.mdiTableArrowRight,
  'table-arrow-up': I.mdiTableArrowUp,
  'table-border': I.mdiTableBorder,
  'table-cancel': I.mdiTableCancel,
  'table-chair': I.mdiTableChair,
  'table-check': I.mdiTableCheck,
  'table-clock': I.mdiTableClock,
  'table-cog': I.mdiTableCog,
  'table-column': I.mdiTableColumn,
  'table-column-plus-after': I.mdiTableColumnPlusAfter,
  'table-column-plus-before': I.mdiTableColumnPlusBefore,
  'table-column-remove': I.mdiTableColumnRemove,
  'table-column-width': I.mdiTableColumnWidth,
  'table-edit': I.mdiTableEdit,
  'table-eye': I.mdiTableEye,
  'table-eye-off': I.mdiTableEyeOff,
  'table-filter': I.mdiTableFilter,
  'table-furniture': I.mdiTableFurniture,
  'table-headers-eye': I.mdiTableHeadersEye,
  'table-headers-eye-off': I.mdiTableHeadersEyeOff,
  'table-heart': I.mdiTableHeart,
  'table-key': I.mdiTableKey,
  'table-large': I.mdiTableLarge,
  'table-large-plus': I.mdiTableLargePlus,
  'table-large-remove': I.mdiTableLargeRemove,
  'table-lock': I.mdiTableLock,
  'table-merge-cells': I.mdiTableMergeCells,
  'table-minus': I.mdiTableMinus,
  'table-multiple': I.mdiTableMultiple,
  'table-network': I.mdiTableNetwork,
  'table-of-contents': I.mdiTableOfContents,
  'table-off': I.mdiTableOff,
  'table-picnic': I.mdiTablePicnic,
  'table-pivot': I.mdiTablePivot,
  'table-plus': I.mdiTablePlus,
  'table-question': I.mdiTableQuestion,
  'table-refresh': I.mdiTableRefresh,
  'table-remove': I.mdiTableRemove,
  'table-row': I.mdiTableRow,
  'table-row-height': I.mdiTableRowHeight,
  'table-row-plus-after': I.mdiTableRowPlusAfter,
  'table-row-plus-before': I.mdiTableRowPlusBefore,
  'table-row-remove': I.mdiTableRowRemove,
  'table-search': I.mdiTableSearch,
  'table-settings': I.mdiTableSettings,
  'table-split-cell': I.mdiTableSplitCell,
  'table-star': I.mdiTableStar,
  'table-sync': I.mdiTableSync,
  'table-tennis': I.mdiTableTennis,
  tablet: I.mdiTablet,
  'tablet-cellphone': I.mdiTabletCellphone,
  'tablet-dashboard': I.mdiTabletDashboard,
  taco: I.mdiTaco,
  tag: I.mdiTag,
  'tag-arrow-down': I.mdiTagArrowDown,
  'tag-arrow-down-outline': I.mdiTagArrowDownOutline,
  'tag-arrow-left': I.mdiTagArrowLeft,
  'tag-arrow-left-outline': I.mdiTagArrowLeftOutline,
  'tag-arrow-right': I.mdiTagArrowRight,
  'tag-arrow-right-outline': I.mdiTagArrowRightOutline,
  'tag-arrow-up': I.mdiTagArrowUp,
  'tag-arrow-up-outline': I.mdiTagArrowUpOutline,
  'tag-check': I.mdiTagCheck,
  'tag-check-outline': I.mdiTagCheckOutline,
  'tag-faces': I.mdiTagFaces,
  'tag-heart': I.mdiTagHeart,
  'tag-heart-outline': I.mdiTagHeartOutline,
  'tag-minus': I.mdiTagMinus,
  'tag-minus-outline': I.mdiTagMinusOutline,
  'tag-multiple': I.mdiTagMultiple,
  'tag-multiple-outline': I.mdiTagMultipleOutline,
  'tag-off': I.mdiTagOff,
  'tag-off-outline': I.mdiTagOffOutline,
  'tag-outline': I.mdiTagOutline,
  'tag-plus': I.mdiTagPlus,
  'tag-plus-outline': I.mdiTagPlusOutline,
  'tag-remove': I.mdiTagRemove,
  'tag-remove-outline': I.mdiTagRemoveOutline,
  'tag-search': I.mdiTagSearch,
  'tag-search-outline': I.mdiTagSearchOutline,
  'tag-text': I.mdiTagText,
  'tag-text-outline': I.mdiTagTextOutline,
  tailwind: I.mdiTailwind,
  'tally-mark-1': I.mdiTallyMark1,
  'tally-mark-2': I.mdiTallyMark2,
  'tally-mark-3': I.mdiTallyMark3,
  'tally-mark-4': I.mdiTallyMark4,
  'tally-mark-5': I.mdiTallyMark5,
  tangram: I.mdiTangram,
  tank: I.mdiTank,
  'tanker-truck': I.mdiTankerTruck,
  'tape-drive': I.mdiTapeDrive,
  'tape-measure': I.mdiTapeMeasure,
  target: I.mdiTarget,
  'target-account': I.mdiTargetAccount,
  'target-variant': I.mdiTargetVariant,
  taxi: I.mdiTaxi,
  tea: I.mdiTea,
  'tea-outline': I.mdiTeaOutline,
  teamviewer: I.mdiTeamviewer,
  'teddy-bear': I.mdiTeddyBear,
  telescope: I.mdiTelescope,
  television: I.mdiTelevision,
  'television-ambient-light': I.mdiTelevisionAmbientLight,
  'television-box': I.mdiTelevisionBox,
  'television-classic': I.mdiTelevisionClassic,
  'television-classic-off': I.mdiTelevisionClassicOff,
  'television-guide': I.mdiTelevisionGuide,
  'television-off': I.mdiTelevisionOff,
  'television-pause': I.mdiTelevisionPause,
  'television-play': I.mdiTelevisionPlay,
  'television-shimmer': I.mdiTelevisionShimmer,
  'television-speaker': I.mdiTelevisionSpeaker,
  'television-speaker-off': I.mdiTelevisionSpeakerOff,
  'television-stop': I.mdiTelevisionStop,
  'temperature-celsius': I.mdiTemperatureCelsius,
  'temperature-fahrenheit': I.mdiTemperatureFahrenheit,
  'temperature-kelvin': I.mdiTemperatureKelvin,
  'temple-buddhist': I.mdiTempleBuddhist,
  'temple-buddhist-outline': I.mdiTempleBuddhistOutline,
  'temple-hindu': I.mdiTempleHindu,
  'temple-hindu-outline': I.mdiTempleHinduOutline,
  tennis: I.mdiTennis,
  'tennis-ball': I.mdiTennisBall,
  tent: I.mdiTent,
  terraform: I.mdiTerraform,
  terrain: I.mdiTerrain,
  'test-tube': I.mdiTestTube,
  'test-tube-empty': I.mdiTestTubeEmpty,
  'test-tube-off': I.mdiTestTubeOff,
  text: I.mdiText,
  'text-account': I.mdiTextAccount,
  'text-box': I.mdiTextBox,
  'text-box-check': I.mdiTextBoxCheck,
  'text-box-check-outline': I.mdiTextBoxCheckOutline,
  'text-box-edit': I.mdiTextBoxEdit,
  'text-box-edit-outline': I.mdiTextBoxEditOutline,
  'text-box-minus': I.mdiTextBoxMinus,
  'text-box-minus-outline': I.mdiTextBoxMinusOutline,
  'text-box-multiple': I.mdiTextBoxMultiple,
  'text-box-multiple-outline': I.mdiTextBoxMultipleOutline,
  'text-box-outline': I.mdiTextBoxOutline,
  'text-box-plus': I.mdiTextBoxPlus,
  'text-box-plus-outline': I.mdiTextBoxPlusOutline,
  'text-box-remove': I.mdiTextBoxRemove,
  'text-box-remove-outline': I.mdiTextBoxRemoveOutline,
  'text-box-search': I.mdiTextBoxSearch,
  'text-box-search-outline': I.mdiTextBoxSearchOutline,
  'text-long': I.mdiTextLong,
  'text-recognition': I.mdiTextRecognition,
  'text-search': I.mdiTextSearch,
  'text-search-variant': I.mdiTextSearchVariant,
  'text-shadow': I.mdiTextShadow,
  'text-short': I.mdiTextShort,
  texture: I.mdiTexture,
  'texture-box': I.mdiTextureBox,
  theater: I.mdiTheater,
  'theme-light-dark': I.mdiThemeLightDark,
  thermometer: I.mdiThermometer,
  'thermometer-alert': I.mdiThermometerAlert,
  'thermometer-auto': I.mdiThermometerAuto,
  'thermometer-bluetooth': I.mdiThermometerBluetooth,
  'thermometer-check': I.mdiThermometerCheck,
  'thermometer-chevron-down': I.mdiThermometerChevronDown,
  'thermometer-chevron-up': I.mdiThermometerChevronUp,
  'thermometer-high': I.mdiThermometerHigh,
  'thermometer-lines': I.mdiThermometerLines,
  'thermometer-low': I.mdiThermometerLow,
  'thermometer-minus': I.mdiThermometerMinus,
  'thermometer-off': I.mdiThermometerOff,
  'thermometer-plus': I.mdiThermometerPlus,
  'thermometer-probe': I.mdiThermometerProbe,
  'thermometer-probe-off': I.mdiThermometerProbeOff,
  'thermometer-water': I.mdiThermometerWater,
  thermostat: I.mdiThermostat,
  'thermostat-auto': I.mdiThermostatAuto,
  'thermostat-box': I.mdiThermostatBox,
  'thermostat-box-auto': I.mdiThermostatBoxAuto,
  'thought-bubble': I.mdiThoughtBubble,
  'thought-bubble-outline': I.mdiThoughtBubbleOutline,
  'thumb-down': I.mdiThumbDown,
  'thumb-down-outline': I.mdiThumbDownOutline,
  'thumb-up': I.mdiThumbUp,
  'thumb-up-outline': I.mdiThumbUpOutline,
  'thumbs-up-down': I.mdiThumbsUpDown,
  'thumbs-up-down-outline': I.mdiThumbsUpDownOutline,
  ticket: I.mdiTicket,
  'ticket-account': I.mdiTicketAccount,
  'ticket-confirmation': I.mdiTicketConfirmation,
  'ticket-confirmation-outline': I.mdiTicketConfirmationOutline,
  'ticket-outline': I.mdiTicketOutline,
  'ticket-percent': I.mdiTicketPercent,
  'ticket-percent-outline': I.mdiTicketPercentOutline,
  tie: I.mdiTie,
  tilde: I.mdiTilde,
  'tilde-off': I.mdiTildeOff,
  timelapse: I.mdiTimelapse,
  timeline: I.mdiTimeline,
  'timeline-alert': I.mdiTimelineAlert,
  'timeline-alert-outline': I.mdiTimelineAlertOutline,
  'timeline-check': I.mdiTimelineCheck,
  'timeline-check-outline': I.mdiTimelineCheckOutline,
  'timeline-clock': I.mdiTimelineClock,
  'timeline-clock-outline': I.mdiTimelineClockOutline,
  'timeline-minus': I.mdiTimelineMinus,
  'timeline-minus-outline': I.mdiTimelineMinusOutline,
  'timeline-outline': I.mdiTimelineOutline,
  'timeline-plus': I.mdiTimelinePlus,
  'timeline-plus-outline': I.mdiTimelinePlusOutline,
  'timeline-question': I.mdiTimelineQuestion,
  'timeline-question-outline': I.mdiTimelineQuestionOutline,
  'timeline-remove': I.mdiTimelineRemove,
  'timeline-remove-outline': I.mdiTimelineRemoveOutline,
  'timeline-text': I.mdiTimelineText,
  'timeline-text-outline': I.mdiTimelineTextOutline,
  timer: I.mdiTimer,
  'timer-3': I.mdiTimer3,
  'timer-10': I.mdiTimer10,
  'timer-alert': I.mdiTimerAlert,
  'timer-alert-outline': I.mdiTimerAlertOutline,
  'timer-cancel': I.mdiTimerCancel,
  'timer-cancel-outline': I.mdiTimerCancelOutline,
  'timer-check': I.mdiTimerCheck,
  'timer-check-outline': I.mdiTimerCheckOutline,
  'timer-cog': I.mdiTimerCog,
  'timer-cog-outline': I.mdiTimerCogOutline,
  'timer-edit': I.mdiTimerEdit,
  'timer-edit-outline': I.mdiTimerEditOutline,
  'timer-lock': I.mdiTimerLock,
  'timer-lock-open': I.mdiTimerLockOpen,
  'timer-lock-open-outline': I.mdiTimerLockOpenOutline,
  'timer-lock-outline': I.mdiTimerLockOutline,
  'timer-marker': I.mdiTimerMarker,
  'timer-marker-outline': I.mdiTimerMarkerOutline,
  'timer-minus': I.mdiTimerMinus,
  'timer-minus-outline': I.mdiTimerMinusOutline,
  'timer-music': I.mdiTimerMusic,
  'timer-music-outline': I.mdiTimerMusicOutline,
  'timer-off': I.mdiTimerOff,
  'timer-off-outline': I.mdiTimerOffOutline,
  'timer-outline': I.mdiTimerOutline,
  'timer-pause': I.mdiTimerPause,
  'timer-pause-outline': I.mdiTimerPauseOutline,
  'timer-play': I.mdiTimerPlay,
  'timer-play-outline': I.mdiTimerPlayOutline,
  'timer-plus': I.mdiTimerPlus,
  'timer-plus-outline': I.mdiTimerPlusOutline,
  'timer-refresh': I.mdiTimerRefresh,
  'timer-refresh-outline': I.mdiTimerRefreshOutline,
  'timer-remove': I.mdiTimerRemove,
  'timer-remove-outline': I.mdiTimerRemoveOutline,
  'timer-sand': I.mdiTimerSand,
  'timer-sand-complete': I.mdiTimerSandComplete,
  'timer-sand-empty': I.mdiTimerSandEmpty,
  'timer-sand-full': I.mdiTimerSandFull,
  'timer-sand-paused': I.mdiTimerSandPaused,
  'timer-settings': I.mdiTimerSettings,
  'timer-settings-outline': I.mdiTimerSettingsOutline,
  'timer-star': I.mdiTimerStar,
  'timer-star-outline': I.mdiTimerStarOutline,
  'timer-stop': I.mdiTimerStop,
  'timer-stop-outline': I.mdiTimerStopOutline,
  'timer-sync': I.mdiTimerSync,
  'timer-sync-outline': I.mdiTimerSyncOutline,
  timetable: I.mdiTimetable,
  tire: I.mdiTire,
  toaster: I.mdiToaster,
  'toaster-off': I.mdiToasterOff,
  'toaster-oven': I.mdiToasterOven,
  'toggle-switch': I.mdiToggleSwitch,
  'toggle-switch-off': I.mdiToggleSwitchOff,
  'toggle-switch-off-outline': I.mdiToggleSwitchOffOutline,
  'toggle-switch-outline': I.mdiToggleSwitchOutline,
  'toggle-switch-variant': I.mdiToggleSwitchVariant,
  'toggle-switch-variant-off': I.mdiToggleSwitchVariantOff,
  toilet: I.mdiToilet,
  toolbox: I.mdiToolbox,
  'toolbox-outline': I.mdiToolboxOutline,
  tools: I.mdiTools,
  tooltip: I.mdiTooltip,
  'tooltip-account': I.mdiTooltipAccount,
  'tooltip-cellphone': I.mdiTooltipCellphone,
  'tooltip-check': I.mdiTooltipCheck,
  'tooltip-check-outline': I.mdiTooltipCheckOutline,
  'tooltip-edit': I.mdiTooltipEdit,
  'tooltip-edit-outline': I.mdiTooltipEditOutline,
  'tooltip-image': I.mdiTooltipImage,
  'tooltip-image-outline': I.mdiTooltipImageOutline,
  'tooltip-minus': I.mdiTooltipMinus,
  'tooltip-minus-outline': I.mdiTooltipMinusOutline,
  'tooltip-outline': I.mdiTooltipOutline,
  'tooltip-plus': I.mdiTooltipPlus,
  'tooltip-plus-outline': I.mdiTooltipPlusOutline,
  'tooltip-remove': I.mdiTooltipRemove,
  'tooltip-remove-outline': I.mdiTooltipRemoveOutline,
  'tooltip-text': I.mdiTooltipText,
  'tooltip-text-outline': I.mdiTooltipTextOutline,
  tooth: I.mdiTooth,
  'tooth-outline': I.mdiToothOutline,
  toothbrush: I.mdiToothbrush,
  'toothbrush-electric': I.mdiToothbrushElectric,
  'toothbrush-paste': I.mdiToothbrushPaste,
  torch: I.mdiTorch,
  tortoise: I.mdiTortoise,
  toslink: I.mdiToslink,
  tournament: I.mdiTournament,
  'tow-truck': I.mdiTowTruck,
  'tower-beach': I.mdiTowerBeach,
  'tower-fire': I.mdiTowerFire,
  'town-hall': I.mdiTownHall,
  'toy-brick': I.mdiToyBrick,
  'toy-brick-marker': I.mdiToyBrickMarker,
  'toy-brick-marker-outline': I.mdiToyBrickMarkerOutline,
  'toy-brick-minus': I.mdiToyBrickMinus,
  'toy-brick-minus-outline': I.mdiToyBrickMinusOutline,
  'toy-brick-outline': I.mdiToyBrickOutline,
  'toy-brick-plus': I.mdiToyBrickPlus,
  'toy-brick-plus-outline': I.mdiToyBrickPlusOutline,
  'toy-brick-remove': I.mdiToyBrickRemove,
  'toy-brick-remove-outline': I.mdiToyBrickRemoveOutline,
  'toy-brick-search': I.mdiToyBrickSearch,
  'toy-brick-search-outline': I.mdiToyBrickSearchOutline,
  'track-light': I.mdiTrackLight,
  'track-light-off': I.mdiTrackLightOff,
  trackpad: I.mdiTrackpad,
  'trackpad-lock': I.mdiTrackpadLock,
  tractor: I.mdiTractor,
  'tractor-variant': I.mdiTractorVariant,
  trademark: I.mdiTrademark,
  'traffic-cone': I.mdiTrafficCone,
  'traffic-light': I.mdiTrafficLight,
  'traffic-light-outline': I.mdiTrafficLightOutline,
  train: I.mdiTrain,
  'train-car': I.mdiTrainCar,
  'train-car-autorack': I.mdiTrainCarAutorack,
  'train-car-box': I.mdiTrainCarBox,
  'train-car-box-full': I.mdiTrainCarBoxFull,
  'train-car-box-open': I.mdiTrainCarBoxOpen,
  'train-car-caboose': I.mdiTrainCarCaboose,
  'train-car-centerbeam': I.mdiTrainCarCenterbeam,
  'train-car-centerbeam-full': I.mdiTrainCarCenterbeamFull,
  'train-car-container': I.mdiTrainCarContainer,
  'train-car-flatbed': I.mdiTrainCarFlatbed,
  'train-car-flatbed-car': I.mdiTrainCarFlatbedCar,
  'train-car-flatbed-tank': I.mdiTrainCarFlatbedTank,
  'train-car-gondola': I.mdiTrainCarGondola,
  'train-car-gondola-full': I.mdiTrainCarGondolaFull,
  'train-car-hopper': I.mdiTrainCarHopper,
  'train-car-hopper-covered': I.mdiTrainCarHopperCovered,
  'train-car-hopper-full': I.mdiTrainCarHopperFull,
  'train-car-intermodal': I.mdiTrainCarIntermodal,
  'train-car-passenger': I.mdiTrainCarPassenger,
  'train-car-passenger-door': I.mdiTrainCarPassengerDoor,
  'train-car-passenger-door-open': I.mdiTrainCarPassengerDoorOpen,
  'train-car-passenger-variant': I.mdiTrainCarPassengerVariant,
  'train-car-tank': I.mdiTrainCarTank,
  'train-variant': I.mdiTrainVariant,
  tram: I.mdiTram,
  'tram-side': I.mdiTramSide,
  transcribe: I.mdiTranscribe,
  'transcribe-close': I.mdiTranscribeClose,
  transfer: I.mdiTransfer,
  'transfer-down': I.mdiTransferDown,
  'transfer-left': I.mdiTransferLeft,
  'transfer-right': I.mdiTransferRight,
  'transfer-up': I.mdiTransferUp,
  'transit-connection': I.mdiTransitConnection,
  'transit-connection-horizontal': I.mdiTransitConnectionHorizontal,
  'transit-connection-variant': I.mdiTransitConnectionVariant,
  'transit-detour': I.mdiTransitDetour,
  'transit-skip': I.mdiTransitSkip,
  'transit-transfer': I.mdiTransitTransfer,
  transition: I.mdiTransition,
  'transition-masked': I.mdiTransitionMasked,
  translate: I.mdiTranslate,
  'translate-off': I.mdiTranslateOff,
  'translate-variant': I.mdiTranslateVariant,
  'transmission-tower': I.mdiTransmissionTower,
  'transmission-tower-export': I.mdiTransmissionTowerExport,
  'transmission-tower-import': I.mdiTransmissionTowerImport,
  'transmission-tower-off': I.mdiTransmissionTowerOff,
  'trash-can': I.mdiTrashCan,
  'trash-can-outline': I.mdiTrashCanOutline,
  tray: I.mdiTray,
  'tray-alert': I.mdiTrayAlert,
  'tray-arrow-down': I.mdiTrayArrowDown,
  'tray-arrow-up': I.mdiTrayArrowUp,
  'tray-full': I.mdiTrayFull,
  'tray-minus': I.mdiTrayMinus,
  'tray-plus': I.mdiTrayPlus,
  'tray-remove': I.mdiTrayRemove,
  'treasure-chest': I.mdiTreasureChest,
  tree: I.mdiTree,
  'tree-outline': I.mdiTreeOutline,
  trello: I.mdiTrello,
  'trending-down': I.mdiTrendingDown,
  'trending-neutral': I.mdiTrendingNeutral,
  'trending-up': I.mdiTrendingUp,
  triangle: I.mdiTriangle,
  'triangle-outline': I.mdiTriangleOutline,
  'triangle-small-down': I.mdiTriangleSmallDown,
  'triangle-small-up': I.mdiTriangleSmallUp,
  'triangle-wave': I.mdiTriangleWave,
  triforce: I.mdiTriforce,
  trophy: I.mdiTrophy,
  'trophy-award': I.mdiTrophyAward,
  'trophy-broken': I.mdiTrophyBroken,
  'trophy-outline': I.mdiTrophyOutline,
  'trophy-variant': I.mdiTrophyVariant,
  'trophy-variant-outline': I.mdiTrophyVariantOutline,
  truck: I.mdiTruck,
  'truck-alert': I.mdiTruckAlert,
  'truck-alert-outline': I.mdiTruckAlertOutline,
  'truck-cargo-container': I.mdiTruckCargoContainer,
  'truck-check': I.mdiTruckCheck,
  'truck-check-outline': I.mdiTruckCheckOutline,
  'truck-delivery': I.mdiTruckDelivery,
  'truck-delivery-outline': I.mdiTruckDeliveryOutline,
  'truck-fast': I.mdiTruckFast,
  'truck-fast-outline': I.mdiTruckFastOutline,
  'truck-flatbed': I.mdiTruckFlatbed,
  'truck-minus': I.mdiTruckMinus,
  'truck-minus-outline': I.mdiTruckMinusOutline,
  'truck-outline': I.mdiTruckOutline,
  'truck-plus': I.mdiTruckPlus,
  'truck-plus-outline': I.mdiTruckPlusOutline,
  'truck-remove': I.mdiTruckRemove,
  'truck-remove-outline': I.mdiTruckRemoveOutline,
  'truck-snowflake': I.mdiTruckSnowflake,
  'truck-trailer': I.mdiTruckTrailer,
  trumpet: I.mdiTrumpet,
  'tshirt-crew': I.mdiTshirtCrew,
  'tshirt-crew-outline': I.mdiTshirtCrewOutline,
  'tshirt-v': I.mdiTshirtV,
  'tshirt-v-outline': I.mdiTshirtVOutline,
  tsunami: I.mdiTsunami,
  'tumble-dryer': I.mdiTumbleDryer,
  'tumble-dryer-alert': I.mdiTumbleDryerAlert,
  'tumble-dryer-off': I.mdiTumbleDryerOff,
  tune: I.mdiTune,
  'tune-variant': I.mdiTuneVariant,
  'tune-vertical': I.mdiTuneVertical,
  'tune-vertical-variant': I.mdiTuneVerticalVariant,
  tunnel: I.mdiTunnel,
  'tunnel-outline': I.mdiTunnelOutline,
  turbine: I.mdiTurbine,
  turkey: I.mdiTurkey,
  turnstile: I.mdiTurnstile,
  'turnstile-outline': I.mdiTurnstileOutline,
  turtle: I.mdiTurtle,
  twitch: I.mdiTwitch,
  twitter: I.mdiTwitter,
  'two-factor-authentication': I.mdiTwoFactorAuthentication,
  typewriter: I.mdiTypewriter,
  ubisoft: I.mdiUbisoft,
  ubuntu: I.mdiUbuntu,
  ufo: I.mdiUfo,
  'ufo-outline': I.mdiUfoOutline,
  'ultra-high-definition': I.mdiUltraHighDefinition,
  umbraco: I.mdiUmbraco,
  umbrella: I.mdiUmbrella,
  'umbrella-beach': I.mdiUmbrellaBeach,
  'umbrella-beach-outline': I.mdiUmbrellaBeachOutline,
  'umbrella-closed': I.mdiUmbrellaClosed,
  'umbrella-closed-outline': I.mdiUmbrellaClosedOutline,
  'umbrella-closed-variant': I.mdiUmbrellaClosedVariant,
  'umbrella-outline': I.mdiUmbrellaOutline,
  undo: I.mdiUndo,
  'undo-variant': I.mdiUndoVariant,
  'unfold-less-horizontal': I.mdiUnfoldLessHorizontal,
  'unfold-less-vertical': I.mdiUnfoldLessVertical,
  'unfold-more-horizontal': I.mdiUnfoldMoreHorizontal,
  'unfold-more-vertical': I.mdiUnfoldMoreVertical,
  ungroup: I.mdiUngroup,
  unicode: I.mdiUnicode,
  unicorn: I.mdiUnicorn,
  'unicorn-variant': I.mdiUnicornVariant,
  unicycle: I.mdiUnicycle,
  unity: I.mdiUnity,
  unreal: I.mdiUnreal,
  update: I.mdiUpdate,
  upload: I.mdiUpload,
  'upload-lock': I.mdiUploadLock,
  'upload-lock-outline': I.mdiUploadLockOutline,
  'upload-multiple': I.mdiUploadMultiple,
  'upload-network': I.mdiUploadNetwork,
  'upload-network-outline': I.mdiUploadNetworkOutline,
  'upload-off': I.mdiUploadOff,
  'upload-off-outline': I.mdiUploadOffOutline,
  'upload-outline': I.mdiUploadOutline,
  usb: I.mdiUsb,
  'usb-flash-drive': I.mdiUsbFlashDrive,
  'usb-flash-drive-outline': I.mdiUsbFlashDriveOutline,
  'usb-port': I.mdiUsbPort,
  vacuum: I.mdiVacuum,
  'vacuum-outline': I.mdiVacuumOutline,
  valve: I.mdiValve,
  'valve-closed': I.mdiValveClosed,
  'valve-open': I.mdiValveOpen,
  'van-passenger': I.mdiVanPassenger,
  'van-utility': I.mdiVanUtility,
  vanish: I.mdiVanish,
  'vanish-quarter': I.mdiVanishQuarter,
  'vanity-light': I.mdiVanityLight,
  variable: I.mdiVariable,
  'variable-box': I.mdiVariableBox,
  'vector-arrange-above': I.mdiVectorArrangeAbove,
  'vector-arrange-below': I.mdiVectorArrangeBelow,
  'vector-bezier': I.mdiVectorBezier,
  'vector-circle': I.mdiVectorCircle,
  'vector-circle-variant': I.mdiVectorCircleVariant,
  'vector-combine': I.mdiVectorCombine,
  'vector-curve': I.mdiVectorCurve,
  'vector-difference': I.mdiVectorDifference,
  'vector-difference-ab': I.mdiVectorDifferenceAb,
  'vector-difference-ba': I.mdiVectorDifferenceBa,
  'vector-ellipse': I.mdiVectorEllipse,
  'vector-intersection': I.mdiVectorIntersection,
  'vector-line': I.mdiVectorLine,
  'vector-link': I.mdiVectorLink,
  'vector-point': I.mdiVectorPoint,
  'vector-point-edit': I.mdiVectorPointEdit,
  'vector-point-minus': I.mdiVectorPointMinus,
  'vector-point-plus': I.mdiVectorPointPlus,
  'vector-point-select': I.mdiVectorPointSelect,
  'vector-polygon': I.mdiVectorPolygon,
  'vector-polygon-variant': I.mdiVectorPolygonVariant,
  'vector-polyline': I.mdiVectorPolyline,
  'vector-polyline-edit': I.mdiVectorPolylineEdit,
  'vector-polyline-minus': I.mdiVectorPolylineMinus,
  'vector-polyline-plus': I.mdiVectorPolylinePlus,
  'vector-polyline-remove': I.mdiVectorPolylineRemove,
  'vector-radius': I.mdiVectorRadius,
  'vector-rectangle': I.mdiVectorRectangle,
  'vector-selection': I.mdiVectorSelection,
  'vector-square': I.mdiVectorSquare,
  'vector-square-close': I.mdiVectorSquareClose,
  'vector-square-edit': I.mdiVectorSquareEdit,
  'vector-square-minus': I.mdiVectorSquareMinus,
  'vector-square-open': I.mdiVectorSquareOpen,
  'vector-square-plus': I.mdiVectorSquarePlus,
  'vector-square-remove': I.mdiVectorSquareRemove,
  'vector-triangle': I.mdiVectorTriangle,
  'vector-union': I.mdiVectorUnion,
  vhs: I.mdiVhs,
  vibrate: I.mdiVibrate,
  'vibrate-off': I.mdiVibrateOff,
  video: I.mdiVideo,
  'video-2-d': I.mdiVideo2d,
  'video-3-d': I.mdiVideo3d,
  'video-3-d-off': I.mdiVideo3dOff,
  'video-3-d-variant': I.mdiVideo3dVariant,
  'video-4-k-box': I.mdiVideo4kBox,
  'video-account': I.mdiVideoAccount,
  'video-box': I.mdiVideoBox,
  'video-box-off': I.mdiVideoBoxOff,
  'video-check': I.mdiVideoCheck,
  'video-check-outline': I.mdiVideoCheckOutline,
  'video-high-definition': I.mdiVideoHighDefinition,
  'video-image': I.mdiVideoImage,
  'video-input-antenna': I.mdiVideoInputAntenna,
  'video-input-component': I.mdiVideoInputComponent,
  'video-input-hdmi': I.mdiVideoInputHdmi,
  'video-input-scart': I.mdiVideoInputScart,
  'video-input-svideo': I.mdiVideoInputSvideo,
  'video-marker': I.mdiVideoMarker,
  'video-marker-outline': I.mdiVideoMarkerOutline,
  'video-minus': I.mdiVideoMinus,
  'video-minus-outline': I.mdiVideoMinusOutline,
  'video-off': I.mdiVideoOff,
  'video-off-outline': I.mdiVideoOffOutline,
  'video-outline': I.mdiVideoOutline,
  'video-plus': I.mdiVideoPlus,
  'video-plus-outline': I.mdiVideoPlusOutline,
  'video-stabilization': I.mdiVideoStabilization,
  'video-switch': I.mdiVideoSwitch,
  'video-switch-outline': I.mdiVideoSwitchOutline,
  'video-vintage': I.mdiVideoVintage,
  'video-wireless': I.mdiVideoWireless,
  'video-wireless-outline': I.mdiVideoWirelessOutline,
  'view-agenda': I.mdiViewAgenda,
  'view-agenda-outline': I.mdiViewAgendaOutline,
  'view-array': I.mdiViewArray,
  'view-array-outline': I.mdiViewArrayOutline,
  'view-carousel': I.mdiViewCarousel,
  'view-carousel-outline': I.mdiViewCarouselOutline,
  'view-column': I.mdiViewColumn,
  'view-column-outline': I.mdiViewColumnOutline,
  'view-comfy': I.mdiViewComfy,
  'view-comfy-outline': I.mdiViewComfyOutline,
  'view-compact': I.mdiViewCompact,
  'view-compact-outline': I.mdiViewCompactOutline,
  'view-dashboard': I.mdiViewDashboard,
  'view-dashboard-edit': I.mdiViewDashboardEdit,
  'view-dashboard-edit-outline': I.mdiViewDashboardEditOutline,
  'view-dashboard-outline': I.mdiViewDashboardOutline,
  'view-dashboard-variant': I.mdiViewDashboardVariant,
  'view-dashboard-variant-outline': I.mdiViewDashboardVariantOutline,
  'view-day': I.mdiViewDay,
  'view-day-outline': I.mdiViewDayOutline,
  'view-gallery': I.mdiViewGallery,
  'view-gallery-outline': I.mdiViewGalleryOutline,
  'view-grid': I.mdiViewGrid,
  'view-grid-outline': I.mdiViewGridOutline,
  'view-grid-plus': I.mdiViewGridPlus,
  'view-grid-plus-outline': I.mdiViewGridPlusOutline,
  'view-headline': I.mdiViewHeadline,
  'view-list': I.mdiViewList,
  'view-list-outline': I.mdiViewListOutline,
  'view-module': I.mdiViewModule,
  'view-module-outline': I.mdiViewModuleOutline,
  'view-parallel': I.mdiViewParallel,
  'view-parallel-outline': I.mdiViewParallelOutline,
  'view-quilt': I.mdiViewQuilt,
  'view-quilt-outline': I.mdiViewQuiltOutline,
  'view-sequential': I.mdiViewSequential,
  'view-sequential-outline': I.mdiViewSequentialOutline,
  'view-split-horizontal': I.mdiViewSplitHorizontal,
  'view-split-vertical': I.mdiViewSplitVertical,
  'view-stream': I.mdiViewStream,
  'view-stream-outline': I.mdiViewStreamOutline,
  'view-week': I.mdiViewWeek,
  'view-week-outline': I.mdiViewWeekOutline,
  vimeo: I.mdiVimeo,
  violin: I.mdiViolin,
  'virtual-reality': I.mdiVirtualReality,
  virus: I.mdiVirus,
  'virus-off': I.mdiVirusOff,
  'virus-off-outline': I.mdiVirusOffOutline,
  'virus-outline': I.mdiVirusOutline,
  vlc: I.mdiVlc,
  voicemail: I.mdiVoicemail,
  volcano: I.mdiVolcano,
  'volcano-outline': I.mdiVolcanoOutline,
  volleyball: I.mdiVolleyball,
  'volume-equal': I.mdiVolumeEqual,
  'volume-high': I.mdiVolumeHigh,
  'volume-low': I.mdiVolumeLow,
  'volume-medium': I.mdiVolumeMedium,
  'volume-minus': I.mdiVolumeMinus,
  'volume-mute': I.mdiVolumeMute,
  'volume-off': I.mdiVolumeOff,
  'volume-plus': I.mdiVolumePlus,
  'volume-source': I.mdiVolumeSource,
  'volume-variant-off': I.mdiVolumeVariantOff,
  'volume-vibrate': I.mdiVolumeVibrate,
  vote: I.mdiVote,
  'vote-outline': I.mdiVoteOutline,
  vpn: I.mdiVpn,
  vuejs: I.mdiVuejs,
  vuetify: I.mdiVuetify,
  walk: I.mdiWalk,
  wall: I.mdiWall,
  'wall-fire': I.mdiWallFire,
  'wall-sconce': I.mdiWallSconce,
  'wall-sconce-flat': I.mdiWallSconceFlat,
  'wall-sconce-flat-outline': I.mdiWallSconceFlatOutline,
  'wall-sconce-flat-variant': I.mdiWallSconceFlatVariant,
  'wall-sconce-flat-variant-outline': I.mdiWallSconceFlatVariantOutline,
  'wall-sconce-outline': I.mdiWallSconceOutline,
  'wall-sconce-round': I.mdiWallSconceRound,
  'wall-sconce-round-outline': I.mdiWallSconceRoundOutline,
  'wall-sconce-round-variant': I.mdiWallSconceRoundVariant,
  'wall-sconce-round-variant-outline': I.mdiWallSconceRoundVariantOutline,
  wallet: I.mdiWallet,
  'wallet-giftcard': I.mdiWalletGiftcard,
  'wallet-membership': I.mdiWalletMembership,
  'wallet-outline': I.mdiWalletOutline,
  'wallet-plus': I.mdiWalletPlus,
  'wallet-plus-outline': I.mdiWalletPlusOutline,
  'wallet-travel': I.mdiWalletTravel,
  wallpaper: I.mdiWallpaper,
  wan: I.mdiWan,
  wardrobe: I.mdiWardrobe,
  'wardrobe-outline': I.mdiWardrobeOutline,
  warehouse: I.mdiWarehouse,
  'washing-machine': I.mdiWashingMachine,
  'washing-machine-alert': I.mdiWashingMachineAlert,
  'washing-machine-off': I.mdiWashingMachineOff,
  watch: I.mdiWatch,
  'watch-export': I.mdiWatchExport,
  'watch-export-variant': I.mdiWatchExportVariant,
  'watch-import': I.mdiWatchImport,
  'watch-import-variant': I.mdiWatchImportVariant,
  'watch-variant': I.mdiWatchVariant,
  'watch-vibrate': I.mdiWatchVibrate,
  'watch-vibrate-off': I.mdiWatchVibrateOff,
  water: I.mdiWater,
  'water-alert': I.mdiWaterAlert,
  'water-alert-outline': I.mdiWaterAlertOutline,
  'water-boiler': I.mdiWaterBoiler,
  'water-boiler-alert': I.mdiWaterBoilerAlert,
  'water-boiler-auto': I.mdiWaterBoilerAuto,
  'water-boiler-off': I.mdiWaterBoilerOff,
  'water-check': I.mdiWaterCheck,
  'water-check-outline': I.mdiWaterCheckOutline,
  'water-circle': I.mdiWaterCircle,
  'water-minus': I.mdiWaterMinus,
  'water-minus-outline': I.mdiWaterMinusOutline,
  'water-off': I.mdiWaterOff,
  'water-off-outline': I.mdiWaterOffOutline,
  'water-opacity': I.mdiWaterOpacity,
  'water-outline': I.mdiWaterOutline,
  'water-percent': I.mdiWaterPercent,
  'water-percent-alert': I.mdiWaterPercentAlert,
  'water-plus': I.mdiWaterPlus,
  'water-plus-outline': I.mdiWaterPlusOutline,
  'water-polo': I.mdiWaterPolo,
  'water-pump': I.mdiWaterPump,
  'water-pump-off': I.mdiWaterPumpOff,
  'water-remove': I.mdiWaterRemove,
  'water-remove-outline': I.mdiWaterRemoveOutline,
  'water-sync': I.mdiWaterSync,
  'water-thermometer': I.mdiWaterThermometer,
  'water-thermometer-outline': I.mdiWaterThermometerOutline,
  'water-well': I.mdiWaterWell,
  'water-well-outline': I.mdiWaterWellOutline,
  waterfall: I.mdiWaterfall,
  'watering-can': I.mdiWateringCan,
  'watering-can-outline': I.mdiWateringCanOutline,
  watermark: I.mdiWatermark,
  wave: I.mdiWave,
  waveform: I.mdiWaveform,
  waves: I.mdiWaves,
  'waves-arrow-left': I.mdiWavesArrowLeft,
  'waves-arrow-right': I.mdiWavesArrowRight,
  'waves-arrow-up': I.mdiWavesArrowUp,
  waze: I.mdiWaze,
  'weather-cloudy': I.mdiWeatherCloudy,
  'weather-cloudy-alert': I.mdiWeatherCloudyAlert,
  'weather-cloudy-arrow-right': I.mdiWeatherCloudyArrowRight,
  'weather-cloudy-clock': I.mdiWeatherCloudyClock,
  'weather-dust': I.mdiWeatherDust,
  'weather-fog': I.mdiWeatherFog,
  'weather-hail': I.mdiWeatherHail,
  'weather-hazy': I.mdiWeatherHazy,
  'weather-hurricane': I.mdiWeatherHurricane,
  'weather-lightning': I.mdiWeatherLightning,
  'weather-lightning-rainy': I.mdiWeatherLightningRainy,
  'weather-night': I.mdiWeatherNight,
  'weather-night-partly-cloudy': I.mdiWeatherNightPartlyCloudy,
  'weather-partly-cloudy': I.mdiWeatherPartlyCloudy,
  'weather-partly-lightning': I.mdiWeatherPartlyLightning,
  'weather-partly-rainy': I.mdiWeatherPartlyRainy,
  'weather-partly-snowy': I.mdiWeatherPartlySnowy,
  'weather-partly-snowy-rainy': I.mdiWeatherPartlySnowyRainy,
  'weather-pouring': I.mdiWeatherPouring,
  'weather-rainy': I.mdiWeatherRainy,
  'weather-snowy': I.mdiWeatherSnowy,
  'weather-snowy-heavy': I.mdiWeatherSnowyHeavy,
  'weather-snowy-rainy': I.mdiWeatherSnowyRainy,
  'weather-sunny': I.mdiWeatherSunny,
  'weather-sunny-alert': I.mdiWeatherSunnyAlert,
  'weather-sunny-off': I.mdiWeatherSunnyOff,
  'weather-sunset': I.mdiWeatherSunset,
  'weather-sunset-down': I.mdiWeatherSunsetDown,
  'weather-sunset-up': I.mdiWeatherSunsetUp,
  'weather-tornado': I.mdiWeatherTornado,
  'weather-windy': I.mdiWeatherWindy,
  'weather-windy-variant': I.mdiWeatherWindyVariant,
  web: I.mdiWeb,
  'web-box': I.mdiWebBox,
  'web-cancel': I.mdiWebCancel,
  'web-check': I.mdiWebCheck,
  'web-clock': I.mdiWebClock,
  'web-minus': I.mdiWebMinus,
  'web-off': I.mdiWebOff,
  'web-plus': I.mdiWebPlus,
  'web-refresh': I.mdiWebRefresh,
  'web-remove': I.mdiWebRemove,
  'web-sync': I.mdiWebSync,
  webcam: I.mdiWebcam,
  'webcam-off': I.mdiWebcamOff,
  webhook: I.mdiWebhook,
  webpack: I.mdiWebpack,
  webrtc: I.mdiWebrtc,
  wechat: I.mdiWechat,
  weight: I.mdiWeight,
  'weight-gram': I.mdiWeightGram,
  'weight-kilogram': I.mdiWeightKilogram,
  'weight-lifter': I.mdiWeightLifter,
  'weight-pound': I.mdiWeightPound,
  whatsapp: I.mdiWhatsapp,
  'wheel-barrow': I.mdiWheelBarrow,
  wheelchair: I.mdiWheelchair,
  'wheelchair-accessibility': I.mdiWheelchairAccessibility,
  whistle: I.mdiWhistle,
  'whistle-outline': I.mdiWhistleOutline,
  'white-balance-auto': I.mdiWhiteBalanceAuto,
  'white-balance-incandescent': I.mdiWhiteBalanceIncandescent,
  'white-balance-iridescent': I.mdiWhiteBalanceIridescent,
  'white-balance-sunny': I.mdiWhiteBalanceSunny,
  widgets: I.mdiWidgets,
  'widgets-outline': I.mdiWidgetsOutline,
  wifi: I.mdiWifi,
  'wifi-alert': I.mdiWifiAlert,
  'wifi-arrow-down': I.mdiWifiArrowDown,
  'wifi-arrow-left': I.mdiWifiArrowLeft,
  'wifi-arrow-left-right': I.mdiWifiArrowLeftRight,
  'wifi-arrow-right': I.mdiWifiArrowRight,
  'wifi-arrow-up': I.mdiWifiArrowUp,
  'wifi-arrow-up-down': I.mdiWifiArrowUpDown,
  'wifi-cancel': I.mdiWifiCancel,
  'wifi-check': I.mdiWifiCheck,
  'wifi-cog': I.mdiWifiCog,
  'wifi-lock': I.mdiWifiLock,
  'wifi-lock-open': I.mdiWifiLockOpen,
  'wifi-marker': I.mdiWifiMarker,
  'wifi-minus': I.mdiWifiMinus,
  'wifi-off': I.mdiWifiOff,
  'wifi-plus': I.mdiWifiPlus,
  'wifi-refresh': I.mdiWifiRefresh,
  'wifi-remove': I.mdiWifiRemove,
  'wifi-settings': I.mdiWifiSettings,
  'wifi-star': I.mdiWifiStar,
  'wifi-strength-1': I.mdiWifiStrength1,
  'wifi-strength-1-alert': I.mdiWifiStrength1Alert,
  'wifi-strength-1-lock': I.mdiWifiStrength1Lock,
  'wifi-strength-1-lock-open': I.mdiWifiStrength1LockOpen,
  'wifi-strength-2': I.mdiWifiStrength2,
  'wifi-strength-2-alert': I.mdiWifiStrength2Alert,
  'wifi-strength-2-lock': I.mdiWifiStrength2Lock,
  'wifi-strength-2-lock-open': I.mdiWifiStrength2LockOpen,
  'wifi-strength-3': I.mdiWifiStrength3,
  'wifi-strength-3-alert': I.mdiWifiStrength3Alert,
  'wifi-strength-3-lock': I.mdiWifiStrength3Lock,
  'wifi-strength-3-lock-open': I.mdiWifiStrength3LockOpen,
  'wifi-strength-4': I.mdiWifiStrength4,
  'wifi-strength-4-alert': I.mdiWifiStrength4Alert,
  'wifi-strength-4-lock': I.mdiWifiStrength4Lock,
  'wifi-strength-4-lock-open': I.mdiWifiStrength4LockOpen,
  'wifi-strength-alert-outline': I.mdiWifiStrengthAlertOutline,
  'wifi-strength-lock-open-outline': I.mdiWifiStrengthLockOpenOutline,
  'wifi-strength-lock-outline': I.mdiWifiStrengthLockOutline,
  'wifi-strength-off': I.mdiWifiStrengthOff,
  'wifi-strength-off-outline': I.mdiWifiStrengthOffOutline,
  'wifi-strength-outline': I.mdiWifiStrengthOutline,
  'wifi-sync': I.mdiWifiSync,
  wikipedia: I.mdiWikipedia,
  'wind-power': I.mdiWindPower,
  'wind-power-outline': I.mdiWindPowerOutline,
  'wind-turbine': I.mdiWindTurbine,
  'wind-turbine-alert': I.mdiWindTurbineAlert,
  'wind-turbine-check': I.mdiWindTurbineCheck,
  'window-close': I.mdiWindowClose,
  'window-closed': I.mdiWindowClosed,
  'window-closed-variant': I.mdiWindowClosedVariant,
  'window-maximize': I.mdiWindowMaximize,
  'window-minimize': I.mdiWindowMinimize,
  'window-open': I.mdiWindowOpen,
  'window-open-variant': I.mdiWindowOpenVariant,
  'window-restore': I.mdiWindowRestore,
  'window-shutter': I.mdiWindowShutter,
  'window-shutter-alert': I.mdiWindowShutterAlert,
  'window-shutter-auto': I.mdiWindowShutterAuto,
  'window-shutter-cog': I.mdiWindowShutterCog,
  'window-shutter-open': I.mdiWindowShutterOpen,
  'window-shutter-settings': I.mdiWindowShutterSettings,
  windsock: I.mdiWindsock,
  wiper: I.mdiWiper,
  'wiper-wash': I.mdiWiperWash,
  'wiper-wash-alert': I.mdiWiperWashAlert,
  'wizard-hat': I.mdiWizardHat,
  wordpress: I.mdiWordpress,
  wrap: I.mdiWrap,
  'wrap-disabled': I.mdiWrapDisabled,
  wrench: I.mdiWrench,
  'wrench-check': I.mdiWrenchCheck,
  'wrench-check-outline': I.mdiWrenchCheckOutline,
  'wrench-clock': I.mdiWrenchClock,
  'wrench-clock-outline': I.mdiWrenchClockOutline,
  'wrench-cog': I.mdiWrenchCog,
  'wrench-cog-outline': I.mdiWrenchCogOutline,
  'wrench-outline': I.mdiWrenchOutline,
  xamarin: I.mdiXamarin,
  xml: I.mdiXml,
  xmpp: I.mdiXmpp,
  yahoo: I.mdiYahoo,
  yeast: I.mdiYeast,
  'yin-yang': I.mdiYinYang,
  yoga: I.mdiYoga,
  youtube: I.mdiYoutube,
  'youtube-gaming': I.mdiYoutubeGaming,
  'youtube-studio': I.mdiYoutubeStudio,
  'youtube-subscription': I.mdiYoutubeSubscription,
  'youtube-tv': I.mdiYoutubeTv,
  yurt: I.mdiYurt,
  'z-wave': I.mdiZWave,
  zend: I.mdiZend,
  zigbee: I.mdiZigbee,
  'zip-box': I.mdiZipBox,
  'zip-box-outline': I.mdiZipBoxOutline,
  'zip-disk': I.mdiZipDisk,
  'zodiac-aquarius': I.mdiZodiacAquarius,
  'zodiac-aries': I.mdiZodiacAries,
  'zodiac-cancer': I.mdiZodiacCancer,
  'zodiac-capricorn': I.mdiZodiacCapricorn,
  'zodiac-gemini': I.mdiZodiacGemini,
  'zodiac-leo': I.mdiZodiacLeo,
  'zodiac-libra': I.mdiZodiacLibra,
  'zodiac-pisces': I.mdiZodiacPisces,
  'zodiac-sagittarius': I.mdiZodiacSagittarius,
  'zodiac-scorpio': I.mdiZodiacScorpio,
  'zodiac-taurus': I.mdiZodiacTaurus,
  'zodiac-virgo': I.mdiZodiacVirgo,
};

export type IconName = keyof typeof icon;
